// Generated from ./util_cohort_builder_grammar/stable/SubjectsVariables.g4 by ANTLR 4.13.1

import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";

import { SubjectsVariablesListener } from "./SubjectsVariablesListener.js";
import { SubjectsVariablesVisitor } from "./SubjectsVariablesVisitor.js";

// for running tests with parameters, TODO: discuss strategy for typed parameters in CI
// eslint-disable-next-line no-unused-vars
type int = number;


export class SubjectsVariables extends antlr.Parser {
    public static readonly INDEX_DATE = 1;
    public static readonly EVENT = 2;
    public static readonly CALENDAR_DATE = 3;
    public static readonly UPPER_DATE_BOUND = 4;
    public static readonly LOWER_DATE_BOUND = 5;
    public static readonly DERIVED_EVENT_DATE = 6;
    public static readonly CONSTRAINTS = 7;
    public static readonly ANY_ORDER = 8;
    public static readonly IS_EVENT_DATE = 9;
    public static readonly TC = 10;
    public static readonly TEMPORAL_CONSTRAINT_ABBR = 11;
    public static readonly TEMPORAL_CONSTRAINT = 12;
    public static readonly POSITION = 13;
    public static readonly CF = 14;
    public static readonly CONCEPT_FILTER = 15;
    public static readonly CONCEPT_FILTER_ABBR = 16;
    public static readonly NF = 17;
    public static readonly NUMERIC_FILTER = 18;
    public static readonly NUMERIC_FILTER_ABBR = 19;
    public static readonly SF = 20;
    public static readonly STRING_FILTER = 21;
    public static readonly STRING_FILTER_ABBR = 22;
    public static readonly UF = 23;
    public static readonly UNIQUENESS_FILTER = 24;
    public static readonly UNIQUENESS_FILTER_ABBR = 25;
    public static readonly RF = 26;
    public static readonly RELATED_ENTITY_FILTER = 27;
    public static readonly RELATED_ENTITY_FILTER_ABBR = 28;
    public static readonly QUALIFIED_CARE_SITE_ALIAS = 29;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE_ALIAS = 30;
    public static readonly QUALIFIED_DRUG_EXPOSURE_ALIAS = 31;
    public static readonly QUALIFIED_MEASUREMENT_ALIAS = 32;
    public static readonly QUALIFIED_OBSERVATION_ALIAS = 33;
    public static readonly QUALIFIED_PERSON_ALIAS = 34;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS = 35;
    public static readonly QUALIFIED_PROVIDER_ALIAS = 36;
    public static readonly QUALIFIED_VISIT_OCCURRENCE_ALIAS = 37;
    public static readonly QUALIFIED_DERIVED_EVENT_NAME = 38;
    public static readonly SUBJECT_VARIABLE_CARE_SITE_ALIAS = 39;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS = 40;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS = 41;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT_ALIAS = 42;
    public static readonly SUBJECT_VARIABLE_OBSERVATION_ALIAS = 43;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS = 44;
    public static readonly SUBJECT_VARIABLE_PROVIDER_ALIAS = 45;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS = 46;
    public static readonly SUBJECT_VARIABLE_DERIVED_EVENT_NAME = 47;
    public static readonly CONCEPT_GROUP = 48;
    public static readonly CARE_SITE_ALIAS = 49;
    public static readonly CONDITION_OCCURRENCE_ALIAS = 50;
    public static readonly DRUG_EXPOSURE_ALIAS = 51;
    public static readonly MEASUREMENT_ALIAS = 52;
    public static readonly OBSERVATION_ALIAS = 53;
    public static readonly PERSON_ALIAS = 54;
    public static readonly PROCEDURE_OCCURRENCE_ALIAS = 55;
    public static readonly PROVIDER_ALIAS = 56;
    public static readonly VISIT_OCCURRENCE_ALIAS = 57;
    public static readonly MERGED_EVENT_NAME = 58;
    public static readonly SEQUENCE_EVENT_NAME = 59;
    public static readonly INSTANCE_EVENT_NAME = 60;
    public static readonly SUBJECTS_VARIABLE_NAME = 61;
    public static readonly NAMESPACE_QUALIFIER = 62;
    public static readonly SUBJECTS_VARIABLE = 63;
    public static readonly CONCEPT = 64;
    public static readonly QUALIFIED_MERGED_EVENT = 65;
    public static readonly QUALIFIED_SEQUENCE_EVENT = 66;
    public static readonly QUALIFIED_INSTANCE_EVENT = 67;
    public static readonly SUBJECT_VARIABLE_MERGED_EVENT = 68;
    public static readonly SUBJECT_VARIABLE_SEQUENCE_EVENT = 69;
    public static readonly SUBJECT_VARIABLE_INSTANCE_EVENT = 70;
    public static readonly MERGED_EVENT = 71;
    public static readonly SEQUENCE_EVENT = 72;
    public static readonly INSTANCE_EVENT = 73;
    public static readonly DERIVED_EVENT = 74;
    public static readonly LINE_COMMENT = 75;
    public static readonly INT = 76;
    public static readonly M = 77;
    public static readonly D = 78;
    public static readonly Y = 79;
    public static readonly DATE = 80;
    public static readonly OPEN_PAREN = 81;
    public static readonly CLOSE_PAREN = 82;
    public static readonly SEMICOLON = 83;
    public static readonly COMMA = 84;
    public static readonly EQ = 85;
    public static readonly MULTIPLY = 86;
    public static readonly DIVIDE = 87;
    public static readonly ADD = 88;
    public static readonly SUBTRACT = 89;
    public static readonly CONTAINS = 90;
    public static readonly NEQ = 91;
    public static readonly LTE = 92;
    public static readonly GTE = 93;
    public static readonly LT = 94;
    public static readonly GT = 95;
    public static readonly MAX = 96;
    public static readonly MIN = 97;
    public static readonly AVG = 98;
    public static readonly COUNT = 99;
    public static readonly LEAST = 100;
    public static readonly GREATEST = 101;
    public static readonly IN = 102;
    public static readonly AND = 103;
    public static readonly OR = 104;
    public static readonly NOT = 105;
    public static readonly COMPLEMENT = 106;
    public static readonly UNION = 107;
    public static readonly INTERSECTION = 108;
    public static readonly DIFFERENCE = 109;
    public static readonly INDEX = 110;
    public static readonly TIME_UNIT = 111;
    public static readonly DAYS = 112;
    public static readonly WEEKS = 113;
    public static readonly MONTHS = 114;
    public static readonly YEARS = 115;
    public static readonly MINIMUM_BETWEEN = 116;
    public static readonly MAXIMUM_BETWEEN = 117;
    public static readonly TOTAL_BETWEEN = 118;
    public static readonly FIXED_WINDOW = 119;
    public static readonly ROLLING_WINDOW = 120;
    public static readonly PERIOD = 121;
    public static readonly WS = 122;
    public static readonly CARE_SITE = 123;
    public static readonly CONDITION_OCCURRENCE = 124;
    public static readonly DRUG_EXPOSURE = 125;
    public static readonly MEASUREMENT = 126;
    public static readonly OBSERVATION = 127;
    public static readonly PERSON = 128;
    public static readonly PROCEDURE_OCCURRENCE = 129;
    public static readonly PROVIDER = 130;
    public static readonly VISIT_OCCURRENCE = 131;
    public static readonly QUALIFIED_CARE_SITE = 132;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE = 133;
    public static readonly QUALIFIED_DRUG_EXPOSURE = 134;
    public static readonly QUALIFIED_MEASUREMENT = 135;
    public static readonly QUALIFIED_OBSERVATION = 136;
    public static readonly QUALIFIED_PERSON = 137;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE = 138;
    public static readonly QUALIFIED_PROVIDER = 139;
    public static readonly QUALIFIED_VISIT_OCCURRENCE = 140;
    public static readonly SUBJECT_VARIABLE_CARE_SITE = 141;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE = 142;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE = 143;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT = 144;
    public static readonly SUBJECT_VARIABLE_OBSERVATION = 145;
    public static readonly SUBJECT_VARIABLE_PERSON = 146;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE = 147;
    public static readonly SUBJECT_VARIABLE_PROVIDER = 148;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE = 149;
    public static readonly CONDITION_OCCURRENCE_DATE_ATTRIBUTE = 150;
    public static readonly DRUG_EXPOSURE_DATE_ATTRIBUTE = 151;
    public static readonly MEASUREMENT_DATE_ATTRIBUTE = 152;
    public static readonly OBSERVATION_DATE_ATTRIBUTE = 153;
    public static readonly PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE = 154;
    public static readonly VISIT_OCCURRENCE_DATE_ATTRIBUTE = 155;
    public static readonly PERSON_DATE_TIME_ATTRIBUTE = 156;
    public static readonly DRUG_EXPOSURE_INT_ATTRIBUTE = 157;
    public static readonly MEASUREMENT_FLOAT_ATTRIBUTE = 158;
    public static readonly PERSON_INT_ATTRIBUTE = 159;
    public static readonly COMMON_NUMERIC_FLOAT_ATTRIBUTE = 160;
    public static readonly QUANTITY = 161;
    public static readonly CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE = 162;
    public static readonly DRUG_EXPOSURE_CONCEPT_ATTRIBUTE = 163;
    public static readonly MEASUREMENT_CONCEPT_ATTRIBUTE = 164;
    public static readonly OBSERVATION_CONCEPT_ATTRIBUTE = 165;
    public static readonly PERSON_CONCEPT_ATTRIBUTE = 166;
    public static readonly PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE = 167;
    public static readonly PROVIDER_CONCEPT_ATTRIBUTE = 168;
    public static readonly VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE = 169;
    public static readonly COMMON_CONCEPT_ATTRIBUTE = 170;
    public static readonly CARE_SITE_CONCEPT_ATTRIBUTE = 171;
    public static readonly COMMON_STRING_ATTRIBUTE = 172;
    public static readonly GENDER_SOURCE_VALUE = 173;
    public static readonly CARE_SITE_STRING_ATTRIBUTE = 174;
    public static readonly CONDITION_OCCURRENCE_STRING_ATTRIBUTE = 175;
    public static readonly DRUG_EXPOSURE_STRING_ATTRIBUTE = 176;
    public static readonly MEASUREMENT_STRING_ATTRIBUTE = 177;
    public static readonly OBSERVATION_STRING_ATTRIBUTE = 178;
    public static readonly PERSON_STRING_ATTRIBUTE = 179;
    public static readonly PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE = 180;
    public static readonly PROVIDER_STRING_ATTRIBUTE = 181;
    public static readonly VISIT_OCCURRENCE_STRING_ATTRIBUTE = 182;
    public static readonly RULE_subjects_variable = 0;
    public static readonly RULE_event_count_criteria = 1;
    public static readonly RULE_count_criteria = 2;
    public static readonly RULE_event_count_criteria_error = 3;
    public static readonly RULE_demographic_event_criteria = 4;
    public static readonly RULE_demographic_event_filters = 5;
    public static readonly RULE_demographic_event_filter = 6;
    public static readonly RULE_demographic_concept_filter = 7;
    public static readonly RULE_demographic_concept_group_filter = 8;
    public static readonly RULE_demographic_concept_id_filter = 9;
    public static readonly RULE_demographic_numeric_filter = 10;
    public static readonly RULE_demographic_int_filter = 11;
    public static readonly RULE_demographic_error_filter = 12;
    public static readonly RULE_subject_variable_event_name = 13;
    public static readonly RULE_index_date = 14;
    public static readonly RULE_index_date_definition = 15;
    public static readonly RULE_calendar_date = 16;
    public static readonly RULE_index_event_date = 17;
    public static readonly RULE_index_date_bounds = 18;
    public static readonly RULE_upper_date_bounds = 19;
    public static readonly RULE_lower_date_bounds = 20;
    public static readonly RULE_calendarError = 21;
    public static readonly RULE_index_event_date_error = 22;
    public static readonly RULE_lower_date_bounds_error = 23;
    public static readonly RULE_upper_date_bounds_error = 24;
    public static readonly RULE_derived_event = 25;
    public static readonly RULE_merged_event = 26;
    public static readonly RULE_merged_event_criteria = 27;
    public static readonly RULE_merged_event_criterion = 28;
    public static readonly RULE_merged_event_filter_criterion = 29;
    public static readonly RULE_merged_event_event = 30;
    public static readonly RULE_merged_event_filter = 31;
    public static readonly RULE_merged_event_uniqueness_filter = 32;
    public static readonly RULE_merged_event_uniqueness_filter_criteria = 33;
    public static readonly RULE_merged_event_filter_error = 34;
    public static readonly RULE_sequence_event = 35;
    public static readonly RULE_sequence_event_criteria = 36;
    public static readonly RULE_sequence_event_criterion = 37;
    public static readonly RULE_sequence_event_constraint = 38;
    public static readonly RULE_temporal_constraint = 39;
    public static readonly RULE_sequence_temporal_filter = 40;
    public static readonly RULE_sequence_event_event = 41;
    public static readonly RULE_selected_sequence_event = 42;
    public static readonly RULE_unselected_sequence_event = 43;
    public static readonly RULE_instance_event = 44;
    public static readonly RULE_instance_event_criteria = 45;
    public static readonly RULE_instance_event_criterion = 46;
    public static readonly RULE_instance_event_event = 47;
    public static readonly RULE_instance_event_position = 48;
    public static readonly RULE_aggregation_qualified = 49;
    public static readonly RULE_specific_instance = 50;
    public static readonly RULE_instance_event_position_error = 51;
    public static readonly RULE_qualified_simple_event = 52;
    public static readonly RULE_qualified_derived_event = 53;
    public static readonly RULE_sequence_event_constraint_error = 54;
    public static readonly RULE_derived_event_error = 55;
    public static readonly RULE_derived_uniqueness_filter = 56;
    public static readonly RULE_derived_uniqueness_filter_window = 57;
    public static readonly RULE_derived_fixed_window_uniqueness_filter = 58;
    public static readonly RULE_derived_rolling_window_uniqueness_filter = 59;
    public static readonly RULE_derived_event_int = 60;
    public static readonly RULE_simple_event = 61;
    public static readonly RULE_condition_occurrence_event = 62;
    public static readonly RULE_drug_exposure_event = 63;
    public static readonly RULE_measurement_event = 64;
    public static readonly RULE_observation_event = 65;
    public static readonly RULE_procedure_occurrence_event = 66;
    public static readonly RULE_visit_occurrence_event = 67;
    public static readonly RULE_condition_occurrence_event_definition = 68;
    public static readonly RULE_drug_exposure_event_definition = 69;
    public static readonly RULE_measurement_event_definition = 70;
    public static readonly RULE_observation_event_definition = 71;
    public static readonly RULE_procedure_occurrence_event_definition = 72;
    public static readonly RULE_visit_occurrence_event_definition = 73;
    public static readonly RULE_condition_occurrence_event_criteria = 74;
    public static readonly RULE_condition_occurrence_event_filter = 75;
    public static readonly RULE_condition_occurrence_concept_filters = 76;
    public static readonly RULE_condition_occurrence_concept_group_filter = 77;
    public static readonly RULE_condition_occurrence_concept_filter = 78;
    public static readonly RULE_condition_occurrence_uniqueness_filters = 79;
    public static readonly RULE_condition_occurrence_uniqueness_filter = 80;
    public static readonly RULE_condition_occurrence_related_entity_filters = 81;
    public static readonly RULE_condition_occurrence_related_entity_filter = 82;
    public static readonly RULE_condition_occurrence_sub_filter = 83;
    public static readonly RULE_condition_occurrence_error_sub_filter = 84;
    public static readonly RULE_condition_occurrence_error_filter = 85;
    public static readonly RULE_drug_exposure_event_criteria = 86;
    public static readonly RULE_drug_exposure_event_filter = 87;
    public static readonly RULE_drug_exposure_concept_filters = 88;
    public static readonly RULE_drug_exposure_concept_group_filter = 89;
    public static readonly RULE_drug_exposure_concept_filter = 90;
    public static readonly RULE_drug_exposure_numeric_filters = 91;
    public static readonly RULE_drug_exposure_float_filter = 92;
    public static readonly RULE_drug_exposure_int_filter = 93;
    public static readonly RULE_drug_exposure_uniqueness_filters = 94;
    public static readonly RULE_drug_exposure_uniqueness_filter = 95;
    public static readonly RULE_drug_exposure_related_entity_filters = 96;
    public static readonly RULE_drug_exposure_related_entity_filter = 97;
    public static readonly RULE_drug_exposure_error_filter = 98;
    public static readonly RULE_measurement_event_criteria = 99;
    public static readonly RULE_measurement_event_filter = 100;
    public static readonly RULE_measurement_concept_filters = 101;
    public static readonly RULE_measurement_concept_group_filter = 102;
    public static readonly RULE_measurement_concept_filter = 103;
    public static readonly RULE_measurement_numeric_filters = 104;
    public static readonly RULE_measurement_float_filter = 105;
    public static readonly RULE_measurement_uniqueness_filters = 106;
    public static readonly RULE_measurement_uniqueness_filter = 107;
    public static readonly RULE_measurement_related_entity_filters = 108;
    public static readonly RULE_measurement_related_entity_filter = 109;
    public static readonly RULE_measurement_error_filter = 110;
    public static readonly RULE_observation_event_criteria = 111;
    public static readonly RULE_observation_event_filter = 112;
    public static readonly RULE_observation_concept_filters = 113;
    public static readonly RULE_observation_concept_group_filter = 114;
    public static readonly RULE_observation_concept_filter = 115;
    public static readonly RULE_observation_numeric_filters = 116;
    public static readonly RULE_observation_float_filter = 117;
    public static readonly RULE_observation_uniqueness_filters = 118;
    public static readonly RULE_observation_uniqueness_filter = 119;
    public static readonly RULE_observation_related_entity_filters = 120;
    public static readonly RULE_observation_related_entity_filter = 121;
    public static readonly RULE_observation_error_filter = 122;
    public static readonly RULE_procedure_occurrence_event_criteria = 123;
    public static readonly RULE_procedure_occurrence_event_filter = 124;
    public static readonly RULE_procedure_occurrence_concept_filters = 125;
    public static readonly RULE_procedure_occurrence_concept_group_filter = 126;
    public static readonly RULE_procedure_occurrence_concept_filter = 127;
    public static readonly RULE_procedure_occurrence_numeric_filters = 128;
    public static readonly RULE_procedure_occurrence_int_filter = 129;
    public static readonly RULE_procedure_occurrence_uniqueness_filters = 130;
    public static readonly RULE_procedure_occurrence_uniqueness_filter = 131;
    public static readonly RULE_procedure_occurrence_related_entity_filters = 132;
    public static readonly RULE_procedure_occurrence_related_entity_filter = 133;
    public static readonly RULE_procedure_occurrence_error_filter = 134;
    public static readonly RULE_provider_concept_filters = 135;
    public static readonly RULE_provider_concept_group_filter = 136;
    public static readonly RULE_provider_concept_filter = 137;
    public static readonly RULE_provider_sub_filter = 138;
    public static readonly RULE_provider_error_sub_filter = 139;
    public static readonly RULE_visit_occurrence_event_criteria = 140;
    public static readonly RULE_visit_occurrence_event_filter = 141;
    public static readonly RULE_visit_occurrence_concept_filters = 142;
    public static readonly RULE_visit_occurrence_concept_group_filter = 143;
    public static readonly RULE_visit_occurrence_concept_filter = 144;
    public static readonly RULE_visit_occurrence_uniqueness_filters = 145;
    public static readonly RULE_visit_occurrence_uniqueness_filter = 146;
    public static readonly RULE_visit_occurrence_related_entity_filters = 147;
    public static readonly RULE_visit_occurrence_related_entity_filter = 148;
    public static readonly RULE_visit_occurrence_sub_filter = 149;
    public static readonly RULE_visit_occurrence_error_sub_filter = 150;
    public static readonly RULE_visit_occurrence_error_filter = 151;
    public static readonly RULE_comparison_op = 152;
    public static readonly RULE_simple_uniqueness_filter = 153;
    public static readonly RULE_simple_uniqueness_filter_window = 154;
    public static readonly RULE_fixed_window_uniqueness_filter = 155;
    public static readonly RULE_rolling_window_uniqueness_filter = 156;
    public static readonly RULE_simple_event_float = 157;
    public static readonly RULE_simple_event_int = 158;
    public static readonly RULE_concept_group_selection = 159;

    public static readonly literalNames = [
        null, "'INDEX_DATE'", "'EVENT'", "'CALENDAR_DATE'", "'UPPER_DATE_BOUND'", 
        "'LOWER_DATE_BOUND'", "'derived_event_date'", "'CONSTRAINTS'", "'ANY_ORDER'", 
        "'IS_EVENT_DATE'", null, "'TC'", "'TEMPORAL_CONSTRAINT'", "'POSITION'", 
        null, "'CONCEPT_FILTER'", "'CF'", null, "'NUMERIC_FILTER'", "'NF'", 
        null, "'STRING_FILTER'", "'SF'", null, "'UNIQUENESS_FILTER'", "'UF'", 
        null, "'RELATED_ENTITY_FILTER'", "'RF'", null, null, null, null, 
        null, null, null, null, null, null, null, null, null, null, null, 
        null, null, null, null, null, null, null, null, null, null, null, 
        null, null, null, null, null, null, null, "'::'", "'SUBJECTS_VARIABLE'", 
        null, "'QUALIFIED_MERGED_EVENT'", "'QUALIFIED_SEQUENCE_EVENT'", 
        "'QUALIFIED_INSTANCE_EVENT'", "'SUBJECT_VARIABLE_MERGED_EVENT'", 
        "'SUBJECT_VARIABLE_SEQUENCE_EVENT'", "'SUBJECT_VARIABLE_INSTANCE_EVENT'", 
        "'MERGED_EVENT'", "'SEQUENCE_EVENT'", "'INSTANCE_EVENT'", "'DERIVED_EVENT'", 
        null, null, null, null, null, null, "'('", "')'", "';'", "','", 
        "'='", "'*'", "'/'", "'+'", "'-'", "'CONTAINS'", "'!='", "'<='", 
        "'>='", "'<'", "'>'", "'MAX'", "'MIN'", "'AVG'", "'COUNT'", "'LEAST'", 
        "'GREATEST'", "'IN'", "'AND'", "'OR'", "'NOT'", "'COMPLEMENT'", 
        "'UNION'", "'INTERSECTION'", "'DIFFERENCE'", "'INDEX'", null, "'DAYS'", 
        "'WEEKS'", "'MONTHS'", "'YEARS'", "'MINIMUM_BETWEEN'", "'MAXIMUM_BETWEEN'", 
        "'TOTAL_BETWEEN'", "'FIXED_WINDOW'", "'ROLLING_WINDOW'", "'.'", 
        null, "'CARE_SITE'", "'CONDITION_OCCURRENCE'", "'DRUG_EXPOSURE'", 
        "'MEASUREMENT'", "'OBSERVATION'", "'PERSON'", "'PROCEDURE_OCCURRENCE'", 
        "'PROVIDER'", "'VISIT_OCCURRENCE'", "'QUALIFIED_CARE_SITE'", "'QUALIFIED_CONDITION_OCCURRENCE'", 
        "'QUALIFIED_DRUG_EXPOSURE'", "'QUALIFIED_MEASUREMENT'", "'QUALIFIED_OBSERVATION'", 
        "'QUALIFIED_PERSON'", "'QUALIFIED_PROCEDURE_OCCURRENCE'", "'QUALIFIED_PROVIDER'", 
        "'QUALIFIED_VISIT_OCCURRENCE'", "'SUBJECT_VARIABLE_CARE_SITE'", 
        "'SUBJECT_VARIABLE_CONDITION_OCCURRENCE'", "'SUBJECT_VARIABLE_DRUG_EXPOSURE'", 
        "'SUBJECT_VARIABLE_MEASUREMENT'", "'SUBJECT_VARIABLE_OBSERVATION'", 
        "'SUBJECT_VARIABLE_PERSON'", "'SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE'", 
        "'SUBJECT_VARIABLE_PROVIDER'", "'SUBJECT_VARIABLE_VISIT_OCCURRENCE'", 
        null, null, "'measurement_date'", "'observation_date'", "'procedure_date'", 
        null, "'birth_datetime'", null, null, null, "'value_as_number'", 
        "'quantity'", null, null, null, null, null, null, "'specialty_concept'", 
        null, null, "'place_of_service_concept'", "'value_as_string'", "'gender_source_value'"
    ];

    public static readonly symbolicNames = [
        null, "INDEX_DATE", "EVENT", "CALENDAR_DATE", "UPPER_DATE_BOUND", 
        "LOWER_DATE_BOUND", "DERIVED_EVENT_DATE", "CONSTRAINTS", "ANY_ORDER", 
        "IS_EVENT_DATE", "TC", "TEMPORAL_CONSTRAINT_ABBR", "TEMPORAL_CONSTRAINT", 
        "POSITION", "CF", "CONCEPT_FILTER", "CONCEPT_FILTER_ABBR", "NF", 
        "NUMERIC_FILTER", "NUMERIC_FILTER_ABBR", "SF", "STRING_FILTER", 
        "STRING_FILTER_ABBR", "UF", "UNIQUENESS_FILTER", "UNIQUENESS_FILTER_ABBR", 
        "RF", "RELATED_ENTITY_FILTER", "RELATED_ENTITY_FILTER_ABBR", "QUALIFIED_CARE_SITE_ALIAS", 
        "QUALIFIED_CONDITION_OCCURRENCE_ALIAS", "QUALIFIED_DRUG_EXPOSURE_ALIAS", 
        "QUALIFIED_MEASUREMENT_ALIAS", "QUALIFIED_OBSERVATION_ALIAS", "QUALIFIED_PERSON_ALIAS", 
        "QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS", "QUALIFIED_PROVIDER_ALIAS", 
        "QUALIFIED_VISIT_OCCURRENCE_ALIAS", "QUALIFIED_DERIVED_EVENT_NAME", 
        "SUBJECT_VARIABLE_CARE_SITE_ALIAS", "SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS", 
        "SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS", "SUBJECT_VARIABLE_MEASUREMENT_ALIAS", 
        "SUBJECT_VARIABLE_OBSERVATION_ALIAS", "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS", 
        "SUBJECT_VARIABLE_PROVIDER_ALIAS", "SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS", 
        "SUBJECT_VARIABLE_DERIVED_EVENT_NAME", "CONCEPT_GROUP", "CARE_SITE_ALIAS", 
        "CONDITION_OCCURRENCE_ALIAS", "DRUG_EXPOSURE_ALIAS", "MEASUREMENT_ALIAS", 
        "OBSERVATION_ALIAS", "PERSON_ALIAS", "PROCEDURE_OCCURRENCE_ALIAS", 
        "PROVIDER_ALIAS", "VISIT_OCCURRENCE_ALIAS", "MERGED_EVENT_NAME", 
        "SEQUENCE_EVENT_NAME", "INSTANCE_EVENT_NAME", "SUBJECTS_VARIABLE_NAME", 
        "NAMESPACE_QUALIFIER", "SUBJECTS_VARIABLE", "CONCEPT", "QUALIFIED_MERGED_EVENT", 
        "QUALIFIED_SEQUENCE_EVENT", "QUALIFIED_INSTANCE_EVENT", "SUBJECT_VARIABLE_MERGED_EVENT", 
        "SUBJECT_VARIABLE_SEQUENCE_EVENT", "SUBJECT_VARIABLE_INSTANCE_EVENT", 
        "MERGED_EVENT", "SEQUENCE_EVENT", "INSTANCE_EVENT", "DERIVED_EVENT", 
        "LINE_COMMENT", "INT", "M", "D", "Y", "DATE", "OPEN_PAREN", "CLOSE_PAREN", 
        "SEMICOLON", "COMMA", "EQ", "MULTIPLY", "DIVIDE", "ADD", "SUBTRACT", 
        "CONTAINS", "NEQ", "LTE", "GTE", "LT", "GT", "MAX", "MIN", "AVG", 
        "COUNT", "LEAST", "GREATEST", "IN", "AND", "OR", "NOT", "COMPLEMENT", 
        "UNION", "INTERSECTION", "DIFFERENCE", "INDEX", "TIME_UNIT", "DAYS", 
        "WEEKS", "MONTHS", "YEARS", "MINIMUM_BETWEEN", "MAXIMUM_BETWEEN", 
        "TOTAL_BETWEEN", "FIXED_WINDOW", "ROLLING_WINDOW", "PERIOD", "WS", 
        "CARE_SITE", "CONDITION_OCCURRENCE", "DRUG_EXPOSURE", "MEASUREMENT", 
        "OBSERVATION", "PERSON", "PROCEDURE_OCCURRENCE", "PROVIDER", "VISIT_OCCURRENCE", 
        "QUALIFIED_CARE_SITE", "QUALIFIED_CONDITION_OCCURRENCE", "QUALIFIED_DRUG_EXPOSURE", 
        "QUALIFIED_MEASUREMENT", "QUALIFIED_OBSERVATION", "QUALIFIED_PERSON", 
        "QUALIFIED_PROCEDURE_OCCURRENCE", "QUALIFIED_PROVIDER", "QUALIFIED_VISIT_OCCURRENCE", 
        "SUBJECT_VARIABLE_CARE_SITE", "SUBJECT_VARIABLE_CONDITION_OCCURRENCE", 
        "SUBJECT_VARIABLE_DRUG_EXPOSURE", "SUBJECT_VARIABLE_MEASUREMENT", 
        "SUBJECT_VARIABLE_OBSERVATION", "SUBJECT_VARIABLE_PERSON", "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE", 
        "SUBJECT_VARIABLE_PROVIDER", "SUBJECT_VARIABLE_VISIT_OCCURRENCE", 
        "CONDITION_OCCURRENCE_DATE_ATTRIBUTE", "DRUG_EXPOSURE_DATE_ATTRIBUTE", 
        "MEASUREMENT_DATE_ATTRIBUTE", "OBSERVATION_DATE_ATTRIBUTE", "PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE", 
        "VISIT_OCCURRENCE_DATE_ATTRIBUTE", "PERSON_DATE_TIME_ATTRIBUTE", 
        "DRUG_EXPOSURE_INT_ATTRIBUTE", "MEASUREMENT_FLOAT_ATTRIBUTE", "PERSON_INT_ATTRIBUTE", 
        "COMMON_NUMERIC_FLOAT_ATTRIBUTE", "QUANTITY", "CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "DRUG_EXPOSURE_CONCEPT_ATTRIBUTE", "MEASUREMENT_CONCEPT_ATTRIBUTE", 
        "OBSERVATION_CONCEPT_ATTRIBUTE", "PERSON_CONCEPT_ATTRIBUTE", "PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "PROVIDER_CONCEPT_ATTRIBUTE", "VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "COMMON_CONCEPT_ATTRIBUTE", "CARE_SITE_CONCEPT_ATTRIBUTE", "COMMON_STRING_ATTRIBUTE", 
        "GENDER_SOURCE_VALUE", "CARE_SITE_STRING_ATTRIBUTE", "CONDITION_OCCURRENCE_STRING_ATTRIBUTE", 
        "DRUG_EXPOSURE_STRING_ATTRIBUTE", "MEASUREMENT_STRING_ATTRIBUTE", 
        "OBSERVATION_STRING_ATTRIBUTE", "PERSON_STRING_ATTRIBUTE", "PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE", 
        "PROVIDER_STRING_ATTRIBUTE", "VISIT_OCCURRENCE_STRING_ATTRIBUTE"
    ];
    public static readonly ruleNames = [
        "subjects_variable", "event_count_criteria", "count_criteria", "event_count_criteria_error", 
        "demographic_event_criteria", "demographic_event_filters", "demographic_event_filter", 
        "demographic_concept_filter", "demographic_concept_group_filter", 
        "demographic_concept_id_filter", "demographic_numeric_filter", "demographic_int_filter", 
        "demographic_error_filter", "subject_variable_event_name", "index_date", 
        "index_date_definition", "calendar_date", "index_event_date", "index_date_bounds", 
        "upper_date_bounds", "lower_date_bounds", "calendarError", "index_event_date_error", 
        "lower_date_bounds_error", "upper_date_bounds_error", "derived_event", 
        "merged_event", "merged_event_criteria", "merged_event_criterion", 
        "merged_event_filter_criterion", "merged_event_event", "merged_event_filter", 
        "merged_event_uniqueness_filter", "merged_event_uniqueness_filter_criteria", 
        "merged_event_filter_error", "sequence_event", "sequence_event_criteria", 
        "sequence_event_criterion", "sequence_event_constraint", "temporal_constraint", 
        "sequence_temporal_filter", "sequence_event_event", "selected_sequence_event", 
        "unselected_sequence_event", "instance_event", "instance_event_criteria", 
        "instance_event_criterion", "instance_event_event", "instance_event_position", 
        "aggregation_qualified", "specific_instance", "instance_event_position_error", 
        "qualified_simple_event", "qualified_derived_event", "sequence_event_constraint_error", 
        "derived_event_error", "derived_uniqueness_filter", "derived_uniqueness_filter_window", 
        "derived_fixed_window_uniqueness_filter", "derived_rolling_window_uniqueness_filter", 
        "derived_event_int", "simple_event", "condition_occurrence_event", 
        "drug_exposure_event", "measurement_event", "observation_event", 
        "procedure_occurrence_event", "visit_occurrence_event", "condition_occurrence_event_definition", 
        "drug_exposure_event_definition", "measurement_event_definition", 
        "observation_event_definition", "procedure_occurrence_event_definition", 
        "visit_occurrence_event_definition", "condition_occurrence_event_criteria", 
        "condition_occurrence_event_filter", "condition_occurrence_concept_filters", 
        "condition_occurrence_concept_group_filter", "condition_occurrence_concept_filter", 
        "condition_occurrence_uniqueness_filters", "condition_occurrence_uniqueness_filter", 
        "condition_occurrence_related_entity_filters", "condition_occurrence_related_entity_filter", 
        "condition_occurrence_sub_filter", "condition_occurrence_error_sub_filter", 
        "condition_occurrence_error_filter", "drug_exposure_event_criteria", 
        "drug_exposure_event_filter", "drug_exposure_concept_filters", "drug_exposure_concept_group_filter", 
        "drug_exposure_concept_filter", "drug_exposure_numeric_filters", 
        "drug_exposure_float_filter", "drug_exposure_int_filter", "drug_exposure_uniqueness_filters", 
        "drug_exposure_uniqueness_filter", "drug_exposure_related_entity_filters", 
        "drug_exposure_related_entity_filter", "drug_exposure_error_filter", 
        "measurement_event_criteria", "measurement_event_filter", "measurement_concept_filters", 
        "measurement_concept_group_filter", "measurement_concept_filter", 
        "measurement_numeric_filters", "measurement_float_filter", "measurement_uniqueness_filters", 
        "measurement_uniqueness_filter", "measurement_related_entity_filters", 
        "measurement_related_entity_filter", "measurement_error_filter", 
        "observation_event_criteria", "observation_event_filter", "observation_concept_filters", 
        "observation_concept_group_filter", "observation_concept_filter", 
        "observation_numeric_filters", "observation_float_filter", "observation_uniqueness_filters", 
        "observation_uniqueness_filter", "observation_related_entity_filters", 
        "observation_related_entity_filter", "observation_error_filter", 
        "procedure_occurrence_event_criteria", "procedure_occurrence_event_filter", 
        "procedure_occurrence_concept_filters", "procedure_occurrence_concept_group_filter", 
        "procedure_occurrence_concept_filter", "procedure_occurrence_numeric_filters", 
        "procedure_occurrence_int_filter", "procedure_occurrence_uniqueness_filters", 
        "procedure_occurrence_uniqueness_filter", "procedure_occurrence_related_entity_filters", 
        "procedure_occurrence_related_entity_filter", "procedure_occurrence_error_filter", 
        "provider_concept_filters", "provider_concept_group_filter", "provider_concept_filter", 
        "provider_sub_filter", "provider_error_sub_filter", "visit_occurrence_event_criteria", 
        "visit_occurrence_event_filter", "visit_occurrence_concept_filters", 
        "visit_occurrence_concept_group_filter", "visit_occurrence_concept_filter", 
        "visit_occurrence_uniqueness_filters", "visit_occurrence_uniqueness_filter", 
        "visit_occurrence_related_entity_filters", "visit_occurrence_related_entity_filter", 
        "visit_occurrence_sub_filter", "visit_occurrence_error_sub_filter", 
        "visit_occurrence_error_filter", "comparison_op", "simple_uniqueness_filter", 
        "simple_uniqueness_filter_window", "fixed_window_uniqueness_filter", 
        "rolling_window_uniqueness_filter", "simple_event_float", "simple_event_int", 
        "concept_group_selection",
    ];

    public get grammarFileName(): string { return "SubjectsVariables.g4"; }
    public get literalNames(): (string | null)[] { return SubjectsVariables.literalNames; }
    public get symbolicNames(): (string | null)[] { return SubjectsVariables.symbolicNames; }
    public get ruleNames(): string[] { return SubjectsVariables.ruleNames; }
    public get serializedATN(): number[] { return SubjectsVariables._serializedATN; }

    protected createFailedPredicateException(predicate?: string, message?: string): antlr.FailedPredicateException {
        return new antlr.FailedPredicateException(this, predicate, message);
    }

    public constructor(input: antlr.TokenStream) {
        super(input);
        this.interpreter = new antlr.ParserATNSimulator(this, SubjectsVariables._ATN, SubjectsVariables.decisionsToDFA, new antlr.PredictionContextCache());
    }
    public subjects_variable(): Subjects_variableContext {
        let localContext = new Subjects_variableContext(this.context, this.state);
        this.enterRule(localContext, 0, SubjectsVariables.RULE_subjects_variable);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 320;
            this.match(SubjectsVariables.SUBJECTS_VARIABLE_NAME);
            this.state = 321;
            this.match(SubjectsVariables.EQ);
            this.state = 325;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 0, this.context) ) {
            case 1:
                {
                this.state = 322;
                this.demographic_event_criteria();
                }
                break;
            case 2:
                {
                this.state = 323;
                this.event_count_criteria();
                }
                break;
            case 3:
                {
                this.state = 324;
                this.event_count_criteria_error();
                }
                break;
            }
            this.state = 327;
            this.match(SubjectsVariables.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public event_count_criteria(): Event_count_criteriaContext {
        let localContext = new Event_count_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 2, SubjectsVariables.RULE_event_count_criteria);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 329;
            localContext._prefix = this.match(SubjectsVariables.COUNT);
            this.state = 330;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 331;
            localContext._criteria = this.count_criteria();
            this.state = 332;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public count_criteria(): Count_criteriaContext {
        let localContext = new Count_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 4, SubjectsVariables.RULE_count_criteria);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 334;
            this.subject_variable_event_name();
            this.state = 335;
            this.comparison_op();
            this.state = 336;
            this.match(SubjectsVariables.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public event_count_criteria_error(): Event_count_criteria_errorContext {
        let localContext = new Event_count_criteria_errorContext(this.context, this.state);
        this.enterRule(localContext, 6, SubjectsVariables.RULE_event_count_criteria_error);
        try {
            this.state = 352;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 1, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 338;
                this.match(SubjectsVariables.COUNT);
                this.state = 339;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 340;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 341;
                this.match(SubjectsVariables.COUNT);
                this.state = 342;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 343;
                this.subject_variable_event_name();
                this.state = 344;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 346;
                this.match(SubjectsVariables.COUNT);
                this.state = 347;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 348;
                this.subject_variable_event_name();
                this.state = 349;
                this.comparison_op();
                this.state = 350;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_event_criteria(): Demographic_event_criteriaContext {
        let localContext = new Demographic_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 8, SubjectsVariables.RULE_demographic_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 354;
            localContext._prefix = this.match(SubjectsVariables.PERSON);
            this.state = 355;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 357;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 14 || _la === 17) {
                {
                this.state = 356;
                this.demographic_event_filters();
                }
            }

            this.state = 359;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_event_filters(): Demographic_event_filtersContext {
        let localContext = new Demographic_event_filtersContext(this.context, this.state);
        this.enterRule(localContext, 10, SubjectsVariables.RULE_demographic_event_filters);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 361;
            this.demographic_event_filter();
            this.state = 366;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 362;
                this.match(SubjectsVariables.COMMA);
                this.state = 363;
                this.demographic_event_filter();
                }
                }
                this.state = 368;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_event_filter(): Demographic_event_filterContext {
        let localContext = new Demographic_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 12, SubjectsVariables.RULE_demographic_event_filter);
        try {
            this.state = 372;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 4, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 369;
                this.demographic_concept_filter();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 370;
                this.demographic_numeric_filter();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 371;
                this.demographic_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_concept_filter(): Demographic_concept_filterContext {
        let localContext = new Demographic_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 14, SubjectsVariables.RULE_demographic_concept_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 374;
            this.match(SubjectsVariables.CF);
            this.state = 375;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 378;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 5, this.context) ) {
            case 1:
                {
                this.state = 376;
                this.demographic_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 377;
                this.demographic_concept_id_filter();
                }
                break;
            }
            this.state = 380;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_concept_group_filter(): Demographic_concept_group_filterContext {
        let localContext = new Demographic_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 16, SubjectsVariables.RULE_demographic_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 382;
            this.match(SubjectsVariables.PERSON_CONCEPT_ATTRIBUTE);
            this.state = 383;
            this.match(SubjectsVariables.IN);
            this.state = 384;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_concept_id_filter(): Demographic_concept_id_filterContext {
        let localContext = new Demographic_concept_id_filterContext(this.context, this.state);
        this.enterRule(localContext, 18, SubjectsVariables.RULE_demographic_concept_id_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 386;
            this.match(SubjectsVariables.PERSON_CONCEPT_ATTRIBUTE);
            this.state = 387;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 85 || _la === 91)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 388;
            this.match(SubjectsVariables.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_numeric_filter(): Demographic_numeric_filterContext {
        let localContext = new Demographic_numeric_filterContext(this.context, this.state);
        this.enterRule(localContext, 20, SubjectsVariables.RULE_demographic_numeric_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 390;
            this.match(SubjectsVariables.NF);
            this.state = 391;
            this.match(SubjectsVariables.OPEN_PAREN);
            {
            this.state = 392;
            this.demographic_int_filter();
            }
            this.state = 393;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_int_filter(): Demographic_int_filterContext {
        let localContext = new Demographic_int_filterContext(this.context, this.state);
        this.enterRule(localContext, 22, SubjectsVariables.RULE_demographic_int_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 395;
            this.match(SubjectsVariables.PERSON_INT_ATTRIBUTE);
            this.state = 396;
            this.comparison_op();
            this.state = 397;
            this.match(SubjectsVariables.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_error_filter(): Demographic_error_filterContext {
        let localContext = new Demographic_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 24, SubjectsVariables.RULE_demographic_error_filter);
        try {
            this.state = 424;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 6, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 399;
                this.match(SubjectsVariables.CF);
                this.state = 400;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 401;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 402;
                this.match(SubjectsVariables.CF);
                this.state = 403;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 404;
                this.match(SubjectsVariables.PERSON_CONCEPT_ATTRIBUTE);
                this.state = 405;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 406;
                this.match(SubjectsVariables.CF);
                this.state = 407;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 408;
                this.match(SubjectsVariables.PERSON_CONCEPT_ATTRIBUTE);
                this.state = 409;
                this.match(SubjectsVariables.IN);
                this.state = 410;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 411;
                this.match(SubjectsVariables.NF);
                this.state = 412;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 413;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 414;
                this.match(SubjectsVariables.NF);
                this.state = 415;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 416;
                this.match(SubjectsVariables.PERSON_INT_ATTRIBUTE);
                this.state = 417;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 418;
                this.match(SubjectsVariables.NF);
                this.state = 419;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 420;
                this.match(SubjectsVariables.PERSON_INT_ATTRIBUTE);
                this.state = 421;
                this.comparison_op();
                this.state = 422;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public subject_variable_event_name(): Subject_variable_event_nameContext {
        let localContext = new Subject_variable_event_nameContext(this.context, this.state);
        this.enterRule(localContext, 26, SubjectsVariables.RULE_subject_variable_event_name);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 426;
            _la = this.tokenStream.LA(1);
            if(!(((((_la - 39)) & ~0x1F) === 0 && ((1 << (_la - 39)) & 511) !== 0))) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_date(): Index_dateContext {
        let localContext = new Index_dateContext(this.context, this.state);
        this.enterRule(localContext, 28, SubjectsVariables.RULE_index_date);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 428;
            this.match(SubjectsVariables.INDEX_DATE);
            this.state = 429;
            this.match(SubjectsVariables.EQ);
            this.state = 430;
            this.index_date_definition();
            this.state = 431;
            this.match(SubjectsVariables.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_date_definition(): Index_date_definitionContext {
        let localContext = new Index_date_definitionContext(this.context, this.state);
        this.enterRule(localContext, 30, SubjectsVariables.RULE_index_date_definition);
        try {
            this.state = 437;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 7, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 433;
                this.calendar_date();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 434;
                this.calendarError();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 435;
                this.index_event_date();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 436;
                this.index_event_date_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public calendar_date(): Calendar_dateContext {
        let localContext = new Calendar_dateContext(this.context, this.state);
        this.enterRule(localContext, 32, SubjectsVariables.RULE_calendar_date);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 439;
            localContext._index_date_type = this.match(SubjectsVariables.CALENDAR_DATE);
            this.state = 440;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 441;
            this.match(SubjectsVariables.DATE);
            this.state = 442;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_event_date(): Index_event_dateContext {
        let localContext = new Index_event_dateContext(this.context, this.state);
        this.enterRule(localContext, 34, SubjectsVariables.RULE_index_event_date);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 444;
            localContext._index_date_type = this.match(SubjectsVariables.EVENT);
            this.state = 445;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 446;
            localContext._date = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 60 || _la === 156)) {
                localContext._date = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 449;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 84) {
                {
                this.state = 447;
                this.match(SubjectsVariables.COMMA);
                this.state = 448;
                this.index_date_bounds();
                }
            }

            this.state = 451;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_date_bounds(): Index_date_boundsContext {
        let localContext = new Index_date_boundsContext(this.context, this.state);
        this.enterRule(localContext, 36, SubjectsVariables.RULE_index_date_bounds);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 455;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 9, this.context) ) {
            case 1:
                {
                this.state = 453;
                this.lower_date_bounds();
                }
                break;
            case 2:
                {
                this.state = 454;
                this.lower_date_bounds_error();
                }
                break;
            }
            this.state = 457;
            this.match(SubjectsVariables.COMMA);
            this.state = 460;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 10, this.context) ) {
            case 1:
                {
                this.state = 458;
                this.upper_date_bounds();
                }
                break;
            case 2:
                {
                this.state = 459;
                this.upper_date_bounds_error();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public upper_date_bounds(): Upper_date_boundsContext {
        let localContext = new Upper_date_boundsContext(this.context, this.state);
        this.enterRule(localContext, 38, SubjectsVariables.RULE_upper_date_bounds);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 462;
            this.match(SubjectsVariables.UPPER_DATE_BOUND);
            this.state = 463;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 464;
            this.match(SubjectsVariables.DATE);
            this.state = 465;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public lower_date_bounds(): Lower_date_boundsContext {
        let localContext = new Lower_date_boundsContext(this.context, this.state);
        this.enterRule(localContext, 40, SubjectsVariables.RULE_lower_date_bounds);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 467;
            this.match(SubjectsVariables.LOWER_DATE_BOUND);
            this.state = 468;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 469;
            this.match(SubjectsVariables.DATE);
            this.state = 470;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public calendarError(): CalendarErrorContext {
        let localContext = new CalendarErrorContext(this.context, this.state);
        this.enterRule(localContext, 42, SubjectsVariables.RULE_calendarError);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 472;
            this.match(SubjectsVariables.CALENDAR_DATE);
            this.state = 473;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 474;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_event_date_error(): Index_event_date_errorContext {
        let localContext = new Index_event_date_errorContext(this.context, this.state);
        this.enterRule(localContext, 44, SubjectsVariables.RULE_index_event_date_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 476;
            this.match(SubjectsVariables.EVENT);
            this.state = 477;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 478;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public lower_date_bounds_error(): Lower_date_bounds_errorContext {
        let localContext = new Lower_date_bounds_errorContext(this.context, this.state);
        this.enterRule(localContext, 46, SubjectsVariables.RULE_lower_date_bounds_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 480;
            this.match(SubjectsVariables.LOWER_DATE_BOUND);
            this.state = 481;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 482;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public upper_date_bounds_error(): Upper_date_bounds_errorContext {
        let localContext = new Upper_date_bounds_errorContext(this.context, this.state);
        this.enterRule(localContext, 48, SubjectsVariables.RULE_upper_date_bounds_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 484;
            this.match(SubjectsVariables.UPPER_DATE_BOUND);
            this.state = 485;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 486;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_event(): Derived_eventContext {
        let localContext = new Derived_eventContext(this.context, this.state);
        this.enterRule(localContext, 50, SubjectsVariables.RULE_derived_event);
        try {
            this.state = 491;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.MERGED_EVENT_NAME:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 488;
                this.merged_event();
                }
                break;
            case SubjectsVariables.SEQUENCE_EVENT_NAME:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 489;
                this.sequence_event();
                }
                break;
            case SubjectsVariables.INSTANCE_EVENT_NAME:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 490;
                this.instance_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event(): Merged_eventContext {
        let localContext = new Merged_eventContext(this.context, this.state);
        this.enterRule(localContext, 52, SubjectsVariables.RULE_merged_event);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 493;
            this.match(SubjectsVariables.MERGED_EVENT_NAME);
            this.state = 494;
            this.match(SubjectsVariables.EQ);
            this.state = 495;
            this.match(SubjectsVariables.MERGED_EVENT);
            this.state = 496;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 497;
            this.merged_event_criteria();
            this.state = 500;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 84) {
                {
                this.state = 498;
                this.match(SubjectsVariables.COMMA);
                this.state = 499;
                this.merged_event_filter_criterion();
                }
            }

            this.state = 502;
            this.match(SubjectsVariables.CLOSE_PAREN);
            this.state = 503;
            this.match(SubjectsVariables.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_criteria(): Merged_event_criteriaContext {
        let localContext = new Merged_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 54, SubjectsVariables.RULE_merged_event_criteria);
        try {
            let alternative: number;
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 505;
            this.merged_event_criterion();
            this.state = 508;
            this.errorHandler.sync(this);
            alternative = 1;
            do {
                switch (alternative) {
                case 1:
                    {
                    {
                    this.state = 506;
                    this.match(SubjectsVariables.COMMA);
                    this.state = 507;
                    this.merged_event_criterion();
                    }
                    }
                    break;
                default:
                    throw new antlr.NoViableAltException(this);
                }
                this.state = 510;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 13, this.context);
            } while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_criterion(): Merged_event_criterionContext {
        let localContext = new Merged_event_criterionContext(this.context, this.state);
        this.enterRule(localContext, 56, SubjectsVariables.RULE_merged_event_criterion);
        try {
            this.state = 514;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 14, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 512;
                this.merged_event_event();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 513;
                this.derived_event_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_filter_criterion(): Merged_event_filter_criterionContext {
        let localContext = new Merged_event_filter_criterionContext(this.context, this.state);
        this.enterRule(localContext, 58, SubjectsVariables.RULE_merged_event_filter_criterion);
        try {
            this.state = 518;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 15, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 516;
                this.merged_event_filter();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 517;
                this.merged_event_filter_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_event(): Merged_event_eventContext {
        let localContext = new Merged_event_eventContext(this.context, this.state);
        this.enterRule(localContext, 60, SubjectsVariables.RULE_merged_event_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 520;
            this.match(SubjectsVariables.DERIVED_EVENT);
            this.state = 521;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 524;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case SubjectsVariables.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case SubjectsVariables.QUALIFIED_MEASUREMENT_ALIAS:
            case SubjectsVariables.QUALIFIED_OBSERVATION_ALIAS:
            case SubjectsVariables.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case SubjectsVariables.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 522;
                this.qualified_simple_event();
                }
                break;
            case SubjectsVariables.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 523;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 526;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_filter(): Merged_event_filterContext {
        let localContext = new Merged_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 62, SubjectsVariables.RULE_merged_event_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 528;
            this.merged_event_uniqueness_filter();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_uniqueness_filter(): Merged_event_uniqueness_filterContext {
        let localContext = new Merged_event_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 64, SubjectsVariables.RULE_merged_event_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 530;
            this.match(SubjectsVariables.UF);
            this.state = 531;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 532;
            this.merged_event_uniqueness_filter_criteria();
            this.state = 533;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_uniqueness_filter_criteria(): Merged_event_uniqueness_filter_criteriaContext {
        let localContext = new Merged_event_uniqueness_filter_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 66, SubjectsVariables.RULE_merged_event_uniqueness_filter_criteria);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 537;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.MINIMUM_BETWEEN:
                {
                this.state = 535;
                this.derived_uniqueness_filter();
                }
                break;
            case SubjectsVariables.FIXED_WINDOW:
            case SubjectsVariables.ROLLING_WINDOW:
                {
                this.state = 536;
                this.derived_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 539;
            localContext._date_attr = this.match(SubjectsVariables.DERIVED_EVENT_DATE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_filter_error(): Merged_event_filter_errorContext {
        let localContext = new Merged_event_filter_errorContext(this.context, this.state);
        this.enterRule(localContext, 68, SubjectsVariables.RULE_merged_event_filter_error);
        try {
            this.state = 595;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 18, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 541;
                this.match(SubjectsVariables.UF);
                this.state = 542;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 543;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 544;
                this.match(SubjectsVariables.UF);
                this.state = 545;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 546;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 547;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 548;
                this.match(SubjectsVariables.UF);
                this.state = 549;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 550;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 551;
                this.derived_event_int();
                this.state = 552;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 554;
                this.match(SubjectsVariables.UF);
                this.state = 555;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 556;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 557;
                this.derived_event_int();
                this.state = 558;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 559;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 561;
                this.match(SubjectsVariables.UF);
                this.state = 562;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 563;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 564;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 565;
                this.match(SubjectsVariables.UF);
                this.state = 566;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 567;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 568;
                this.derived_event_int();
                this.state = 569;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 571;
                this.match(SubjectsVariables.UF);
                this.state = 572;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 573;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 574;
                this.derived_event_int();
                this.state = 575;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 576;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 578;
                this.match(SubjectsVariables.UF);
                this.state = 579;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 580;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 581;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 582;
                this.match(SubjectsVariables.UF);
                this.state = 583;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 584;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 585;
                this.derived_event_int();
                this.state = 586;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 588;
                this.match(SubjectsVariables.UF);
                this.state = 589;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 590;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 591;
                this.derived_event_int();
                this.state = 592;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 593;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event(): Sequence_eventContext {
        let localContext = new Sequence_eventContext(this.context, this.state);
        this.enterRule(localContext, 70, SubjectsVariables.RULE_sequence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 597;
            this.match(SubjectsVariables.SEQUENCE_EVENT_NAME);
            this.state = 598;
            this.match(SubjectsVariables.EQ);
            this.state = 599;
            this.match(SubjectsVariables.SEQUENCE_EVENT);
            this.state = 600;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 601;
            this.sequence_event_criteria();
            this.state = 602;
            this.match(SubjectsVariables.CLOSE_PAREN);
            this.state = 603;
            this.match(SubjectsVariables.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_criteria(): Sequence_event_criteriaContext {
        let localContext = new Sequence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 72, SubjectsVariables.RULE_sequence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 605;
            this.sequence_event_criterion();
            this.state = 610;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 606;
                this.match(SubjectsVariables.COMMA);
                this.state = 607;
                this.sequence_event_criterion();
                }
                }
                this.state = 612;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_criterion(): Sequence_event_criterionContext {
        let localContext = new Sequence_event_criterionContext(this.context, this.state);
        this.enterRule(localContext, 74, SubjectsVariables.RULE_sequence_event_criterion);
        try {
            this.state = 617;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 20, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 613;
                this.sequence_event_constraint();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 614;
                this.sequence_event_event();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 615;
                this.sequence_event_constraint_error();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 616;
                this.derived_event_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_constraint(): Sequence_event_constraintContext {
        let localContext = new Sequence_event_constraintContext(this.context, this.state);
        this.enterRule(localContext, 76, SubjectsVariables.RULE_sequence_event_constraint);
        try {
            this.state = 621;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.ANY_ORDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 619;
                this.match(SubjectsVariables.ANY_ORDER);
                }
                break;
            case SubjectsVariables.TC:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 620;
                this.temporal_constraint();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public temporal_constraint(): Temporal_constraintContext {
        let localContext = new Temporal_constraintContext(this.context, this.state);
        this.enterRule(localContext, 78, SubjectsVariables.RULE_temporal_constraint);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 623;
            this.match(SubjectsVariables.TC);
            this.state = 624;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 625;
            this.sequence_temporal_filter();
            this.state = 626;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_temporal_filter(): Sequence_temporal_filterContext {
        let localContext = new Sequence_temporal_filterContext(this.context, this.state);
        this.enterRule(localContext, 80, SubjectsVariables.RULE_sequence_temporal_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 628;
            _la = this.tokenStream.LA(1);
            if(!(((((_la - 116)) & ~0x1F) === 0 && ((1 << (_la - 116)) & 7) !== 0))) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 629;
            this.match(SubjectsVariables.INT);
            this.state = 630;
            this.match(SubjectsVariables.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_event(): Sequence_event_eventContext {
        let localContext = new Sequence_event_eventContext(this.context, this.state);
        this.enterRule(localContext, 82, SubjectsVariables.RULE_sequence_event_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 632;
            this.match(SubjectsVariables.DERIVED_EVENT);
            this.state = 633;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 636;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 22, this.context) ) {
            case 1:
                {
                this.state = 634;
                this.selected_sequence_event();
                }
                break;
            case 2:
                {
                this.state = 635;
                this.unselected_sequence_event();
                }
                break;
            }
            this.state = 638;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public selected_sequence_event(): Selected_sequence_eventContext {
        let localContext = new Selected_sequence_eventContext(this.context, this.state);
        this.enterRule(localContext, 84, SubjectsVariables.RULE_selected_sequence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 642;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case SubjectsVariables.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case SubjectsVariables.QUALIFIED_MEASUREMENT_ALIAS:
            case SubjectsVariables.QUALIFIED_OBSERVATION_ALIAS:
            case SubjectsVariables.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case SubjectsVariables.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 640;
                this.qualified_simple_event();
                }
                break;
            case SubjectsVariables.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 641;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 644;
            this.match(SubjectsVariables.COMMA);
            this.state = 645;
            this.match(SubjectsVariables.IS_EVENT_DATE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public unselected_sequence_event(): Unselected_sequence_eventContext {
        let localContext = new Unselected_sequence_eventContext(this.context, this.state);
        this.enterRule(localContext, 86, SubjectsVariables.RULE_unselected_sequence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 649;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case SubjectsVariables.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case SubjectsVariables.QUALIFIED_MEASUREMENT_ALIAS:
            case SubjectsVariables.QUALIFIED_OBSERVATION_ALIAS:
            case SubjectsVariables.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case SubjectsVariables.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 647;
                this.qualified_simple_event();
                }
                break;
            case SubjectsVariables.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 648;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event(): Instance_eventContext {
        let localContext = new Instance_eventContext(this.context, this.state);
        this.enterRule(localContext, 88, SubjectsVariables.RULE_instance_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 651;
            this.match(SubjectsVariables.INSTANCE_EVENT_NAME);
            this.state = 652;
            this.match(SubjectsVariables.EQ);
            this.state = 653;
            this.match(SubjectsVariables.INSTANCE_EVENT);
            this.state = 654;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 655;
            this.instance_event_criteria();
            this.state = 656;
            this.match(SubjectsVariables.CLOSE_PAREN);
            this.state = 657;
            this.match(SubjectsVariables.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_criteria(): Instance_event_criteriaContext {
        let localContext = new Instance_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 90, SubjectsVariables.RULE_instance_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 659;
            this.instance_event_criterion();
            this.state = 662;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            do {
                {
                {
                this.state = 660;
                this.match(SubjectsVariables.COMMA);
                this.state = 661;
                this.instance_event_criterion();
                }
                }
                this.state = 664;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            } while (_la === 84);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_criterion(): Instance_event_criterionContext {
        let localContext = new Instance_event_criterionContext(this.context, this.state);
        this.enterRule(localContext, 92, SubjectsVariables.RULE_instance_event_criterion);
        try {
            this.state = 671;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 26, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 667;
                this.instance_event_event();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 668;
                this.derived_event_error();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 669;
                this.instance_event_position();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 670;
                this.instance_event_position_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_event(): Instance_event_eventContext {
        let localContext = new Instance_event_eventContext(this.context, this.state);
        this.enterRule(localContext, 94, SubjectsVariables.RULE_instance_event_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 673;
            this.match(SubjectsVariables.DERIVED_EVENT);
            this.state = 674;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 677;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case SubjectsVariables.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case SubjectsVariables.QUALIFIED_MEASUREMENT_ALIAS:
            case SubjectsVariables.QUALIFIED_OBSERVATION_ALIAS:
            case SubjectsVariables.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case SubjectsVariables.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 675;
                this.qualified_simple_event();
                }
                break;
            case SubjectsVariables.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 676;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 679;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_position(): Instance_event_positionContext {
        let localContext = new Instance_event_positionContext(this.context, this.state);
        this.enterRule(localContext, 96, SubjectsVariables.RULE_instance_event_position);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 681;
            this.match(SubjectsVariables.POSITION);
            this.state = 682;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 685;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.MAX:
            case SubjectsVariables.MIN:
                {
                this.state = 683;
                this.aggregation_qualified();
                }
                break;
            case SubjectsVariables.INDEX:
                {
                this.state = 684;
                this.specific_instance();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 687;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public aggregation_qualified(): Aggregation_qualifiedContext {
        let localContext = new Aggregation_qualifiedContext(this.context, this.state);
        this.enterRule(localContext, 98, SubjectsVariables.RULE_aggregation_qualified);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 689;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 96 || _la === 97)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public specific_instance(): Specific_instanceContext {
        let localContext = new Specific_instanceContext(this.context, this.state);
        this.enterRule(localContext, 100, SubjectsVariables.RULE_specific_instance);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 691;
            this.match(SubjectsVariables.INDEX);
            this.state = 692;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 693;
            this.match(SubjectsVariables.INT);
            this.state = 694;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_position_error(): Instance_event_position_errorContext {
        let localContext = new Instance_event_position_errorContext(this.context, this.state);
        this.enterRule(localContext, 102, SubjectsVariables.RULE_instance_event_position_error);
        try {
            this.state = 705;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 29, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 696;
                this.match(SubjectsVariables.POSITION);
                this.state = 697;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 698;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 699;
                this.match(SubjectsVariables.POSITION);
                this.state = 700;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 701;
                this.match(SubjectsVariables.INDEX);
                this.state = 702;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 703;
                this.match(SubjectsVariables.CLOSE_PAREN);
                this.state = 704;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public qualified_simple_event(): Qualified_simple_eventContext {
        let localContext = new Qualified_simple_eventContext(this.context, this.state);
        this.enterRule(localContext, 104, SubjectsVariables.RULE_qualified_simple_event);
        try {
            this.state = 725;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 707;
                this.match(SubjectsVariables.QUALIFIED_CONDITION_OCCURRENCE_ALIAS);
                this.state = 708;
                this.match(SubjectsVariables.PERIOD);
                this.state = 709;
                this.match(SubjectsVariables.CONDITION_OCCURRENCE_DATE_ATTRIBUTE);
                }
                break;
            case SubjectsVariables.QUALIFIED_DRUG_EXPOSURE_ALIAS:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 710;
                this.match(SubjectsVariables.QUALIFIED_DRUG_EXPOSURE_ALIAS);
                this.state = 711;
                this.match(SubjectsVariables.PERIOD);
                this.state = 712;
                this.match(SubjectsVariables.DRUG_EXPOSURE_DATE_ATTRIBUTE);
                }
                break;
            case SubjectsVariables.QUALIFIED_MEASUREMENT_ALIAS:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 713;
                this.match(SubjectsVariables.QUALIFIED_MEASUREMENT_ALIAS);
                this.state = 714;
                this.match(SubjectsVariables.PERIOD);
                this.state = 715;
                this.match(SubjectsVariables.MEASUREMENT_DATE_ATTRIBUTE);
                }
                break;
            case SubjectsVariables.QUALIFIED_OBSERVATION_ALIAS:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 716;
                this.match(SubjectsVariables.QUALIFIED_OBSERVATION_ALIAS);
                this.state = 717;
                this.match(SubjectsVariables.PERIOD);
                this.state = 718;
                this.match(SubjectsVariables.OBSERVATION_DATE_ATTRIBUTE);
                }
                break;
            case SubjectsVariables.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 719;
                this.match(SubjectsVariables.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS);
                this.state = 720;
                this.match(SubjectsVariables.PERIOD);
                this.state = 721;
                this.match(SubjectsVariables.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE);
                }
                break;
            case SubjectsVariables.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 722;
                this.match(SubjectsVariables.QUALIFIED_VISIT_OCCURRENCE_ALIAS);
                this.state = 723;
                this.match(SubjectsVariables.PERIOD);
                this.state = 724;
                this.match(SubjectsVariables.VISIT_OCCURRENCE_DATE_ATTRIBUTE);
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public qualified_derived_event(): Qualified_derived_eventContext {
        let localContext = new Qualified_derived_eventContext(this.context, this.state);
        this.enterRule(localContext, 106, SubjectsVariables.RULE_qualified_derived_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 727;
            this.match(SubjectsVariables.QUALIFIED_DERIVED_EVENT_NAME);
            this.state = 728;
            this.match(SubjectsVariables.PERIOD);
            this.state = 729;
            this.match(SubjectsVariables.DERIVED_EVENT_DATE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_constraint_error(): Sequence_event_constraint_errorContext {
        let localContext = new Sequence_event_constraint_errorContext(this.context, this.state);
        this.enterRule(localContext, 108, SubjectsVariables.RULE_sequence_event_constraint_error);
        let _la: number;
        try {
            this.state = 743;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 31, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 731;
                this.match(SubjectsVariables.TC);
                this.state = 732;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 733;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 734;
                this.match(SubjectsVariables.TC);
                this.state = 735;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 736;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 116)) & ~0x1F) === 0 && ((1 << (_la - 116)) & 7) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 737;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 738;
                this.match(SubjectsVariables.TC);
                this.state = 739;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 740;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 116)) & ~0x1F) === 0 && ((1 << (_la - 116)) & 7) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 741;
                this.match(SubjectsVariables.INT);
                this.state = 742;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_event_error(): Derived_event_errorContext {
        let localContext = new Derived_event_errorContext(this.context, this.state);
        this.enterRule(localContext, 110, SubjectsVariables.RULE_derived_event_error);
        let _la: number;
        try {
            this.state = 757;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 32, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 745;
                this.match(SubjectsVariables.DERIVED_EVENT);
                this.state = 746;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 747;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 748;
                this.match(SubjectsVariables.DERIVED_EVENT);
                this.state = 749;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 750;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 30)) & ~0x1F) === 0 && ((1 << (_la - 30)) & 431) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 751;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 752;
                this.match(SubjectsVariables.DERIVED_EVENT);
                this.state = 753;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 754;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 30)) & ~0x1F) === 0 && ((1 << (_la - 30)) & 431) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 755;
                this.match(SubjectsVariables.PERIOD);
                this.state = 756;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_uniqueness_filter(): Derived_uniqueness_filterContext {
        let localContext = new Derived_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 112, SubjectsVariables.RULE_derived_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 759;
            this.match(SubjectsVariables.MINIMUM_BETWEEN);
            this.state = 760;
            this.derived_event_int();
            this.state = 761;
            this.match(SubjectsVariables.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_uniqueness_filter_window(): Derived_uniqueness_filter_windowContext {
        let localContext = new Derived_uniqueness_filter_windowContext(this.context, this.state);
        this.enterRule(localContext, 114, SubjectsVariables.RULE_derived_uniqueness_filter_window);
        try {
            this.state = 765;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.FIXED_WINDOW:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 763;
                this.derived_fixed_window_uniqueness_filter();
                }
                break;
            case SubjectsVariables.ROLLING_WINDOW:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 764;
                this.derived_rolling_window_uniqueness_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_fixed_window_uniqueness_filter(): Derived_fixed_window_uniqueness_filterContext {
        let localContext = new Derived_fixed_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 116, SubjectsVariables.RULE_derived_fixed_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 767;
            this.match(SubjectsVariables.FIXED_WINDOW);
            this.state = 768;
            this.derived_event_int();
            this.state = 769;
            this.match(SubjectsVariables.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_rolling_window_uniqueness_filter(): Derived_rolling_window_uniqueness_filterContext {
        let localContext = new Derived_rolling_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 118, SubjectsVariables.RULE_derived_rolling_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 771;
            this.match(SubjectsVariables.ROLLING_WINDOW);
            this.state = 772;
            this.derived_event_int();
            this.state = 773;
            this.match(SubjectsVariables.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_event_int(): Derived_event_intContext {
        let localContext = new Derived_event_intContext(this.context, this.state);
        this.enterRule(localContext, 120, SubjectsVariables.RULE_derived_event_int);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 775;
            this.match(SubjectsVariables.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event(): Simple_eventContext {
        let localContext = new Simple_eventContext(this.context, this.state);
        this.enterRule(localContext, 122, SubjectsVariables.RULE_simple_event);
        try {
            this.state = 783;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.CONDITION_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 777;
                this.condition_occurrence_event();
                }
                break;
            case SubjectsVariables.DRUG_EXPOSURE_ALIAS:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 778;
                this.drug_exposure_event();
                }
                break;
            case SubjectsVariables.MEASUREMENT_ALIAS:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 779;
                this.measurement_event();
                }
                break;
            case SubjectsVariables.OBSERVATION_ALIAS:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 780;
                this.observation_event();
                }
                break;
            case SubjectsVariables.PROCEDURE_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 781;
                this.procedure_occurrence_event();
                }
                break;
            case SubjectsVariables.VISIT_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 782;
                this.visit_occurrence_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event(): Condition_occurrence_eventContext {
        let localContext = new Condition_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 124, SubjectsVariables.RULE_condition_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 785;
            localContext._event_name = this.match(SubjectsVariables.CONDITION_OCCURRENCE_ALIAS);
            this.state = 786;
            this.match(SubjectsVariables.EQ);
            this.state = 787;
            localContext._event_definition = this.condition_occurrence_event_definition();
            this.state = 788;
            this.match(SubjectsVariables.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event(): Drug_exposure_eventContext {
        let localContext = new Drug_exposure_eventContext(this.context, this.state);
        this.enterRule(localContext, 126, SubjectsVariables.RULE_drug_exposure_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 790;
            localContext._event_name = this.match(SubjectsVariables.DRUG_EXPOSURE_ALIAS);
            this.state = 791;
            this.match(SubjectsVariables.EQ);
            this.state = 792;
            localContext._event_definition = this.drug_exposure_event_definition();
            this.state = 793;
            this.match(SubjectsVariables.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event(): Measurement_eventContext {
        let localContext = new Measurement_eventContext(this.context, this.state);
        this.enterRule(localContext, 128, SubjectsVariables.RULE_measurement_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 795;
            localContext._event_name = this.match(SubjectsVariables.MEASUREMENT_ALIAS);
            this.state = 796;
            this.match(SubjectsVariables.EQ);
            this.state = 797;
            localContext._event_definition = this.measurement_event_definition();
            this.state = 798;
            this.match(SubjectsVariables.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event(): Observation_eventContext {
        let localContext = new Observation_eventContext(this.context, this.state);
        this.enterRule(localContext, 130, SubjectsVariables.RULE_observation_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 800;
            localContext._event_name = this.match(SubjectsVariables.OBSERVATION_ALIAS);
            this.state = 801;
            this.match(SubjectsVariables.EQ);
            this.state = 802;
            localContext._event_definition = this.observation_event_definition();
            this.state = 803;
            this.match(SubjectsVariables.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event(): Procedure_occurrence_eventContext {
        let localContext = new Procedure_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 132, SubjectsVariables.RULE_procedure_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 805;
            localContext._event_name = this.match(SubjectsVariables.PROCEDURE_OCCURRENCE_ALIAS);
            this.state = 806;
            this.match(SubjectsVariables.EQ);
            this.state = 807;
            localContext._event_definition = this.procedure_occurrence_event_definition();
            this.state = 808;
            this.match(SubjectsVariables.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event(): Visit_occurrence_eventContext {
        let localContext = new Visit_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 134, SubjectsVariables.RULE_visit_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 810;
            localContext._event_name = this.match(SubjectsVariables.VISIT_OCCURRENCE_ALIAS);
            this.state = 811;
            this.match(SubjectsVariables.EQ);
            this.state = 812;
            localContext._event_definition = this.visit_occurrence_event_definition();
            this.state = 813;
            this.match(SubjectsVariables.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_definition(): Condition_occurrence_event_definitionContext {
        let localContext = new Condition_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 136, SubjectsVariables.RULE_condition_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 815;
            localContext._prefix = this.match(SubjectsVariables.CONDITION_OCCURRENCE);
            this.state = 816;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 818;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 75513856) !== 0)) {
                {
                this.state = 817;
                localContext._criteria = this.condition_occurrence_event_criteria();
                }
            }

            this.state = 820;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_definition(): Drug_exposure_event_definitionContext {
        let localContext = new Drug_exposure_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 138, SubjectsVariables.RULE_drug_exposure_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 822;
            localContext._prefix = this.match(SubjectsVariables.DRUG_EXPOSURE);
            this.state = 823;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 825;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 75644928) !== 0)) {
                {
                this.state = 824;
                localContext._criteria = this.drug_exposure_event_criteria();
                }
            }

            this.state = 827;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_definition(): Measurement_event_definitionContext {
        let localContext = new Measurement_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 140, SubjectsVariables.RULE_measurement_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 829;
            localContext._prefix = this.match(SubjectsVariables.MEASUREMENT);
            this.state = 830;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 832;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 75644928) !== 0)) {
                {
                this.state = 831;
                localContext._criteria = this.measurement_event_criteria();
                }
            }

            this.state = 834;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_definition(): Observation_event_definitionContext {
        let localContext = new Observation_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 142, SubjectsVariables.RULE_observation_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 836;
            localContext._prefix = this.match(SubjectsVariables.OBSERVATION);
            this.state = 837;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 839;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 75644928) !== 0)) {
                {
                this.state = 838;
                localContext._criteria = this.observation_event_criteria();
                }
            }

            this.state = 841;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_definition(): Procedure_occurrence_event_definitionContext {
        let localContext = new Procedure_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 144, SubjectsVariables.RULE_procedure_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 843;
            localContext._prefix = this.match(SubjectsVariables.PROCEDURE_OCCURRENCE);
            this.state = 844;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 846;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 75644928) !== 0)) {
                {
                this.state = 845;
                localContext._criteria = this.procedure_occurrence_event_criteria();
                }
            }

            this.state = 848;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_definition(): Visit_occurrence_event_definitionContext {
        let localContext = new Visit_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 146, SubjectsVariables.RULE_visit_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 850;
            localContext._prefix = this.match(SubjectsVariables.VISIT_OCCURRENCE);
            this.state = 851;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 853;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 75513856) !== 0)) {
                {
                this.state = 852;
                localContext._criteria = this.visit_occurrence_event_criteria();
                }
            }

            this.state = 855;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_criteria(): Condition_occurrence_event_criteriaContext {
        let localContext = new Condition_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 148, SubjectsVariables.RULE_condition_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 857;
            this.condition_occurrence_event_filter();
            this.state = 862;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 858;
                this.match(SubjectsVariables.COMMA);
                this.state = 859;
                this.condition_occurrence_event_filter();
                }
                }
                this.state = 864;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_filter(): Condition_occurrence_event_filterContext {
        let localContext = new Condition_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 150, SubjectsVariables.RULE_condition_occurrence_event_filter);
        try {
            this.state = 869;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 42, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 865;
                this.condition_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 866;
                this.condition_occurrence_uniqueness_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 867;
                this.condition_occurrence_related_entity_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 868;
                this.condition_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_filters(): Condition_occurrence_concept_filtersContext {
        let localContext = new Condition_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 152, SubjectsVariables.RULE_condition_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 871;
            this.match(SubjectsVariables.CF);
            this.state = 872;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 875;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 43, this.context) ) {
            case 1:
                {
                this.state = 873;
                this.condition_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 874;
                this.condition_occurrence_concept_filter();
                }
                break;
            }
            this.state = 877;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext {
        let localContext = new Condition_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 154, SubjectsVariables.RULE_condition_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 879;
            this.match(SubjectsVariables.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 880;
            this.match(SubjectsVariables.IN);
            this.state = 881;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext {
        let localContext = new Condition_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 156, SubjectsVariables.RULE_condition_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 883;
            this.match(SubjectsVariables.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 884;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 85 || _la === 91)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 885;
            this.match(SubjectsVariables.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_uniqueness_filters(): Condition_occurrence_uniqueness_filtersContext {
        let localContext = new Condition_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 158, SubjectsVariables.RULE_condition_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 887;
            this.match(SubjectsVariables.UF);
            this.state = 888;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 889;
            this.condition_occurrence_uniqueness_filter();
            this.state = 890;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_uniqueness_filter(): Condition_occurrence_uniqueness_filterContext {
        let localContext = new Condition_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 160, SubjectsVariables.RULE_condition_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 894;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.MINIMUM_BETWEEN:
                {
                this.state = 892;
                this.simple_uniqueness_filter();
                }
                break;
            case SubjectsVariables.FIXED_WINDOW:
            case SubjectsVariables.ROLLING_WINDOW:
                {
                this.state = 893;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 896;
            localContext._date_attr = this.match(SubjectsVariables.CONDITION_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_related_entity_filters(): Condition_occurrence_related_entity_filtersContext {
        let localContext = new Condition_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 162, SubjectsVariables.RULE_condition_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 898;
            this.match(SubjectsVariables.RF);
            this.state = 899;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 900;
            this.condition_occurrence_related_entity_filter();
            this.state = 901;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_related_entity_filter(): Condition_occurrence_related_entity_filterContext {
        let localContext = new Condition_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 164, SubjectsVariables.RULE_condition_occurrence_related_entity_filter);
        try {
            this.state = 905;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 903;
                this.provider_sub_filter();
                }
                break;
            case SubjectsVariables.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 904;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_sub_filter(): Condition_occurrence_sub_filterContext {
        let localContext = new Condition_occurrence_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 166, SubjectsVariables.RULE_condition_occurrence_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 907;
            this.match(SubjectsVariables.CONDITION_OCCURRENCE);
            this.state = 910;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 46, this.context) ) {
            case 1:
                {
                this.state = 908;
                this.condition_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 909;
                this.condition_occurrence_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_error_sub_filter(): Condition_occurrence_error_sub_filterContext {
        let localContext = new Condition_occurrence_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 168, SubjectsVariables.RULE_condition_occurrence_error_sub_filter);
        let _la: number;
        try {
            this.state = 922;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 47, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 913;
                this.match(SubjectsVariables.CONDITION_OCCURRENCE);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 914;
                this.match(SubjectsVariables.CONDITION_OCCURRENCE);
                this.state = 915;
                this.match(SubjectsVariables.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 916;
                this.match(SubjectsVariables.CONDITION_OCCURRENCE);
                this.state = 917;
                this.match(SubjectsVariables.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 918;
                this.match(SubjectsVariables.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 919;
                this.match(SubjectsVariables.CONDITION_OCCURRENCE);
                this.state = 920;
                this.match(SubjectsVariables.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 921;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_error_filter(): Condition_occurrence_error_filterContext {
        let localContext = new Condition_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 170, SubjectsVariables.RULE_condition_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 1008;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 48, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 924;
                this.match(SubjectsVariables.CF);
                this.state = 925;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 926;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 927;
                this.match(SubjectsVariables.CF);
                this.state = 928;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 929;
                this.match(SubjectsVariables.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 930;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 931;
                this.match(SubjectsVariables.CF);
                this.state = 932;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 933;
                this.match(SubjectsVariables.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 934;
                this.match(SubjectsVariables.IN);
                this.state = 935;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 936;
                this.match(SubjectsVariables.CF);
                this.state = 937;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 938;
                this.match(SubjectsVariables.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 939;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 940;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 941;
                this.match(SubjectsVariables.UF);
                this.state = 942;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 943;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 944;
                this.match(SubjectsVariables.UF);
                this.state = 945;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 946;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 947;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 948;
                this.match(SubjectsVariables.UF);
                this.state = 949;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 950;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 951;
                this.simple_event_int();
                this.state = 952;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 954;
                this.match(SubjectsVariables.UF);
                this.state = 955;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 956;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 957;
                this.simple_event_int();
                this.state = 958;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 959;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 961;
                this.match(SubjectsVariables.UF);
                this.state = 962;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 963;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 964;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 965;
                this.match(SubjectsVariables.UF);
                this.state = 966;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 967;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 968;
                this.simple_event_int();
                this.state = 969;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 971;
                this.match(SubjectsVariables.UF);
                this.state = 972;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 973;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 974;
                this.simple_event_int();
                this.state = 975;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 976;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 978;
                this.match(SubjectsVariables.UF);
                this.state = 979;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 980;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 981;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 982;
                this.match(SubjectsVariables.UF);
                this.state = 983;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 984;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 985;
                this.simple_event_int();
                this.state = 986;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 988;
                this.match(SubjectsVariables.UF);
                this.state = 989;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 990;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 991;
                this.simple_event_int();
                this.state = 992;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 993;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 995;
                this.match(SubjectsVariables.RF);
                this.state = 996;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 997;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 998;
                this.match(SubjectsVariables.RF);
                this.state = 999;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1000;
                this.provider_error_sub_filter();
                this.state = 1001;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1003;
                this.match(SubjectsVariables.RF);
                this.state = 1004;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1005;
                this.visit_occurrence_error_sub_filter();
                this.state = 1006;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_criteria(): Drug_exposure_event_criteriaContext {
        let localContext = new Drug_exposure_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 172, SubjectsVariables.RULE_drug_exposure_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1010;
            this.drug_exposure_event_filter();
            this.state = 1015;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 1011;
                this.match(SubjectsVariables.COMMA);
                this.state = 1012;
                this.drug_exposure_event_filter();
                }
                }
                this.state = 1017;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_filter(): Drug_exposure_event_filterContext {
        let localContext = new Drug_exposure_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 174, SubjectsVariables.RULE_drug_exposure_event_filter);
        try {
            this.state = 1023;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 50, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1018;
                this.drug_exposure_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1019;
                this.drug_exposure_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1020;
                this.drug_exposure_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1021;
                this.drug_exposure_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1022;
                this.drug_exposure_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_filters(): Drug_exposure_concept_filtersContext {
        let localContext = new Drug_exposure_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 176, SubjectsVariables.RULE_drug_exposure_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1025;
            this.match(SubjectsVariables.CF);
            this.state = 1026;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1029;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 51, this.context) ) {
            case 1:
                {
                this.state = 1027;
                this.drug_exposure_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1028;
                this.drug_exposure_concept_filter();
                }
                break;
            }
            this.state = 1031;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_group_filter(): Drug_exposure_concept_group_filterContext {
        let localContext = new Drug_exposure_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 178, SubjectsVariables.RULE_drug_exposure_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1033;
            this.match(SubjectsVariables.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
            this.state = 1034;
            this.match(SubjectsVariables.IN);
            this.state = 1035;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_filter(): Drug_exposure_concept_filterContext {
        let localContext = new Drug_exposure_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 180, SubjectsVariables.RULE_drug_exposure_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1037;
            this.match(SubjectsVariables.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
            this.state = 1038;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 85 || _la === 91)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1039;
            this.match(SubjectsVariables.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_numeric_filters(): Drug_exposure_numeric_filtersContext {
        let localContext = new Drug_exposure_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 182, SubjectsVariables.RULE_drug_exposure_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1041;
            this.match(SubjectsVariables.NF);
            this.state = 1042;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1045;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.QUANTITY:
                {
                this.state = 1043;
                this.drug_exposure_float_filter();
                }
                break;
            case SubjectsVariables.DRUG_EXPOSURE_INT_ATTRIBUTE:
                {
                this.state = 1044;
                this.drug_exposure_int_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1047;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_float_filter(): Drug_exposure_float_filterContext {
        let localContext = new Drug_exposure_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 184, SubjectsVariables.RULE_drug_exposure_float_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1049;
            this.match(SubjectsVariables.QUANTITY);
            this.state = 1050;
            this.comparison_op();
            this.state = 1051;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_int_filter(): Drug_exposure_int_filterContext {
        let localContext = new Drug_exposure_int_filterContext(this.context, this.state);
        this.enterRule(localContext, 186, SubjectsVariables.RULE_drug_exposure_int_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1053;
            this.match(SubjectsVariables.DRUG_EXPOSURE_INT_ATTRIBUTE);
            this.state = 1054;
            this.comparison_op();
            this.state = 1055;
            this.simple_event_int();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_uniqueness_filters(): Drug_exposure_uniqueness_filtersContext {
        let localContext = new Drug_exposure_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 188, SubjectsVariables.RULE_drug_exposure_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1057;
            this.match(SubjectsVariables.UF);
            this.state = 1058;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1059;
            this.drug_exposure_uniqueness_filter();
            this.state = 1060;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_uniqueness_filter(): Drug_exposure_uniqueness_filterContext {
        let localContext = new Drug_exposure_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 190, SubjectsVariables.RULE_drug_exposure_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1064;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.MINIMUM_BETWEEN:
                {
                this.state = 1062;
                this.simple_uniqueness_filter();
                }
                break;
            case SubjectsVariables.FIXED_WINDOW:
            case SubjectsVariables.ROLLING_WINDOW:
                {
                this.state = 1063;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1066;
            this.match(SubjectsVariables.DRUG_EXPOSURE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_related_entity_filters(): Drug_exposure_related_entity_filtersContext {
        let localContext = new Drug_exposure_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 192, SubjectsVariables.RULE_drug_exposure_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1068;
            this.match(SubjectsVariables.RF);
            this.state = 1069;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1070;
            this.drug_exposure_related_entity_filter();
            this.state = 1071;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_related_entity_filter(): Drug_exposure_related_entity_filterContext {
        let localContext = new Drug_exposure_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 194, SubjectsVariables.RULE_drug_exposure_related_entity_filter);
        try {
            this.state = 1075;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1073;
                this.provider_sub_filter();
                }
                break;
            case SubjectsVariables.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1074;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_error_filter(): Drug_exposure_error_filterContext {
        let localContext = new Drug_exposure_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 196, SubjectsVariables.RULE_drug_exposure_error_filter);
        let _la: number;
        try {
            this.state = 1184;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 55, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1077;
                this.match(SubjectsVariables.CF);
                this.state = 1078;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1079;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1080;
                this.match(SubjectsVariables.CF);
                this.state = 1081;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1082;
                this.match(SubjectsVariables.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 1083;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1084;
                this.match(SubjectsVariables.CF);
                this.state = 1085;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1086;
                this.match(SubjectsVariables.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 1087;
                this.match(SubjectsVariables.IN);
                this.state = 1088;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1089;
                this.match(SubjectsVariables.CF);
                this.state = 1090;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1091;
                this.match(SubjectsVariables.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 1092;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1093;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1094;
                this.match(SubjectsVariables.NF);
                this.state = 1095;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1096;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1097;
                this.match(SubjectsVariables.NF);
                this.state = 1098;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1099;
                this.match(SubjectsVariables.QUANTITY);
                this.state = 1100;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1101;
                this.match(SubjectsVariables.NF);
                this.state = 1102;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1103;
                this.match(SubjectsVariables.QUANTITY);
                this.state = 1104;
                this.comparison_op();
                this.state = 1105;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1107;
                this.match(SubjectsVariables.NF);
                this.state = 1108;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1109;
                this.match(SubjectsVariables.DRUG_EXPOSURE_INT_ATTRIBUTE);
                this.state = 1110;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1111;
                this.match(SubjectsVariables.NF);
                this.state = 1112;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1113;
                this.match(SubjectsVariables.DRUG_EXPOSURE_INT_ATTRIBUTE);
                this.state = 1114;
                this.comparison_op();
                this.state = 1115;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1117;
                this.match(SubjectsVariables.UF);
                this.state = 1118;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1119;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1120;
                this.match(SubjectsVariables.UF);
                this.state = 1121;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1122;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 1123;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1124;
                this.match(SubjectsVariables.UF);
                this.state = 1125;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1126;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 1127;
                this.simple_event_int();
                this.state = 1128;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1130;
                this.match(SubjectsVariables.UF);
                this.state = 1131;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1132;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 1133;
                this.simple_event_int();
                this.state = 1134;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 1135;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1137;
                this.match(SubjectsVariables.UF);
                this.state = 1138;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1139;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 1140;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1141;
                this.match(SubjectsVariables.UF);
                this.state = 1142;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1143;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 1144;
                this.simple_event_int();
                this.state = 1145;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1147;
                this.match(SubjectsVariables.UF);
                this.state = 1148;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1149;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 1150;
                this.simple_event_int();
                this.state = 1151;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 1152;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1154;
                this.match(SubjectsVariables.UF);
                this.state = 1155;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1156;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 1157;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1158;
                this.match(SubjectsVariables.UF);
                this.state = 1159;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1160;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 1161;
                this.simple_event_int();
                this.state = 1162;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1164;
                this.match(SubjectsVariables.UF);
                this.state = 1165;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1166;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 1167;
                this.simple_event_int();
                this.state = 1168;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 1169;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1171;
                this.match(SubjectsVariables.RF);
                this.state = 1172;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1173;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 1174;
                this.match(SubjectsVariables.RF);
                this.state = 1175;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1176;
                this.provider_error_sub_filter();
                this.state = 1177;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 1179;
                this.match(SubjectsVariables.RF);
                this.state = 1180;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1181;
                this.visit_occurrence_error_sub_filter();
                this.state = 1182;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_criteria(): Measurement_event_criteriaContext {
        let localContext = new Measurement_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 198, SubjectsVariables.RULE_measurement_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1186;
            this.measurement_event_filter();
            this.state = 1191;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 1187;
                this.match(SubjectsVariables.COMMA);
                this.state = 1188;
                this.measurement_event_filter();
                }
                }
                this.state = 1193;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_filter(): Measurement_event_filterContext {
        let localContext = new Measurement_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 200, SubjectsVariables.RULE_measurement_event_filter);
        try {
            this.state = 1199;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 57, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1194;
                this.measurement_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1195;
                this.measurement_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1196;
                this.measurement_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1197;
                this.measurement_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1198;
                this.measurement_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_filters(): Measurement_concept_filtersContext {
        let localContext = new Measurement_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 202, SubjectsVariables.RULE_measurement_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1201;
            this.match(SubjectsVariables.CF);
            this.state = 1202;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1205;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 58, this.context) ) {
            case 1:
                {
                this.state = 1203;
                this.measurement_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1204;
                this.measurement_concept_filter();
                }
                break;
            }
            this.state = 1207;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_group_filter(): Measurement_concept_group_filterContext {
        let localContext = new Measurement_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 204, SubjectsVariables.RULE_measurement_concept_group_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1209;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 164 || _la === 170)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1210;
            this.match(SubjectsVariables.IN);
            this.state = 1211;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_filter(): Measurement_concept_filterContext {
        let localContext = new Measurement_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 206, SubjectsVariables.RULE_measurement_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1213;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 164 || _la === 170)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1214;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 85 || _la === 91)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1215;
            this.match(SubjectsVariables.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_numeric_filters(): Measurement_numeric_filtersContext {
        let localContext = new Measurement_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 208, SubjectsVariables.RULE_measurement_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1217;
            this.match(SubjectsVariables.NF);
            this.state = 1218;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1219;
            this.measurement_float_filter();
            this.state = 1220;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_float_filter(): Measurement_float_filterContext {
        let localContext = new Measurement_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 210, SubjectsVariables.RULE_measurement_float_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1222;
            _la = this.tokenStream.LA(1);
            if(!(_la === 158 || _la === 160)) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1223;
            this.comparison_op();
            this.state = 1224;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_uniqueness_filters(): Measurement_uniqueness_filtersContext {
        let localContext = new Measurement_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 212, SubjectsVariables.RULE_measurement_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1226;
            this.match(SubjectsVariables.UF);
            this.state = 1227;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1228;
            this.measurement_uniqueness_filter();
            this.state = 1229;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_uniqueness_filter(): Measurement_uniqueness_filterContext {
        let localContext = new Measurement_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 214, SubjectsVariables.RULE_measurement_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1233;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.MINIMUM_BETWEEN:
                {
                this.state = 1231;
                this.simple_uniqueness_filter();
                }
                break;
            case SubjectsVariables.FIXED_WINDOW:
            case SubjectsVariables.ROLLING_WINDOW:
                {
                this.state = 1232;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1235;
            this.match(SubjectsVariables.MEASUREMENT_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_related_entity_filters(): Measurement_related_entity_filtersContext {
        let localContext = new Measurement_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 216, SubjectsVariables.RULE_measurement_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1237;
            this.match(SubjectsVariables.RF);
            this.state = 1238;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1239;
            this.measurement_related_entity_filter();
            this.state = 1240;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_related_entity_filter(): Measurement_related_entity_filterContext {
        let localContext = new Measurement_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 218, SubjectsVariables.RULE_measurement_related_entity_filter);
        try {
            this.state = 1244;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1242;
                this.provider_sub_filter();
                }
                break;
            case SubjectsVariables.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1243;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_error_filter(): Measurement_error_filterContext {
        let localContext = new Measurement_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 220, SubjectsVariables.RULE_measurement_error_filter);
        let _la: number;
        try {
            this.state = 1357;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 61, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1246;
                this.match(SubjectsVariables.CF);
                this.state = 1247;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1248;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1249;
                this.match(SubjectsVariables.CF);
                this.state = 1250;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1251;
                this.match(SubjectsVariables.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 1252;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1253;
                this.match(SubjectsVariables.CF);
                this.state = 1254;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1255;
                this.match(SubjectsVariables.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 1256;
                this.match(SubjectsVariables.IN);
                this.state = 1257;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1258;
                this.match(SubjectsVariables.CF);
                this.state = 1259;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1260;
                this.match(SubjectsVariables.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 1261;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1262;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1263;
                this.match(SubjectsVariables.CF);
                this.state = 1264;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1265;
                this.match(SubjectsVariables.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1266;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1267;
                this.match(SubjectsVariables.CF);
                this.state = 1268;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1269;
                this.match(SubjectsVariables.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1270;
                this.match(SubjectsVariables.IN);
                this.state = 1271;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1272;
                this.match(SubjectsVariables.CF);
                this.state = 1273;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1274;
                this.match(SubjectsVariables.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1275;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1276;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1277;
                this.match(SubjectsVariables.NF);
                this.state = 1278;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1279;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1280;
                this.match(SubjectsVariables.NF);
                this.state = 1281;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1282;
                _la = this.tokenStream.LA(1);
                if(!(_la === 158 || _la === 160)) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1283;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1284;
                this.match(SubjectsVariables.NF);
                this.state = 1285;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1286;
                _la = this.tokenStream.LA(1);
                if(!(_la === 158 || _la === 160)) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1287;
                this.comparison_op();
                this.state = 1288;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1290;
                this.match(SubjectsVariables.UF);
                this.state = 1291;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1292;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1293;
                this.match(SubjectsVariables.UF);
                this.state = 1294;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1295;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 1296;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1297;
                this.match(SubjectsVariables.UF);
                this.state = 1298;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1299;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 1300;
                this.simple_event_int();
                this.state = 1301;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1303;
                this.match(SubjectsVariables.UF);
                this.state = 1304;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1305;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 1306;
                this.simple_event_int();
                this.state = 1307;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 1308;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1310;
                this.match(SubjectsVariables.UF);
                this.state = 1311;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1312;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 1313;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1314;
                this.match(SubjectsVariables.UF);
                this.state = 1315;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1316;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 1317;
                this.simple_event_int();
                this.state = 1318;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1320;
                this.match(SubjectsVariables.UF);
                this.state = 1321;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1322;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 1323;
                this.simple_event_int();
                this.state = 1324;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 1325;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1327;
                this.match(SubjectsVariables.UF);
                this.state = 1328;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1329;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 1330;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1331;
                this.match(SubjectsVariables.UF);
                this.state = 1332;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1333;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 1334;
                this.simple_event_int();
                this.state = 1335;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1337;
                this.match(SubjectsVariables.UF);
                this.state = 1338;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1339;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 1340;
                this.simple_event_int();
                this.state = 1341;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 1342;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 1344;
                this.match(SubjectsVariables.RF);
                this.state = 1345;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1346;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 1347;
                this.match(SubjectsVariables.RF);
                this.state = 1348;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1349;
                this.provider_error_sub_filter();
                this.state = 1350;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 23:
                this.enterOuterAlt(localContext, 23);
                {
                this.state = 1352;
                this.match(SubjectsVariables.RF);
                this.state = 1353;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1354;
                this.visit_occurrence_error_sub_filter();
                this.state = 1355;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_criteria(): Observation_event_criteriaContext {
        let localContext = new Observation_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 222, SubjectsVariables.RULE_observation_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1359;
            this.observation_event_filter();
            this.state = 1364;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 1360;
                this.match(SubjectsVariables.COMMA);
                this.state = 1361;
                this.observation_event_filter();
                }
                }
                this.state = 1366;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_filter(): Observation_event_filterContext {
        let localContext = new Observation_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 224, SubjectsVariables.RULE_observation_event_filter);
        try {
            this.state = 1372;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 63, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1367;
                this.observation_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1368;
                this.observation_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1369;
                this.observation_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1370;
                this.observation_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1371;
                this.observation_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_filters(): Observation_concept_filtersContext {
        let localContext = new Observation_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 226, SubjectsVariables.RULE_observation_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1374;
            this.match(SubjectsVariables.CF);
            this.state = 1375;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1378;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 64, this.context) ) {
            case 1:
                {
                this.state = 1376;
                this.observation_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1377;
                this.observation_concept_filter();
                }
                break;
            }
            this.state = 1380;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_group_filter(): Observation_concept_group_filterContext {
        let localContext = new Observation_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 228, SubjectsVariables.RULE_observation_concept_group_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1382;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 165 || _la === 170)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1383;
            this.match(SubjectsVariables.IN);
            this.state = 1384;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_filter(): Observation_concept_filterContext {
        let localContext = new Observation_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 230, SubjectsVariables.RULE_observation_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1386;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 165 || _la === 170)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1387;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 85 || _la === 91)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1388;
            this.match(SubjectsVariables.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_numeric_filters(): Observation_numeric_filtersContext {
        let localContext = new Observation_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 232, SubjectsVariables.RULE_observation_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1390;
            this.match(SubjectsVariables.NF);
            this.state = 1391;
            this.match(SubjectsVariables.OPEN_PAREN);
            {
            this.state = 1392;
            this.observation_float_filter();
            }
            this.state = 1393;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_float_filter(): Observation_float_filterContext {
        let localContext = new Observation_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 234, SubjectsVariables.RULE_observation_float_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1395;
            this.match(SubjectsVariables.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
            this.state = 1396;
            this.comparison_op();
            this.state = 1397;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_uniqueness_filters(): Observation_uniqueness_filtersContext {
        let localContext = new Observation_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 236, SubjectsVariables.RULE_observation_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1399;
            this.match(SubjectsVariables.UF);
            this.state = 1400;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1401;
            this.observation_uniqueness_filter();
            this.state = 1402;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_uniqueness_filter(): Observation_uniqueness_filterContext {
        let localContext = new Observation_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 238, SubjectsVariables.RULE_observation_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1406;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.MINIMUM_BETWEEN:
                {
                this.state = 1404;
                this.simple_uniqueness_filter();
                }
                break;
            case SubjectsVariables.FIXED_WINDOW:
            case SubjectsVariables.ROLLING_WINDOW:
                {
                this.state = 1405;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1408;
            this.match(SubjectsVariables.OBSERVATION_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_related_entity_filters(): Observation_related_entity_filtersContext {
        let localContext = new Observation_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 240, SubjectsVariables.RULE_observation_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1410;
            this.match(SubjectsVariables.RF);
            this.state = 1411;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1412;
            this.observation_related_entity_filter();
            this.state = 1413;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_related_entity_filter(): Observation_related_entity_filterContext {
        let localContext = new Observation_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 242, SubjectsVariables.RULE_observation_related_entity_filter);
        try {
            this.state = 1417;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1415;
                this.provider_sub_filter();
                }
                break;
            case SubjectsVariables.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1416;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_error_filter(): Observation_error_filterContext {
        let localContext = new Observation_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 244, SubjectsVariables.RULE_observation_error_filter);
        let _la: number;
        try {
            this.state = 1530;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 67, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1419;
                this.match(SubjectsVariables.CF);
                this.state = 1420;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1421;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1422;
                this.match(SubjectsVariables.CF);
                this.state = 1423;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1424;
                this.match(SubjectsVariables.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 1425;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1426;
                this.match(SubjectsVariables.CF);
                this.state = 1427;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1428;
                this.match(SubjectsVariables.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 1429;
                this.match(SubjectsVariables.IN);
                this.state = 1430;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1431;
                this.match(SubjectsVariables.CF);
                this.state = 1432;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1433;
                this.match(SubjectsVariables.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 1434;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1435;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1436;
                this.match(SubjectsVariables.CF);
                this.state = 1437;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1438;
                this.match(SubjectsVariables.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1439;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1440;
                this.match(SubjectsVariables.CF);
                this.state = 1441;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1442;
                this.match(SubjectsVariables.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1443;
                this.match(SubjectsVariables.IN);
                this.state = 1444;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1445;
                this.match(SubjectsVariables.CF);
                this.state = 1446;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1447;
                this.match(SubjectsVariables.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1448;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1449;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1450;
                this.match(SubjectsVariables.NF);
                this.state = 1451;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1452;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1453;
                this.match(SubjectsVariables.NF);
                this.state = 1454;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1455;
                this.match(SubjectsVariables.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
                this.state = 1456;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1457;
                this.match(SubjectsVariables.NF);
                this.state = 1458;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1459;
                this.match(SubjectsVariables.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
                this.state = 1460;
                this.comparison_op();
                this.state = 1461;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1463;
                this.match(SubjectsVariables.UF);
                this.state = 1464;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1465;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1466;
                this.match(SubjectsVariables.UF);
                this.state = 1467;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1468;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 1469;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1470;
                this.match(SubjectsVariables.UF);
                this.state = 1471;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1472;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 1473;
                this.simple_event_int();
                this.state = 1474;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1476;
                this.match(SubjectsVariables.UF);
                this.state = 1477;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1478;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 1479;
                this.simple_event_int();
                this.state = 1480;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 1481;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1483;
                this.match(SubjectsVariables.UF);
                this.state = 1484;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1485;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 1486;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1487;
                this.match(SubjectsVariables.UF);
                this.state = 1488;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1489;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 1490;
                this.simple_event_int();
                this.state = 1491;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1493;
                this.match(SubjectsVariables.UF);
                this.state = 1494;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1495;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 1496;
                this.simple_event_int();
                this.state = 1497;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 1498;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1500;
                this.match(SubjectsVariables.UF);
                this.state = 1501;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1502;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 1503;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1504;
                this.match(SubjectsVariables.UF);
                this.state = 1505;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1506;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 1507;
                this.simple_event_int();
                this.state = 1508;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1510;
                this.match(SubjectsVariables.UF);
                this.state = 1511;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1512;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 1513;
                this.simple_event_int();
                this.state = 1514;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 1515;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 1517;
                this.match(SubjectsVariables.RF);
                this.state = 1518;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1519;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 1520;
                this.match(SubjectsVariables.RF);
                this.state = 1521;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1522;
                this.provider_error_sub_filter();
                this.state = 1523;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 23:
                this.enterOuterAlt(localContext, 23);
                {
                this.state = 1525;
                this.match(SubjectsVariables.RF);
                this.state = 1526;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1527;
                this.visit_occurrence_error_sub_filter();
                this.state = 1528;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_criteria(): Procedure_occurrence_event_criteriaContext {
        let localContext = new Procedure_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 246, SubjectsVariables.RULE_procedure_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1532;
            this.procedure_occurrence_event_filter();
            this.state = 1537;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 1533;
                this.match(SubjectsVariables.COMMA);
                this.state = 1534;
                this.procedure_occurrence_event_filter();
                }
                }
                this.state = 1539;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_filter(): Procedure_occurrence_event_filterContext {
        let localContext = new Procedure_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 248, SubjectsVariables.RULE_procedure_occurrence_event_filter);
        try {
            this.state = 1545;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 69, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1540;
                this.procedure_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1541;
                this.procedure_occurrence_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1542;
                this.procedure_occurrence_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1543;
                this.procedure_occurrence_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1544;
                this.procedure_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_filters(): Procedure_occurrence_concept_filtersContext {
        let localContext = new Procedure_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 250, SubjectsVariables.RULE_procedure_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1547;
            this.match(SubjectsVariables.CF);
            this.state = 1548;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1551;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 70, this.context) ) {
            case 1:
                {
                this.state = 1549;
                this.procedure_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1550;
                this.procedure_occurrence_concept_filter();
                }
                break;
            }
            this.state = 1553;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_group_filter(): Procedure_occurrence_concept_group_filterContext {
        let localContext = new Procedure_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 252, SubjectsVariables.RULE_procedure_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1555;
            this.match(SubjectsVariables.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1556;
            this.match(SubjectsVariables.IN);
            this.state = 1557;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_filter(): Procedure_occurrence_concept_filterContext {
        let localContext = new Procedure_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 254, SubjectsVariables.RULE_procedure_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1559;
            this.match(SubjectsVariables.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1560;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 85 || _la === 91)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1561;
            this.match(SubjectsVariables.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_numeric_filters(): Procedure_occurrence_numeric_filtersContext {
        let localContext = new Procedure_occurrence_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 256, SubjectsVariables.RULE_procedure_occurrence_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1563;
            this.match(SubjectsVariables.NF);
            this.state = 1564;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1565;
            this.procedure_occurrence_int_filter();
            this.state = 1566;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_int_filter(): Procedure_occurrence_int_filterContext {
        let localContext = new Procedure_occurrence_int_filterContext(this.context, this.state);
        this.enterRule(localContext, 258, SubjectsVariables.RULE_procedure_occurrence_int_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1568;
            this.match(SubjectsVariables.QUANTITY);
            this.state = 1569;
            this.comparison_op();
            this.state = 1570;
            this.simple_event_int();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_uniqueness_filters(): Procedure_occurrence_uniqueness_filtersContext {
        let localContext = new Procedure_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 260, SubjectsVariables.RULE_procedure_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1572;
            this.match(SubjectsVariables.UF);
            this.state = 1573;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1574;
            this.procedure_occurrence_uniqueness_filter();
            this.state = 1575;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_uniqueness_filter(): Procedure_occurrence_uniqueness_filterContext {
        let localContext = new Procedure_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 262, SubjectsVariables.RULE_procedure_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1579;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.MINIMUM_BETWEEN:
                {
                this.state = 1577;
                this.simple_uniqueness_filter();
                }
                break;
            case SubjectsVariables.FIXED_WINDOW:
            case SubjectsVariables.ROLLING_WINDOW:
                {
                this.state = 1578;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1581;
            this.match(SubjectsVariables.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_related_entity_filters(): Procedure_occurrence_related_entity_filtersContext {
        let localContext = new Procedure_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 264, SubjectsVariables.RULE_procedure_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1583;
            this.match(SubjectsVariables.RF);
            this.state = 1584;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1585;
            this.procedure_occurrence_related_entity_filter();
            this.state = 1586;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_related_entity_filter(): Procedure_occurrence_related_entity_filterContext {
        let localContext = new Procedure_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 266, SubjectsVariables.RULE_procedure_occurrence_related_entity_filter);
        try {
            this.state = 1590;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1588;
                this.provider_sub_filter();
                }
                break;
            case SubjectsVariables.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1589;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_error_filter(): Procedure_occurrence_error_filterContext {
        let localContext = new Procedure_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 268, SubjectsVariables.RULE_procedure_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 1689;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 73, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1592;
                this.match(SubjectsVariables.CF);
                this.state = 1593;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1594;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1595;
                this.match(SubjectsVariables.CF);
                this.state = 1596;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1597;
                this.match(SubjectsVariables.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1598;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1599;
                this.match(SubjectsVariables.CF);
                this.state = 1600;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1601;
                this.match(SubjectsVariables.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1602;
                this.match(SubjectsVariables.IN);
                this.state = 1603;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1604;
                this.match(SubjectsVariables.CF);
                this.state = 1605;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1606;
                this.match(SubjectsVariables.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1607;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1608;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1609;
                this.match(SubjectsVariables.NF);
                this.state = 1610;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1611;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1612;
                this.match(SubjectsVariables.NF);
                this.state = 1613;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1614;
                this.match(SubjectsVariables.QUANTITY);
                this.state = 1615;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1616;
                this.match(SubjectsVariables.NF);
                this.state = 1617;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1618;
                this.match(SubjectsVariables.QUANTITY);
                this.state = 1619;
                this.comparison_op();
                this.state = 1620;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1622;
                this.match(SubjectsVariables.UF);
                this.state = 1623;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1624;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1625;
                this.match(SubjectsVariables.UF);
                this.state = 1626;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1627;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 1628;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1629;
                this.match(SubjectsVariables.UF);
                this.state = 1630;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1631;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 1632;
                this.simple_event_int();
                this.state = 1633;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1635;
                this.match(SubjectsVariables.UF);
                this.state = 1636;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1637;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 1638;
                this.simple_event_int();
                this.state = 1639;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 1640;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1642;
                this.match(SubjectsVariables.UF);
                this.state = 1643;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1644;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 1645;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1646;
                this.match(SubjectsVariables.UF);
                this.state = 1647;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1648;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 1649;
                this.simple_event_int();
                this.state = 1650;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1652;
                this.match(SubjectsVariables.UF);
                this.state = 1653;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1654;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 1655;
                this.simple_event_int();
                this.state = 1656;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 1657;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1659;
                this.match(SubjectsVariables.UF);
                this.state = 1660;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1661;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 1662;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1663;
                this.match(SubjectsVariables.UF);
                this.state = 1664;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1665;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 1666;
                this.simple_event_int();
                this.state = 1667;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1669;
                this.match(SubjectsVariables.UF);
                this.state = 1670;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1671;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 1672;
                this.simple_event_int();
                this.state = 1673;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 1674;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1676;
                this.match(SubjectsVariables.RF);
                this.state = 1677;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1678;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1679;
                this.match(SubjectsVariables.RF);
                this.state = 1680;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1681;
                this.provider_error_sub_filter();
                this.state = 1682;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1684;
                this.match(SubjectsVariables.RF);
                this.state = 1685;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1686;
                this.visit_occurrence_error_sub_filter();
                this.state = 1687;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_filters(): Provider_concept_filtersContext {
        let localContext = new Provider_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 270, SubjectsVariables.RULE_provider_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1691;
            this.match(SubjectsVariables.CF);
            this.state = 1692;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1695;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 74, this.context) ) {
            case 1:
                {
                this.state = 1693;
                this.provider_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1694;
                this.provider_concept_filter();
                }
                break;
            }
            this.state = 1697;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext {
        let localContext = new Provider_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 272, SubjectsVariables.RULE_provider_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1699;
            this.match(SubjectsVariables.PROVIDER_CONCEPT_ATTRIBUTE);
            this.state = 1700;
            this.match(SubjectsVariables.IN);
            this.state = 1701;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_filter(): Provider_concept_filterContext {
        let localContext = new Provider_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 274, SubjectsVariables.RULE_provider_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1703;
            this.match(SubjectsVariables.PROVIDER_CONCEPT_ATTRIBUTE);
            this.state = 1704;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 85 || _la === 91)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1705;
            this.match(SubjectsVariables.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_sub_filter(): Provider_sub_filterContext {
        let localContext = new Provider_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 276, SubjectsVariables.RULE_provider_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1707;
            this.match(SubjectsVariables.PROVIDER);
            this.state = 1710;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 75, this.context) ) {
            case 1:
                {
                this.state = 1708;
                this.provider_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1709;
                this.provider_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext {
        let localContext = new Provider_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 278, SubjectsVariables.RULE_provider_error_sub_filter);
        let _la: number;
        try {
            this.state = 1722;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 76, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1713;
                this.match(SubjectsVariables.PROVIDER);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1714;
                this.match(SubjectsVariables.PROVIDER);
                this.state = 1715;
                this.match(SubjectsVariables.PROVIDER_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1716;
                this.match(SubjectsVariables.PROVIDER);
                this.state = 1717;
                this.match(SubjectsVariables.PROVIDER_CONCEPT_ATTRIBUTE);
                this.state = 1718;
                this.match(SubjectsVariables.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1719;
                this.match(SubjectsVariables.PROVIDER);
                this.state = 1720;
                this.match(SubjectsVariables.PROVIDER_CONCEPT_ATTRIBUTE);
                this.state = 1721;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_criteria(): Visit_occurrence_event_criteriaContext {
        let localContext = new Visit_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 280, SubjectsVariables.RULE_visit_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1724;
            this.visit_occurrence_event_filter();
            this.state = 1729;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 1725;
                this.match(SubjectsVariables.COMMA);
                this.state = 1726;
                this.visit_occurrence_event_filter();
                }
                }
                this.state = 1731;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_filter(): Visit_occurrence_event_filterContext {
        let localContext = new Visit_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 282, SubjectsVariables.RULE_visit_occurrence_event_filter);
        try {
            this.state = 1736;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 78, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1732;
                this.visit_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1733;
                this.visit_occurrence_uniqueness_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1734;
                this.visit_occurrence_related_entity_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1735;
                this.visit_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_filters(): Visit_occurrence_concept_filtersContext {
        let localContext = new Visit_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 284, SubjectsVariables.RULE_visit_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1738;
            this.match(SubjectsVariables.CF);
            this.state = 1739;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1742;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 79, this.context) ) {
            case 1:
                {
                this.state = 1740;
                this.visit_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1741;
                this.visit_occurrence_concept_filter();
                }
                break;
            }
            this.state = 1744;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext {
        let localContext = new Visit_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 286, SubjectsVariables.RULE_visit_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1746;
            this.match(SubjectsVariables.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1747;
            this.match(SubjectsVariables.IN);
            this.state = 1748;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext {
        let localContext = new Visit_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 288, SubjectsVariables.RULE_visit_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1750;
            this.match(SubjectsVariables.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1751;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 85 || _la === 91)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1752;
            this.match(SubjectsVariables.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_uniqueness_filters(): Visit_occurrence_uniqueness_filtersContext {
        let localContext = new Visit_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 290, SubjectsVariables.RULE_visit_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1754;
            this.match(SubjectsVariables.UF);
            this.state = 1755;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1756;
            this.visit_occurrence_uniqueness_filter();
            this.state = 1757;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_uniqueness_filter(): Visit_occurrence_uniqueness_filterContext {
        let localContext = new Visit_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 292, SubjectsVariables.RULE_visit_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1761;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.MINIMUM_BETWEEN:
                {
                this.state = 1759;
                this.simple_uniqueness_filter();
                }
                break;
            case SubjectsVariables.FIXED_WINDOW:
            case SubjectsVariables.ROLLING_WINDOW:
                {
                this.state = 1760;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1763;
            this.match(SubjectsVariables.VISIT_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_related_entity_filters(): Visit_occurrence_related_entity_filtersContext {
        let localContext = new Visit_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 294, SubjectsVariables.RULE_visit_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1765;
            this.match(SubjectsVariables.RF);
            this.state = 1766;
            this.match(SubjectsVariables.OPEN_PAREN);
            this.state = 1767;
            this.visit_occurrence_related_entity_filter();
            this.state = 1768;
            this.match(SubjectsVariables.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_related_entity_filter(): Visit_occurrence_related_entity_filterContext {
        let localContext = new Visit_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 296, SubjectsVariables.RULE_visit_occurrence_related_entity_filter);
        try {
            this.state = 1772;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1770;
                this.provider_sub_filter();
                }
                break;
            case SubjectsVariables.CONDITION_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1771;
                this.condition_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext {
        let localContext = new Visit_occurrence_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 298, SubjectsVariables.RULE_visit_occurrence_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1774;
            this.match(SubjectsVariables.VISIT_OCCURRENCE);
            this.state = 1777;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 82, this.context) ) {
            case 1:
                {
                this.state = 1775;
                this.visit_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1776;
                this.visit_occurrence_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext {
        let localContext = new Visit_occurrence_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 300, SubjectsVariables.RULE_visit_occurrence_error_sub_filter);
        let _la: number;
        try {
            this.state = 1789;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 83, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1780;
                this.match(SubjectsVariables.VISIT_OCCURRENCE);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1781;
                this.match(SubjectsVariables.VISIT_OCCURRENCE);
                this.state = 1782;
                this.match(SubjectsVariables.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1783;
                this.match(SubjectsVariables.VISIT_OCCURRENCE);
                this.state = 1784;
                this.match(SubjectsVariables.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1785;
                this.match(SubjectsVariables.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1786;
                this.match(SubjectsVariables.VISIT_OCCURRENCE);
                this.state = 1787;
                this.match(SubjectsVariables.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1788;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_error_filter(): Visit_occurrence_error_filterContext {
        let localContext = new Visit_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 302, SubjectsVariables.RULE_visit_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 1875;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 84, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1791;
                this.match(SubjectsVariables.CF);
                this.state = 1792;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1793;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1794;
                this.match(SubjectsVariables.CF);
                this.state = 1795;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1796;
                this.match(SubjectsVariables.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1797;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1798;
                this.match(SubjectsVariables.CF);
                this.state = 1799;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1800;
                this.match(SubjectsVariables.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1801;
                this.match(SubjectsVariables.IN);
                this.state = 1802;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1803;
                this.match(SubjectsVariables.CF);
                this.state = 1804;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1805;
                this.match(SubjectsVariables.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1806;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 85 || _la === 91)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1807;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1808;
                this.match(SubjectsVariables.UF);
                this.state = 1809;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1810;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1811;
                this.match(SubjectsVariables.UF);
                this.state = 1812;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1813;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 1814;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1815;
                this.match(SubjectsVariables.UF);
                this.state = 1816;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1817;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 1818;
                this.simple_event_int();
                this.state = 1819;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1821;
                this.match(SubjectsVariables.UF);
                this.state = 1822;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1823;
                this.match(SubjectsVariables.MINIMUM_BETWEEN);
                this.state = 1824;
                this.simple_event_int();
                this.state = 1825;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 1826;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1828;
                this.match(SubjectsVariables.UF);
                this.state = 1829;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1830;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 1831;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1832;
                this.match(SubjectsVariables.UF);
                this.state = 1833;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1834;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 1835;
                this.simple_event_int();
                this.state = 1836;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1838;
                this.match(SubjectsVariables.UF);
                this.state = 1839;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1840;
                this.match(SubjectsVariables.FIXED_WINDOW);
                this.state = 1841;
                this.simple_event_int();
                this.state = 1842;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 1843;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1845;
                this.match(SubjectsVariables.UF);
                this.state = 1846;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1847;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 1848;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1849;
                this.match(SubjectsVariables.UF);
                this.state = 1850;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1851;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 1852;
                this.simple_event_int();
                this.state = 1853;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1855;
                this.match(SubjectsVariables.UF);
                this.state = 1856;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1857;
                this.match(SubjectsVariables.ROLLING_WINDOW);
                this.state = 1858;
                this.simple_event_int();
                this.state = 1859;
                this.match(SubjectsVariables.TIME_UNIT);
                this.state = 1860;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1862;
                this.match(SubjectsVariables.RF);
                this.state = 1863;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1864;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1865;
                this.match(SubjectsVariables.RF);
                this.state = 1866;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1867;
                this.provider_error_sub_filter();
                this.state = 1868;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1870;
                this.match(SubjectsVariables.RF);
                this.state = 1871;
                this.match(SubjectsVariables.OPEN_PAREN);
                this.state = 1872;
                this.condition_occurrence_error_sub_filter();
                this.state = 1873;
                this.match(SubjectsVariables.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public comparison_op(): Comparison_opContext {
        let localContext = new Comparison_opContext(this.context, this.state);
        this.enterRule(localContext, 304, SubjectsVariables.RULE_comparison_op);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1877;
            _la = this.tokenStream.LA(1);
            if(!(((((_la - 85)) & ~0x1F) === 0 && ((1 << (_la - 85)) & 1985) !== 0))) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext {
        let localContext = new Simple_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 306, SubjectsVariables.RULE_simple_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1879;
            this.match(SubjectsVariables.MINIMUM_BETWEEN);
            this.state = 1880;
            this.simple_event_int();
            this.state = 1881;
            this.match(SubjectsVariables.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext {
        let localContext = new Simple_uniqueness_filter_windowContext(this.context, this.state);
        this.enterRule(localContext, 308, SubjectsVariables.RULE_simple_uniqueness_filter_window);
        try {
            this.state = 1885;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case SubjectsVariables.FIXED_WINDOW:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1883;
                this.fixed_window_uniqueness_filter();
                }
                break;
            case SubjectsVariables.ROLLING_WINDOW:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1884;
                this.rolling_window_uniqueness_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public fixed_window_uniqueness_filter(): Fixed_window_uniqueness_filterContext {
        let localContext = new Fixed_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 310, SubjectsVariables.RULE_fixed_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1887;
            this.match(SubjectsVariables.FIXED_WINDOW);
            this.state = 1888;
            this.simple_event_int();
            this.state = 1889;
            this.match(SubjectsVariables.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public rolling_window_uniqueness_filter(): Rolling_window_uniqueness_filterContext {
        let localContext = new Rolling_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 312, SubjectsVariables.RULE_rolling_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1891;
            this.match(SubjectsVariables.ROLLING_WINDOW);
            this.state = 1892;
            this.simple_event_int();
            this.state = 1893;
            this.match(SubjectsVariables.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event_float(): Simple_event_floatContext {
        let localContext = new Simple_event_floatContext(this.context, this.state);
        this.enterRule(localContext, 314, SubjectsVariables.RULE_simple_event_float);
        let _la: number;
        try {
            this.state = 1903;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 88, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1895;
                this.simple_event_int();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1897;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
                if (_la === 76) {
                    {
                    this.state = 1896;
                    this.match(SubjectsVariables.INT);
                    }
                }

                this.state = 1899;
                this.match(SubjectsVariables.PERIOD);
                this.state = 1901;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
                if (_la === 76) {
                    {
                    this.state = 1900;
                    this.match(SubjectsVariables.INT);
                    }
                }

                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event_int(): Simple_event_intContext {
        let localContext = new Simple_event_intContext(this.context, this.state);
        this.enterRule(localContext, 316, SubjectsVariables.RULE_simple_event_int);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1905;
            this.match(SubjectsVariables.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        let localContext = new Concept_group_selectionContext(this.context, this.state);
        this.enterRule(localContext, 318, SubjectsVariables.RULE_concept_group_selection);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1907;
            this.match(SubjectsVariables.CONCEPT_GROUP);
            this.state = 1912;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 84) {
                {
                {
                this.state = 1908;
                this.match(SubjectsVariables.COMMA);
                this.state = 1909;
                this.match(SubjectsVariables.CONCEPT_GROUP);
                }
                }
                this.state = 1914;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }

    public static readonly _serializedATN: number[] = [
        4,1,182,1916,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,2,6,
        7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,12,2,13,7,
        13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,19,2,
        20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,2,26,7,
        26,2,27,7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,31,7,31,2,32,7,32,2,
        33,7,33,2,34,7,34,2,35,7,35,2,36,7,36,2,37,7,37,2,38,7,38,2,39,7,
        39,2,40,7,40,2,41,7,41,2,42,7,42,2,43,7,43,2,44,7,44,2,45,7,45,2,
        46,7,46,2,47,7,47,2,48,7,48,2,49,7,49,2,50,7,50,2,51,7,51,2,52,7,
        52,2,53,7,53,2,54,7,54,2,55,7,55,2,56,7,56,2,57,7,57,2,58,7,58,2,
        59,7,59,2,60,7,60,2,61,7,61,2,62,7,62,2,63,7,63,2,64,7,64,2,65,7,
        65,2,66,7,66,2,67,7,67,2,68,7,68,2,69,7,69,2,70,7,70,2,71,7,71,2,
        72,7,72,2,73,7,73,2,74,7,74,2,75,7,75,2,76,7,76,2,77,7,77,2,78,7,
        78,2,79,7,79,2,80,7,80,2,81,7,81,2,82,7,82,2,83,7,83,2,84,7,84,2,
        85,7,85,2,86,7,86,2,87,7,87,2,88,7,88,2,89,7,89,2,90,7,90,2,91,7,
        91,2,92,7,92,2,93,7,93,2,94,7,94,2,95,7,95,2,96,7,96,2,97,7,97,2,
        98,7,98,2,99,7,99,2,100,7,100,2,101,7,101,2,102,7,102,2,103,7,103,
        2,104,7,104,2,105,7,105,2,106,7,106,2,107,7,107,2,108,7,108,2,109,
        7,109,2,110,7,110,2,111,7,111,2,112,7,112,2,113,7,113,2,114,7,114,
        2,115,7,115,2,116,7,116,2,117,7,117,2,118,7,118,2,119,7,119,2,120,
        7,120,2,121,7,121,2,122,7,122,2,123,7,123,2,124,7,124,2,125,7,125,
        2,126,7,126,2,127,7,127,2,128,7,128,2,129,7,129,2,130,7,130,2,131,
        7,131,2,132,7,132,2,133,7,133,2,134,7,134,2,135,7,135,2,136,7,136,
        2,137,7,137,2,138,7,138,2,139,7,139,2,140,7,140,2,141,7,141,2,142,
        7,142,2,143,7,143,2,144,7,144,2,145,7,145,2,146,7,146,2,147,7,147,
        2,148,7,148,2,149,7,149,2,150,7,150,2,151,7,151,2,152,7,152,2,153,
        7,153,2,154,7,154,2,155,7,155,2,156,7,156,2,157,7,157,2,158,7,158,
        2,159,7,159,1,0,1,0,1,0,1,0,1,0,3,0,326,8,0,1,0,1,0,1,1,1,1,1,1,
        1,1,1,1,1,2,1,2,1,2,1,2,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,
        1,3,1,3,1,3,1,3,3,3,353,8,3,1,4,1,4,1,4,3,4,358,8,4,1,4,1,4,1,5,
        1,5,1,5,5,5,365,8,5,10,5,12,5,368,9,5,1,6,1,6,1,6,3,6,373,8,6,1,
        7,1,7,1,7,1,7,3,7,379,8,7,1,7,1,7,1,8,1,8,1,8,1,8,1,9,1,9,1,9,1,
        9,1,10,1,10,1,10,1,10,1,10,1,11,1,11,1,11,1,11,1,12,1,12,1,12,1,
        12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,
        12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,1,12,3,12,425,8,12,1,13,1,
        13,1,14,1,14,1,14,1,14,1,14,1,15,1,15,1,15,1,15,3,15,438,8,15,1,
        16,1,16,1,16,1,16,1,16,1,17,1,17,1,17,1,17,1,17,3,17,450,8,17,1,
        17,1,17,1,18,1,18,3,18,456,8,18,1,18,1,18,1,18,3,18,461,8,18,1,19,
        1,19,1,19,1,19,1,19,1,20,1,20,1,20,1,20,1,20,1,21,1,21,1,21,1,21,
        1,22,1,22,1,22,1,22,1,23,1,23,1,23,1,23,1,24,1,24,1,24,1,24,1,25,
        1,25,1,25,3,25,492,8,25,1,26,1,26,1,26,1,26,1,26,1,26,1,26,3,26,
        501,8,26,1,26,1,26,1,26,1,27,1,27,1,27,4,27,509,8,27,11,27,12,27,
        510,1,28,1,28,3,28,515,8,28,1,29,1,29,3,29,519,8,29,1,30,1,30,1,
        30,1,30,3,30,525,8,30,1,30,1,30,1,31,1,31,1,32,1,32,1,32,1,32,1,
        32,1,33,1,33,3,33,538,8,33,1,33,1,33,1,34,1,34,1,34,1,34,1,34,1,
        34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,
        34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,
        34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,
        34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,1,34,3,34,596,8,34,1,
        35,1,35,1,35,1,35,1,35,1,35,1,35,1,35,1,36,1,36,1,36,5,36,609,8,
        36,10,36,12,36,612,9,36,1,37,1,37,1,37,1,37,3,37,618,8,37,1,38,1,
        38,3,38,622,8,38,1,39,1,39,1,39,1,39,1,39,1,40,1,40,1,40,1,40,1,
        41,1,41,1,41,1,41,3,41,637,8,41,1,41,1,41,1,42,1,42,3,42,643,8,42,
        1,42,1,42,1,42,1,43,1,43,3,43,650,8,43,1,44,1,44,1,44,1,44,1,44,
        1,44,1,44,1,44,1,45,1,45,1,45,4,45,663,8,45,11,45,12,45,664,1,46,
        1,46,1,46,1,46,1,46,3,46,672,8,46,1,47,1,47,1,47,1,47,3,47,678,8,
        47,1,47,1,47,1,48,1,48,1,48,1,48,3,48,686,8,48,1,48,1,48,1,49,1,
        49,1,50,1,50,1,50,1,50,1,50,1,51,1,51,1,51,1,51,1,51,1,51,1,51,1,
        51,1,51,3,51,706,8,51,1,52,1,52,1,52,1,52,1,52,1,52,1,52,1,52,1,
        52,1,52,1,52,1,52,1,52,1,52,1,52,1,52,1,52,1,52,3,52,726,8,52,1,
        53,1,53,1,53,1,53,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,54,1,
        54,1,54,1,54,3,54,744,8,54,1,55,1,55,1,55,1,55,1,55,1,55,1,55,1,
        55,1,55,1,55,1,55,1,55,3,55,758,8,55,1,56,1,56,1,56,1,56,1,57,1,
        57,3,57,766,8,57,1,58,1,58,1,58,1,58,1,59,1,59,1,59,1,59,1,60,1,
        60,1,61,1,61,1,61,1,61,1,61,1,61,3,61,784,8,61,1,62,1,62,1,62,1,
        62,1,62,1,63,1,63,1,63,1,63,1,63,1,64,1,64,1,64,1,64,1,64,1,65,1,
        65,1,65,1,65,1,65,1,66,1,66,1,66,1,66,1,66,1,67,1,67,1,67,1,67,1,
        67,1,68,1,68,1,68,3,68,819,8,68,1,68,1,68,1,69,1,69,1,69,3,69,826,
        8,69,1,69,1,69,1,70,1,70,1,70,3,70,833,8,70,1,70,1,70,1,71,1,71,
        1,71,3,71,840,8,71,1,71,1,71,1,72,1,72,1,72,3,72,847,8,72,1,72,1,
        72,1,73,1,73,1,73,3,73,854,8,73,1,73,1,73,1,74,1,74,1,74,5,74,861,
        8,74,10,74,12,74,864,9,74,1,75,1,75,1,75,1,75,3,75,870,8,75,1,76,
        1,76,1,76,1,76,3,76,876,8,76,1,76,1,76,1,77,1,77,1,77,1,77,1,78,
        1,78,1,78,1,78,1,79,1,79,1,79,1,79,1,79,1,80,1,80,3,80,895,8,80,
        1,80,1,80,1,81,1,81,1,81,1,81,1,81,1,82,1,82,3,82,906,8,82,1,83,
        1,83,1,83,3,83,911,8,83,1,84,1,84,1,84,1,84,1,84,1,84,1,84,1,84,
        1,84,1,84,3,84,923,8,84,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,
        1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,
        1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,
        1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,
        1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,
        1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,
        1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,1,85,3,85,1009,
        8,85,1,86,1,86,1,86,5,86,1014,8,86,10,86,12,86,1017,9,86,1,87,1,
        87,1,87,1,87,1,87,3,87,1024,8,87,1,88,1,88,1,88,1,88,3,88,1030,8,
        88,1,88,1,88,1,89,1,89,1,89,1,89,1,90,1,90,1,90,1,90,1,91,1,91,1,
        91,1,91,3,91,1046,8,91,1,91,1,91,1,92,1,92,1,92,1,92,1,93,1,93,1,
        93,1,93,1,94,1,94,1,94,1,94,1,94,1,95,1,95,3,95,1065,8,95,1,95,1,
        95,1,96,1,96,1,96,1,96,1,96,1,97,1,97,3,97,1076,8,97,1,98,1,98,1,
        98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,
        98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,
        98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,
        98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,
        98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,
        98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,
        98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,
        98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,98,1,
        98,3,98,1185,8,98,1,99,1,99,1,99,5,99,1190,8,99,10,99,12,99,1193,
        9,99,1,100,1,100,1,100,1,100,1,100,3,100,1200,8,100,1,101,1,101,
        1,101,1,101,3,101,1206,8,101,1,101,1,101,1,102,1,102,1,102,1,102,
        1,103,1,103,1,103,1,103,1,104,1,104,1,104,1,104,1,104,1,105,1,105,
        1,105,1,105,1,106,1,106,1,106,1,106,1,106,1,107,1,107,3,107,1234,
        8,107,1,107,1,107,1,108,1,108,1,108,1,108,1,108,1,109,1,109,3,109,
        1245,8,109,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,
        1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,
        1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,
        1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,
        1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,
        1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,
        1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,
        1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,
        1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,
        1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,
        1,110,1,110,1,110,3,110,1358,8,110,1,111,1,111,1,111,5,111,1363,
        8,111,10,111,12,111,1366,9,111,1,112,1,112,1,112,1,112,1,112,3,112,
        1373,8,112,1,113,1,113,1,113,1,113,3,113,1379,8,113,1,113,1,113,
        1,114,1,114,1,114,1,114,1,115,1,115,1,115,1,115,1,116,1,116,1,116,
        1,116,1,116,1,117,1,117,1,117,1,117,1,118,1,118,1,118,1,118,1,118,
        1,119,1,119,3,119,1407,8,119,1,119,1,119,1,120,1,120,1,120,1,120,
        1,120,1,121,1,121,3,121,1418,8,121,1,122,1,122,1,122,1,122,1,122,
        1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,
        1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,
        1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,
        1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,
        1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,
        1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,
        1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,
        1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,
        1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,
        1,122,1,122,1,122,1,122,1,122,1,122,1,122,3,122,1531,8,122,1,123,
        1,123,1,123,5,123,1536,8,123,10,123,12,123,1539,9,123,1,124,1,124,
        1,124,1,124,1,124,3,124,1546,8,124,1,125,1,125,1,125,1,125,3,125,
        1552,8,125,1,125,1,125,1,126,1,126,1,126,1,126,1,127,1,127,1,127,
        1,127,1,128,1,128,1,128,1,128,1,128,1,129,1,129,1,129,1,129,1,130,
        1,130,1,130,1,130,1,130,1,131,1,131,3,131,1580,8,131,1,131,1,131,
        1,132,1,132,1,132,1,132,1,132,1,133,1,133,3,133,1591,8,133,1,134,
        1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,
        1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,
        1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,
        1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,
        1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,
        1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,
        1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,
        1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,
        1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,3,134,1690,8,134,
        1,135,1,135,1,135,1,135,3,135,1696,8,135,1,135,1,135,1,136,1,136,
        1,136,1,136,1,137,1,137,1,137,1,137,1,138,1,138,1,138,3,138,1711,
        8,138,1,139,1,139,1,139,1,139,1,139,1,139,1,139,1,139,1,139,1,139,
        3,139,1723,8,139,1,140,1,140,1,140,5,140,1728,8,140,10,140,12,140,
        1731,9,140,1,141,1,141,1,141,1,141,3,141,1737,8,141,1,142,1,142,
        1,142,1,142,3,142,1743,8,142,1,142,1,142,1,143,1,143,1,143,1,143,
        1,144,1,144,1,144,1,144,1,145,1,145,1,145,1,145,1,145,1,146,1,146,
        3,146,1762,8,146,1,146,1,146,1,147,1,147,1,147,1,147,1,147,1,148,
        1,148,3,148,1773,8,148,1,149,1,149,1,149,3,149,1778,8,149,1,150,
        1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,150,3,150,1790,
        8,150,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,
        1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,
        1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,
        1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,
        1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,
        1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,
        1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,
        1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,3,151,1876,8,151,
        1,152,1,152,1,153,1,153,1,153,1,153,1,154,1,154,3,154,1886,8,154,
        1,155,1,155,1,155,1,155,1,156,1,156,1,156,1,156,1,157,1,157,3,157,
        1898,8,157,1,157,1,157,3,157,1902,8,157,3,157,1904,8,157,1,158,1,
        158,1,159,1,159,1,159,5,159,1911,8,159,10,159,12,159,1914,9,159,
        1,159,0,0,160,0,2,4,6,8,10,12,14,16,18,20,22,24,26,28,30,32,34,36,
        38,40,42,44,46,48,50,52,54,56,58,60,62,64,66,68,70,72,74,76,78,80,
        82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,118,
        120,122,124,126,128,130,132,134,136,138,140,142,144,146,148,150,
        152,154,156,158,160,162,164,166,168,170,172,174,176,178,180,182,
        184,186,188,190,192,194,196,198,200,202,204,206,208,210,212,214,
        216,218,220,222,224,226,228,230,232,234,236,238,240,242,244,246,
        248,250,252,254,256,258,260,262,264,266,268,270,272,274,276,278,
        280,282,284,286,288,290,292,294,296,298,300,302,304,306,308,310,
        312,314,316,318,0,10,2,0,85,85,91,91,1,0,39,47,2,0,60,60,156,156,
        1,0,116,118,1,0,96,97,3,0,30,33,35,35,37,38,2,0,164,164,170,170,
        2,0,158,158,160,160,2,0,165,165,170,170,2,0,85,85,91,95,2013,0,320,
        1,0,0,0,2,329,1,0,0,0,4,334,1,0,0,0,6,352,1,0,0,0,8,354,1,0,0,0,
        10,361,1,0,0,0,12,372,1,0,0,0,14,374,1,0,0,0,16,382,1,0,0,0,18,386,
        1,0,0,0,20,390,1,0,0,0,22,395,1,0,0,0,24,424,1,0,0,0,26,426,1,0,
        0,0,28,428,1,0,0,0,30,437,1,0,0,0,32,439,1,0,0,0,34,444,1,0,0,0,
        36,455,1,0,0,0,38,462,1,0,0,0,40,467,1,0,0,0,42,472,1,0,0,0,44,476,
        1,0,0,0,46,480,1,0,0,0,48,484,1,0,0,0,50,491,1,0,0,0,52,493,1,0,
        0,0,54,505,1,0,0,0,56,514,1,0,0,0,58,518,1,0,0,0,60,520,1,0,0,0,
        62,528,1,0,0,0,64,530,1,0,0,0,66,537,1,0,0,0,68,595,1,0,0,0,70,597,
        1,0,0,0,72,605,1,0,0,0,74,617,1,0,0,0,76,621,1,0,0,0,78,623,1,0,
        0,0,80,628,1,0,0,0,82,632,1,0,0,0,84,642,1,0,0,0,86,649,1,0,0,0,
        88,651,1,0,0,0,90,659,1,0,0,0,92,671,1,0,0,0,94,673,1,0,0,0,96,681,
        1,0,0,0,98,689,1,0,0,0,100,691,1,0,0,0,102,705,1,0,0,0,104,725,1,
        0,0,0,106,727,1,0,0,0,108,743,1,0,0,0,110,757,1,0,0,0,112,759,1,
        0,0,0,114,765,1,0,0,0,116,767,1,0,0,0,118,771,1,0,0,0,120,775,1,
        0,0,0,122,783,1,0,0,0,124,785,1,0,0,0,126,790,1,0,0,0,128,795,1,
        0,0,0,130,800,1,0,0,0,132,805,1,0,0,0,134,810,1,0,0,0,136,815,1,
        0,0,0,138,822,1,0,0,0,140,829,1,0,0,0,142,836,1,0,0,0,144,843,1,
        0,0,0,146,850,1,0,0,0,148,857,1,0,0,0,150,869,1,0,0,0,152,871,1,
        0,0,0,154,879,1,0,0,0,156,883,1,0,0,0,158,887,1,0,0,0,160,894,1,
        0,0,0,162,898,1,0,0,0,164,905,1,0,0,0,166,907,1,0,0,0,168,922,1,
        0,0,0,170,1008,1,0,0,0,172,1010,1,0,0,0,174,1023,1,0,0,0,176,1025,
        1,0,0,0,178,1033,1,0,0,0,180,1037,1,0,0,0,182,1041,1,0,0,0,184,1049,
        1,0,0,0,186,1053,1,0,0,0,188,1057,1,0,0,0,190,1064,1,0,0,0,192,1068,
        1,0,0,0,194,1075,1,0,0,0,196,1184,1,0,0,0,198,1186,1,0,0,0,200,1199,
        1,0,0,0,202,1201,1,0,0,0,204,1209,1,0,0,0,206,1213,1,0,0,0,208,1217,
        1,0,0,0,210,1222,1,0,0,0,212,1226,1,0,0,0,214,1233,1,0,0,0,216,1237,
        1,0,0,0,218,1244,1,0,0,0,220,1357,1,0,0,0,222,1359,1,0,0,0,224,1372,
        1,0,0,0,226,1374,1,0,0,0,228,1382,1,0,0,0,230,1386,1,0,0,0,232,1390,
        1,0,0,0,234,1395,1,0,0,0,236,1399,1,0,0,0,238,1406,1,0,0,0,240,1410,
        1,0,0,0,242,1417,1,0,0,0,244,1530,1,0,0,0,246,1532,1,0,0,0,248,1545,
        1,0,0,0,250,1547,1,0,0,0,252,1555,1,0,0,0,254,1559,1,0,0,0,256,1563,
        1,0,0,0,258,1568,1,0,0,0,260,1572,1,0,0,0,262,1579,1,0,0,0,264,1583,
        1,0,0,0,266,1590,1,0,0,0,268,1689,1,0,0,0,270,1691,1,0,0,0,272,1699,
        1,0,0,0,274,1703,1,0,0,0,276,1707,1,0,0,0,278,1722,1,0,0,0,280,1724,
        1,0,0,0,282,1736,1,0,0,0,284,1738,1,0,0,0,286,1746,1,0,0,0,288,1750,
        1,0,0,0,290,1754,1,0,0,0,292,1761,1,0,0,0,294,1765,1,0,0,0,296,1772,
        1,0,0,0,298,1774,1,0,0,0,300,1789,1,0,0,0,302,1875,1,0,0,0,304,1877,
        1,0,0,0,306,1879,1,0,0,0,308,1885,1,0,0,0,310,1887,1,0,0,0,312,1891,
        1,0,0,0,314,1903,1,0,0,0,316,1905,1,0,0,0,318,1907,1,0,0,0,320,321,
        5,61,0,0,321,325,5,85,0,0,322,326,3,8,4,0,323,326,3,2,1,0,324,326,
        3,6,3,0,325,322,1,0,0,0,325,323,1,0,0,0,325,324,1,0,0,0,326,327,
        1,0,0,0,327,328,5,83,0,0,328,1,1,0,0,0,329,330,5,99,0,0,330,331,
        5,81,0,0,331,332,3,4,2,0,332,333,5,82,0,0,333,3,1,0,0,0,334,335,
        3,26,13,0,335,336,3,304,152,0,336,337,5,76,0,0,337,5,1,0,0,0,338,
        339,5,99,0,0,339,340,5,81,0,0,340,353,5,82,0,0,341,342,5,99,0,0,
        342,343,5,81,0,0,343,344,3,26,13,0,344,345,5,82,0,0,345,353,1,0,
        0,0,346,347,5,99,0,0,347,348,5,81,0,0,348,349,3,26,13,0,349,350,
        3,304,152,0,350,351,5,82,0,0,351,353,1,0,0,0,352,338,1,0,0,0,352,
        341,1,0,0,0,352,346,1,0,0,0,353,7,1,0,0,0,354,355,5,128,0,0,355,
        357,5,81,0,0,356,358,3,10,5,0,357,356,1,0,0,0,357,358,1,0,0,0,358,
        359,1,0,0,0,359,360,5,82,0,0,360,9,1,0,0,0,361,366,3,12,6,0,362,
        363,5,84,0,0,363,365,3,12,6,0,364,362,1,0,0,0,365,368,1,0,0,0,366,
        364,1,0,0,0,366,367,1,0,0,0,367,11,1,0,0,0,368,366,1,0,0,0,369,373,
        3,14,7,0,370,373,3,20,10,0,371,373,3,24,12,0,372,369,1,0,0,0,372,
        370,1,0,0,0,372,371,1,0,0,0,373,13,1,0,0,0,374,375,5,14,0,0,375,
        378,5,81,0,0,376,379,3,16,8,0,377,379,3,18,9,0,378,376,1,0,0,0,378,
        377,1,0,0,0,379,380,1,0,0,0,380,381,5,82,0,0,381,15,1,0,0,0,382,
        383,5,166,0,0,383,384,5,102,0,0,384,385,3,318,159,0,385,17,1,0,0,
        0,386,387,5,166,0,0,387,388,7,0,0,0,388,389,5,64,0,0,389,19,1,0,
        0,0,390,391,5,17,0,0,391,392,5,81,0,0,392,393,3,22,11,0,393,394,
        5,82,0,0,394,21,1,0,0,0,395,396,5,159,0,0,396,397,3,304,152,0,397,
        398,5,76,0,0,398,23,1,0,0,0,399,400,5,14,0,0,400,401,5,81,0,0,401,
        425,5,82,0,0,402,403,5,14,0,0,403,404,5,81,0,0,404,405,5,166,0,0,
        405,425,5,82,0,0,406,407,5,14,0,0,407,408,5,81,0,0,408,409,5,166,
        0,0,409,410,5,102,0,0,410,425,5,82,0,0,411,412,5,17,0,0,412,413,
        5,81,0,0,413,425,5,82,0,0,414,415,5,17,0,0,415,416,5,81,0,0,416,
        417,5,159,0,0,417,425,5,82,0,0,418,419,5,17,0,0,419,420,5,81,0,0,
        420,421,5,159,0,0,421,422,3,304,152,0,422,423,5,82,0,0,423,425,1,
        0,0,0,424,399,1,0,0,0,424,402,1,0,0,0,424,406,1,0,0,0,424,411,1,
        0,0,0,424,414,1,0,0,0,424,418,1,0,0,0,425,25,1,0,0,0,426,427,7,1,
        0,0,427,27,1,0,0,0,428,429,5,1,0,0,429,430,5,85,0,0,430,431,3,30,
        15,0,431,432,5,83,0,0,432,29,1,0,0,0,433,438,3,32,16,0,434,438,3,
        42,21,0,435,438,3,34,17,0,436,438,3,44,22,0,437,433,1,0,0,0,437,
        434,1,0,0,0,437,435,1,0,0,0,437,436,1,0,0,0,438,31,1,0,0,0,439,440,
        5,3,0,0,440,441,5,81,0,0,441,442,5,80,0,0,442,443,5,82,0,0,443,33,
        1,0,0,0,444,445,5,2,0,0,445,446,5,81,0,0,446,449,7,2,0,0,447,448,
        5,84,0,0,448,450,3,36,18,0,449,447,1,0,0,0,449,450,1,0,0,0,450,451,
        1,0,0,0,451,452,5,82,0,0,452,35,1,0,0,0,453,456,3,40,20,0,454,456,
        3,46,23,0,455,453,1,0,0,0,455,454,1,0,0,0,456,457,1,0,0,0,457,460,
        5,84,0,0,458,461,3,38,19,0,459,461,3,48,24,0,460,458,1,0,0,0,460,
        459,1,0,0,0,461,37,1,0,0,0,462,463,5,4,0,0,463,464,5,81,0,0,464,
        465,5,80,0,0,465,466,5,82,0,0,466,39,1,0,0,0,467,468,5,5,0,0,468,
        469,5,81,0,0,469,470,5,80,0,0,470,471,5,82,0,0,471,41,1,0,0,0,472,
        473,5,3,0,0,473,474,5,81,0,0,474,475,5,82,0,0,475,43,1,0,0,0,476,
        477,5,2,0,0,477,478,5,81,0,0,478,479,5,82,0,0,479,45,1,0,0,0,480,
        481,5,5,0,0,481,482,5,81,0,0,482,483,5,82,0,0,483,47,1,0,0,0,484,
        485,5,4,0,0,485,486,5,81,0,0,486,487,5,82,0,0,487,49,1,0,0,0,488,
        492,3,52,26,0,489,492,3,70,35,0,490,492,3,88,44,0,491,488,1,0,0,
        0,491,489,1,0,0,0,491,490,1,0,0,0,492,51,1,0,0,0,493,494,5,58,0,
        0,494,495,5,85,0,0,495,496,5,71,0,0,496,497,5,81,0,0,497,500,3,54,
        27,0,498,499,5,84,0,0,499,501,3,58,29,0,500,498,1,0,0,0,500,501,
        1,0,0,0,501,502,1,0,0,0,502,503,5,82,0,0,503,504,5,83,0,0,504,53,
        1,0,0,0,505,508,3,56,28,0,506,507,5,84,0,0,507,509,3,56,28,0,508,
        506,1,0,0,0,509,510,1,0,0,0,510,508,1,0,0,0,510,511,1,0,0,0,511,
        55,1,0,0,0,512,515,3,60,30,0,513,515,3,110,55,0,514,512,1,0,0,0,
        514,513,1,0,0,0,515,57,1,0,0,0,516,519,3,62,31,0,517,519,3,68,34,
        0,518,516,1,0,0,0,518,517,1,0,0,0,519,59,1,0,0,0,520,521,5,74,0,
        0,521,524,5,81,0,0,522,525,3,104,52,0,523,525,3,106,53,0,524,522,
        1,0,0,0,524,523,1,0,0,0,525,526,1,0,0,0,526,527,5,82,0,0,527,61,
        1,0,0,0,528,529,3,64,32,0,529,63,1,0,0,0,530,531,5,23,0,0,531,532,
        5,81,0,0,532,533,3,66,33,0,533,534,5,82,0,0,534,65,1,0,0,0,535,538,
        3,112,56,0,536,538,3,114,57,0,537,535,1,0,0,0,537,536,1,0,0,0,538,
        539,1,0,0,0,539,540,5,6,0,0,540,67,1,0,0,0,541,542,5,23,0,0,542,
        543,5,81,0,0,543,596,5,82,0,0,544,545,5,23,0,0,545,546,5,81,0,0,
        546,547,5,116,0,0,547,596,5,82,0,0,548,549,5,23,0,0,549,550,5,81,
        0,0,550,551,5,116,0,0,551,552,3,120,60,0,552,553,5,82,0,0,553,596,
        1,0,0,0,554,555,5,23,0,0,555,556,5,81,0,0,556,557,5,116,0,0,557,
        558,3,120,60,0,558,559,5,111,0,0,559,560,5,82,0,0,560,596,1,0,0,
        0,561,562,5,23,0,0,562,563,5,81,0,0,563,564,5,119,0,0,564,596,5,
        82,0,0,565,566,5,23,0,0,566,567,5,81,0,0,567,568,5,119,0,0,568,569,
        3,120,60,0,569,570,5,82,0,0,570,596,1,0,0,0,571,572,5,23,0,0,572,
        573,5,81,0,0,573,574,5,119,0,0,574,575,3,120,60,0,575,576,5,111,
        0,0,576,577,5,82,0,0,577,596,1,0,0,0,578,579,5,23,0,0,579,580,5,
        81,0,0,580,581,5,120,0,0,581,596,5,82,0,0,582,583,5,23,0,0,583,584,
        5,81,0,0,584,585,5,120,0,0,585,586,3,120,60,0,586,587,5,82,0,0,587,
        596,1,0,0,0,588,589,5,23,0,0,589,590,5,81,0,0,590,591,5,120,0,0,
        591,592,3,120,60,0,592,593,5,111,0,0,593,594,5,82,0,0,594,596,1,
        0,0,0,595,541,1,0,0,0,595,544,1,0,0,0,595,548,1,0,0,0,595,554,1,
        0,0,0,595,561,1,0,0,0,595,565,1,0,0,0,595,571,1,0,0,0,595,578,1,
        0,0,0,595,582,1,0,0,0,595,588,1,0,0,0,596,69,1,0,0,0,597,598,5,59,
        0,0,598,599,5,85,0,0,599,600,5,72,0,0,600,601,5,81,0,0,601,602,3,
        72,36,0,602,603,5,82,0,0,603,604,5,83,0,0,604,71,1,0,0,0,605,610,
        3,74,37,0,606,607,5,84,0,0,607,609,3,74,37,0,608,606,1,0,0,0,609,
        612,1,0,0,0,610,608,1,0,0,0,610,611,1,0,0,0,611,73,1,0,0,0,612,610,
        1,0,0,0,613,618,3,76,38,0,614,618,3,82,41,0,615,618,3,108,54,0,616,
        618,3,110,55,0,617,613,1,0,0,0,617,614,1,0,0,0,617,615,1,0,0,0,617,
        616,1,0,0,0,618,75,1,0,0,0,619,622,5,8,0,0,620,622,3,78,39,0,621,
        619,1,0,0,0,621,620,1,0,0,0,622,77,1,0,0,0,623,624,5,10,0,0,624,
        625,5,81,0,0,625,626,3,80,40,0,626,627,5,82,0,0,627,79,1,0,0,0,628,
        629,7,3,0,0,629,630,5,76,0,0,630,631,5,111,0,0,631,81,1,0,0,0,632,
        633,5,74,0,0,633,636,5,81,0,0,634,637,3,84,42,0,635,637,3,86,43,
        0,636,634,1,0,0,0,636,635,1,0,0,0,637,638,1,0,0,0,638,639,5,82,0,
        0,639,83,1,0,0,0,640,643,3,104,52,0,641,643,3,106,53,0,642,640,1,
        0,0,0,642,641,1,0,0,0,643,644,1,0,0,0,644,645,5,84,0,0,645,646,5,
        9,0,0,646,85,1,0,0,0,647,650,3,104,52,0,648,650,3,106,53,0,649,647,
        1,0,0,0,649,648,1,0,0,0,650,87,1,0,0,0,651,652,5,60,0,0,652,653,
        5,85,0,0,653,654,5,73,0,0,654,655,5,81,0,0,655,656,3,90,45,0,656,
        657,5,82,0,0,657,658,5,83,0,0,658,89,1,0,0,0,659,662,3,92,46,0,660,
        661,5,84,0,0,661,663,3,92,46,0,662,660,1,0,0,0,663,664,1,0,0,0,664,
        662,1,0,0,0,664,665,1,0,0,0,665,91,1,0,0,0,666,672,1,0,0,0,667,672,
        3,94,47,0,668,672,3,110,55,0,669,672,3,96,48,0,670,672,3,102,51,
        0,671,666,1,0,0,0,671,667,1,0,0,0,671,668,1,0,0,0,671,669,1,0,0,
        0,671,670,1,0,0,0,672,93,1,0,0,0,673,674,5,74,0,0,674,677,5,81,0,
        0,675,678,3,104,52,0,676,678,3,106,53,0,677,675,1,0,0,0,677,676,
        1,0,0,0,678,679,1,0,0,0,679,680,5,82,0,0,680,95,1,0,0,0,681,682,
        5,13,0,0,682,685,5,81,0,0,683,686,3,98,49,0,684,686,3,100,50,0,685,
        683,1,0,0,0,685,684,1,0,0,0,686,687,1,0,0,0,687,688,5,82,0,0,688,
        97,1,0,0,0,689,690,7,4,0,0,690,99,1,0,0,0,691,692,5,110,0,0,692,
        693,5,81,0,0,693,694,5,76,0,0,694,695,5,82,0,0,695,101,1,0,0,0,696,
        697,5,13,0,0,697,698,5,81,0,0,698,706,5,82,0,0,699,700,5,13,0,0,
        700,701,5,81,0,0,701,702,5,110,0,0,702,703,5,81,0,0,703,704,5,82,
        0,0,704,706,5,82,0,0,705,696,1,0,0,0,705,699,1,0,0,0,706,103,1,0,
        0,0,707,708,5,30,0,0,708,709,5,121,0,0,709,726,5,150,0,0,710,711,
        5,31,0,0,711,712,5,121,0,0,712,726,5,151,0,0,713,714,5,32,0,0,714,
        715,5,121,0,0,715,726,5,152,0,0,716,717,5,33,0,0,717,718,5,121,0,
        0,718,726,5,153,0,0,719,720,5,35,0,0,720,721,5,121,0,0,721,726,5,
        154,0,0,722,723,5,37,0,0,723,724,5,121,0,0,724,726,5,155,0,0,725,
        707,1,0,0,0,725,710,1,0,0,0,725,713,1,0,0,0,725,716,1,0,0,0,725,
        719,1,0,0,0,725,722,1,0,0,0,726,105,1,0,0,0,727,728,5,38,0,0,728,
        729,5,121,0,0,729,730,5,6,0,0,730,107,1,0,0,0,731,732,5,10,0,0,732,
        733,5,81,0,0,733,744,5,82,0,0,734,735,5,10,0,0,735,736,5,81,0,0,
        736,737,7,3,0,0,737,744,5,82,0,0,738,739,5,10,0,0,739,740,5,81,0,
        0,740,741,7,3,0,0,741,742,5,76,0,0,742,744,5,82,0,0,743,731,1,0,
        0,0,743,734,1,0,0,0,743,738,1,0,0,0,744,109,1,0,0,0,745,746,5,74,
        0,0,746,747,5,81,0,0,747,758,5,82,0,0,748,749,5,74,0,0,749,750,5,
        81,0,0,750,751,7,5,0,0,751,758,5,82,0,0,752,753,5,74,0,0,753,754,
        5,81,0,0,754,755,7,5,0,0,755,756,5,121,0,0,756,758,5,82,0,0,757,
        745,1,0,0,0,757,748,1,0,0,0,757,752,1,0,0,0,758,111,1,0,0,0,759,
        760,5,116,0,0,760,761,3,120,60,0,761,762,5,111,0,0,762,113,1,0,0,
        0,763,766,3,116,58,0,764,766,3,118,59,0,765,763,1,0,0,0,765,764,
        1,0,0,0,766,115,1,0,0,0,767,768,5,119,0,0,768,769,3,120,60,0,769,
        770,5,111,0,0,770,117,1,0,0,0,771,772,5,120,0,0,772,773,3,120,60,
        0,773,774,5,111,0,0,774,119,1,0,0,0,775,776,5,76,0,0,776,121,1,0,
        0,0,777,784,3,124,62,0,778,784,3,126,63,0,779,784,3,128,64,0,780,
        784,3,130,65,0,781,784,3,132,66,0,782,784,3,134,67,0,783,777,1,0,
        0,0,783,778,1,0,0,0,783,779,1,0,0,0,783,780,1,0,0,0,783,781,1,0,
        0,0,783,782,1,0,0,0,784,123,1,0,0,0,785,786,5,50,0,0,786,787,5,85,
        0,0,787,788,3,136,68,0,788,789,5,83,0,0,789,125,1,0,0,0,790,791,
        5,51,0,0,791,792,5,85,0,0,792,793,3,138,69,0,793,794,5,83,0,0,794,
        127,1,0,0,0,795,796,5,52,0,0,796,797,5,85,0,0,797,798,3,140,70,0,
        798,799,5,83,0,0,799,129,1,0,0,0,800,801,5,53,0,0,801,802,5,85,0,
        0,802,803,3,142,71,0,803,804,5,83,0,0,804,131,1,0,0,0,805,806,5,
        55,0,0,806,807,5,85,0,0,807,808,3,144,72,0,808,809,5,83,0,0,809,
        133,1,0,0,0,810,811,5,57,0,0,811,812,5,85,0,0,812,813,3,146,73,0,
        813,814,5,83,0,0,814,135,1,0,0,0,815,816,5,124,0,0,816,818,5,81,
        0,0,817,819,3,148,74,0,818,817,1,0,0,0,818,819,1,0,0,0,819,820,1,
        0,0,0,820,821,5,82,0,0,821,137,1,0,0,0,822,823,5,125,0,0,823,825,
        5,81,0,0,824,826,3,172,86,0,825,824,1,0,0,0,825,826,1,0,0,0,826,
        827,1,0,0,0,827,828,5,82,0,0,828,139,1,0,0,0,829,830,5,126,0,0,830,
        832,5,81,0,0,831,833,3,198,99,0,832,831,1,0,0,0,832,833,1,0,0,0,
        833,834,1,0,0,0,834,835,5,82,0,0,835,141,1,0,0,0,836,837,5,127,0,
        0,837,839,5,81,0,0,838,840,3,222,111,0,839,838,1,0,0,0,839,840,1,
        0,0,0,840,841,1,0,0,0,841,842,5,82,0,0,842,143,1,0,0,0,843,844,5,
        129,0,0,844,846,5,81,0,0,845,847,3,246,123,0,846,845,1,0,0,0,846,
        847,1,0,0,0,847,848,1,0,0,0,848,849,5,82,0,0,849,145,1,0,0,0,850,
        851,5,131,0,0,851,853,5,81,0,0,852,854,3,280,140,0,853,852,1,0,0,
        0,853,854,1,0,0,0,854,855,1,0,0,0,855,856,5,82,0,0,856,147,1,0,0,
        0,857,862,3,150,75,0,858,859,5,84,0,0,859,861,3,150,75,0,860,858,
        1,0,0,0,861,864,1,0,0,0,862,860,1,0,0,0,862,863,1,0,0,0,863,149,
        1,0,0,0,864,862,1,0,0,0,865,870,3,152,76,0,866,870,3,158,79,0,867,
        870,3,162,81,0,868,870,3,170,85,0,869,865,1,0,0,0,869,866,1,0,0,
        0,869,867,1,0,0,0,869,868,1,0,0,0,870,151,1,0,0,0,871,872,5,14,0,
        0,872,875,5,81,0,0,873,876,3,154,77,0,874,876,3,156,78,0,875,873,
        1,0,0,0,875,874,1,0,0,0,876,877,1,0,0,0,877,878,5,82,0,0,878,153,
        1,0,0,0,879,880,5,162,0,0,880,881,5,102,0,0,881,882,3,318,159,0,
        882,155,1,0,0,0,883,884,5,162,0,0,884,885,7,0,0,0,885,886,5,64,0,
        0,886,157,1,0,0,0,887,888,5,23,0,0,888,889,5,81,0,0,889,890,3,160,
        80,0,890,891,5,82,0,0,891,159,1,0,0,0,892,895,3,306,153,0,893,895,
        3,308,154,0,894,892,1,0,0,0,894,893,1,0,0,0,895,896,1,0,0,0,896,
        897,5,150,0,0,897,161,1,0,0,0,898,899,5,26,0,0,899,900,5,81,0,0,
        900,901,3,164,82,0,901,902,5,82,0,0,902,163,1,0,0,0,903,906,3,276,
        138,0,904,906,3,298,149,0,905,903,1,0,0,0,905,904,1,0,0,0,906,165,
        1,0,0,0,907,910,5,124,0,0,908,911,3,154,77,0,909,911,3,156,78,0,
        910,908,1,0,0,0,910,909,1,0,0,0,911,167,1,0,0,0,912,923,1,0,0,0,
        913,923,5,124,0,0,914,915,5,124,0,0,915,923,5,162,0,0,916,917,5,
        124,0,0,917,918,5,162,0,0,918,923,5,102,0,0,919,920,5,124,0,0,920,
        921,5,162,0,0,921,923,7,0,0,0,922,912,1,0,0,0,922,913,1,0,0,0,922,
        914,1,0,0,0,922,916,1,0,0,0,922,919,1,0,0,0,923,169,1,0,0,0,924,
        925,5,14,0,0,925,926,5,81,0,0,926,1009,5,82,0,0,927,928,5,14,0,0,
        928,929,5,81,0,0,929,930,5,162,0,0,930,1009,5,82,0,0,931,932,5,14,
        0,0,932,933,5,81,0,0,933,934,5,162,0,0,934,935,5,102,0,0,935,1009,
        5,82,0,0,936,937,5,14,0,0,937,938,5,81,0,0,938,939,5,162,0,0,939,
        940,7,0,0,0,940,1009,5,82,0,0,941,942,5,23,0,0,942,943,5,81,0,0,
        943,1009,5,82,0,0,944,945,5,23,0,0,945,946,5,81,0,0,946,947,5,116,
        0,0,947,1009,5,82,0,0,948,949,5,23,0,0,949,950,5,81,0,0,950,951,
        5,116,0,0,951,952,3,316,158,0,952,953,5,82,0,0,953,1009,1,0,0,0,
        954,955,5,23,0,0,955,956,5,81,0,0,956,957,5,116,0,0,957,958,3,316,
        158,0,958,959,5,111,0,0,959,960,5,82,0,0,960,1009,1,0,0,0,961,962,
        5,23,0,0,962,963,5,81,0,0,963,964,5,119,0,0,964,1009,5,82,0,0,965,
        966,5,23,0,0,966,967,5,81,0,0,967,968,5,119,0,0,968,969,3,316,158,
        0,969,970,5,82,0,0,970,1009,1,0,0,0,971,972,5,23,0,0,972,973,5,81,
        0,0,973,974,5,119,0,0,974,975,3,316,158,0,975,976,5,111,0,0,976,
        977,5,82,0,0,977,1009,1,0,0,0,978,979,5,23,0,0,979,980,5,81,0,0,
        980,981,5,120,0,0,981,1009,5,82,0,0,982,983,5,23,0,0,983,984,5,81,
        0,0,984,985,5,120,0,0,985,986,3,316,158,0,986,987,5,82,0,0,987,1009,
        1,0,0,0,988,989,5,23,0,0,989,990,5,81,0,0,990,991,5,120,0,0,991,
        992,3,316,158,0,992,993,5,111,0,0,993,994,5,82,0,0,994,1009,1,0,
        0,0,995,996,5,26,0,0,996,997,5,81,0,0,997,1009,5,82,0,0,998,999,
        5,26,0,0,999,1000,5,81,0,0,1000,1001,3,278,139,0,1001,1002,5,82,
        0,0,1002,1009,1,0,0,0,1003,1004,5,26,0,0,1004,1005,5,81,0,0,1005,
        1006,3,300,150,0,1006,1007,5,82,0,0,1007,1009,1,0,0,0,1008,924,1,
        0,0,0,1008,927,1,0,0,0,1008,931,1,0,0,0,1008,936,1,0,0,0,1008,941,
        1,0,0,0,1008,944,1,0,0,0,1008,948,1,0,0,0,1008,954,1,0,0,0,1008,
        961,1,0,0,0,1008,965,1,0,0,0,1008,971,1,0,0,0,1008,978,1,0,0,0,1008,
        982,1,0,0,0,1008,988,1,0,0,0,1008,995,1,0,0,0,1008,998,1,0,0,0,1008,
        1003,1,0,0,0,1009,171,1,0,0,0,1010,1015,3,174,87,0,1011,1012,5,84,
        0,0,1012,1014,3,174,87,0,1013,1011,1,0,0,0,1014,1017,1,0,0,0,1015,
        1013,1,0,0,0,1015,1016,1,0,0,0,1016,173,1,0,0,0,1017,1015,1,0,0,
        0,1018,1024,3,176,88,0,1019,1024,3,182,91,0,1020,1024,3,188,94,0,
        1021,1024,3,192,96,0,1022,1024,3,196,98,0,1023,1018,1,0,0,0,1023,
        1019,1,0,0,0,1023,1020,1,0,0,0,1023,1021,1,0,0,0,1023,1022,1,0,0,
        0,1024,175,1,0,0,0,1025,1026,5,14,0,0,1026,1029,5,81,0,0,1027,1030,
        3,178,89,0,1028,1030,3,180,90,0,1029,1027,1,0,0,0,1029,1028,1,0,
        0,0,1030,1031,1,0,0,0,1031,1032,5,82,0,0,1032,177,1,0,0,0,1033,1034,
        5,163,0,0,1034,1035,5,102,0,0,1035,1036,3,318,159,0,1036,179,1,0,
        0,0,1037,1038,5,163,0,0,1038,1039,7,0,0,0,1039,1040,5,64,0,0,1040,
        181,1,0,0,0,1041,1042,5,17,0,0,1042,1045,5,81,0,0,1043,1046,3,184,
        92,0,1044,1046,3,186,93,0,1045,1043,1,0,0,0,1045,1044,1,0,0,0,1046,
        1047,1,0,0,0,1047,1048,5,82,0,0,1048,183,1,0,0,0,1049,1050,5,161,
        0,0,1050,1051,3,304,152,0,1051,1052,3,314,157,0,1052,185,1,0,0,0,
        1053,1054,5,157,0,0,1054,1055,3,304,152,0,1055,1056,3,316,158,0,
        1056,187,1,0,0,0,1057,1058,5,23,0,0,1058,1059,5,81,0,0,1059,1060,
        3,190,95,0,1060,1061,5,82,0,0,1061,189,1,0,0,0,1062,1065,3,306,153,
        0,1063,1065,3,308,154,0,1064,1062,1,0,0,0,1064,1063,1,0,0,0,1065,
        1066,1,0,0,0,1066,1067,5,151,0,0,1067,191,1,0,0,0,1068,1069,5,26,
        0,0,1069,1070,5,81,0,0,1070,1071,3,194,97,0,1071,1072,5,82,0,0,1072,
        193,1,0,0,0,1073,1076,3,276,138,0,1074,1076,3,298,149,0,1075,1073,
        1,0,0,0,1075,1074,1,0,0,0,1076,195,1,0,0,0,1077,1078,5,14,0,0,1078,
        1079,5,81,0,0,1079,1185,5,82,0,0,1080,1081,5,14,0,0,1081,1082,5,
        81,0,0,1082,1083,5,163,0,0,1083,1185,5,82,0,0,1084,1085,5,14,0,0,
        1085,1086,5,81,0,0,1086,1087,5,163,0,0,1087,1088,5,102,0,0,1088,
        1185,5,82,0,0,1089,1090,5,14,0,0,1090,1091,5,81,0,0,1091,1092,5,
        163,0,0,1092,1093,7,0,0,0,1093,1185,5,82,0,0,1094,1095,5,17,0,0,
        1095,1096,5,81,0,0,1096,1185,5,82,0,0,1097,1098,5,17,0,0,1098,1099,
        5,81,0,0,1099,1100,5,161,0,0,1100,1185,5,82,0,0,1101,1102,5,17,0,
        0,1102,1103,5,81,0,0,1103,1104,5,161,0,0,1104,1105,3,304,152,0,1105,
        1106,5,82,0,0,1106,1185,1,0,0,0,1107,1108,5,17,0,0,1108,1109,5,81,
        0,0,1109,1110,5,157,0,0,1110,1185,5,82,0,0,1111,1112,5,17,0,0,1112,
        1113,5,81,0,0,1113,1114,5,157,0,0,1114,1115,3,304,152,0,1115,1116,
        5,82,0,0,1116,1185,1,0,0,0,1117,1118,5,23,0,0,1118,1119,5,81,0,0,
        1119,1185,5,82,0,0,1120,1121,5,23,0,0,1121,1122,5,81,0,0,1122,1123,
        5,116,0,0,1123,1185,5,82,0,0,1124,1125,5,23,0,0,1125,1126,5,81,0,
        0,1126,1127,5,116,0,0,1127,1128,3,316,158,0,1128,1129,5,82,0,0,1129,
        1185,1,0,0,0,1130,1131,5,23,0,0,1131,1132,5,81,0,0,1132,1133,5,116,
        0,0,1133,1134,3,316,158,0,1134,1135,5,111,0,0,1135,1136,5,82,0,0,
        1136,1185,1,0,0,0,1137,1138,5,23,0,0,1138,1139,5,81,0,0,1139,1140,
        5,119,0,0,1140,1185,5,82,0,0,1141,1142,5,23,0,0,1142,1143,5,81,0,
        0,1143,1144,5,119,0,0,1144,1145,3,316,158,0,1145,1146,5,82,0,0,1146,
        1185,1,0,0,0,1147,1148,5,23,0,0,1148,1149,5,81,0,0,1149,1150,5,119,
        0,0,1150,1151,3,316,158,0,1151,1152,5,111,0,0,1152,1153,5,82,0,0,
        1153,1185,1,0,0,0,1154,1155,5,23,0,0,1155,1156,5,81,0,0,1156,1157,
        5,120,0,0,1157,1185,5,82,0,0,1158,1159,5,23,0,0,1159,1160,5,81,0,
        0,1160,1161,5,120,0,0,1161,1162,3,316,158,0,1162,1163,5,82,0,0,1163,
        1185,1,0,0,0,1164,1165,5,23,0,0,1165,1166,5,81,0,0,1166,1167,5,120,
        0,0,1167,1168,3,316,158,0,1168,1169,5,111,0,0,1169,1170,5,82,0,0,
        1170,1185,1,0,0,0,1171,1172,5,26,0,0,1172,1173,5,81,0,0,1173,1185,
        5,82,0,0,1174,1175,5,26,0,0,1175,1176,5,81,0,0,1176,1177,3,278,139,
        0,1177,1178,5,82,0,0,1178,1185,1,0,0,0,1179,1180,5,26,0,0,1180,1181,
        5,81,0,0,1181,1182,3,300,150,0,1182,1183,5,82,0,0,1183,1185,1,0,
        0,0,1184,1077,1,0,0,0,1184,1080,1,0,0,0,1184,1084,1,0,0,0,1184,1089,
        1,0,0,0,1184,1094,1,0,0,0,1184,1097,1,0,0,0,1184,1101,1,0,0,0,1184,
        1107,1,0,0,0,1184,1111,1,0,0,0,1184,1117,1,0,0,0,1184,1120,1,0,0,
        0,1184,1124,1,0,0,0,1184,1130,1,0,0,0,1184,1137,1,0,0,0,1184,1141,
        1,0,0,0,1184,1147,1,0,0,0,1184,1154,1,0,0,0,1184,1158,1,0,0,0,1184,
        1164,1,0,0,0,1184,1171,1,0,0,0,1184,1174,1,0,0,0,1184,1179,1,0,0,
        0,1185,197,1,0,0,0,1186,1191,3,200,100,0,1187,1188,5,84,0,0,1188,
        1190,3,200,100,0,1189,1187,1,0,0,0,1190,1193,1,0,0,0,1191,1189,1,
        0,0,0,1191,1192,1,0,0,0,1192,199,1,0,0,0,1193,1191,1,0,0,0,1194,
        1200,3,202,101,0,1195,1200,3,208,104,0,1196,1200,3,212,106,0,1197,
        1200,3,216,108,0,1198,1200,3,220,110,0,1199,1194,1,0,0,0,1199,1195,
        1,0,0,0,1199,1196,1,0,0,0,1199,1197,1,0,0,0,1199,1198,1,0,0,0,1200,
        201,1,0,0,0,1201,1202,5,14,0,0,1202,1205,5,81,0,0,1203,1206,3,204,
        102,0,1204,1206,3,206,103,0,1205,1203,1,0,0,0,1205,1204,1,0,0,0,
        1206,1207,1,0,0,0,1207,1208,5,82,0,0,1208,203,1,0,0,0,1209,1210,
        7,6,0,0,1210,1211,5,102,0,0,1211,1212,3,318,159,0,1212,205,1,0,0,
        0,1213,1214,7,6,0,0,1214,1215,7,0,0,0,1215,1216,5,64,0,0,1216,207,
        1,0,0,0,1217,1218,5,17,0,0,1218,1219,5,81,0,0,1219,1220,3,210,105,
        0,1220,1221,5,82,0,0,1221,209,1,0,0,0,1222,1223,7,7,0,0,1223,1224,
        3,304,152,0,1224,1225,3,314,157,0,1225,211,1,0,0,0,1226,1227,5,23,
        0,0,1227,1228,5,81,0,0,1228,1229,3,214,107,0,1229,1230,5,82,0,0,
        1230,213,1,0,0,0,1231,1234,3,306,153,0,1232,1234,3,308,154,0,1233,
        1231,1,0,0,0,1233,1232,1,0,0,0,1234,1235,1,0,0,0,1235,1236,5,152,
        0,0,1236,215,1,0,0,0,1237,1238,5,26,0,0,1238,1239,5,81,0,0,1239,
        1240,3,218,109,0,1240,1241,5,82,0,0,1241,217,1,0,0,0,1242,1245,3,
        276,138,0,1243,1245,3,298,149,0,1244,1242,1,0,0,0,1244,1243,1,0,
        0,0,1245,219,1,0,0,0,1246,1247,5,14,0,0,1247,1248,5,81,0,0,1248,
        1358,5,82,0,0,1249,1250,5,14,0,0,1250,1251,5,81,0,0,1251,1252,5,
        164,0,0,1252,1358,5,82,0,0,1253,1254,5,14,0,0,1254,1255,5,81,0,0,
        1255,1256,5,164,0,0,1256,1257,5,102,0,0,1257,1358,5,82,0,0,1258,
        1259,5,14,0,0,1259,1260,5,81,0,0,1260,1261,5,164,0,0,1261,1262,7,
        0,0,0,1262,1358,5,82,0,0,1263,1264,5,14,0,0,1264,1265,5,81,0,0,1265,
        1266,5,170,0,0,1266,1358,5,82,0,0,1267,1268,5,14,0,0,1268,1269,5,
        81,0,0,1269,1270,5,170,0,0,1270,1271,5,102,0,0,1271,1358,5,82,0,
        0,1272,1273,5,14,0,0,1273,1274,5,81,0,0,1274,1275,5,170,0,0,1275,
        1276,7,0,0,0,1276,1358,5,82,0,0,1277,1278,5,17,0,0,1278,1279,5,81,
        0,0,1279,1358,5,82,0,0,1280,1281,5,17,0,0,1281,1282,5,81,0,0,1282,
        1283,7,7,0,0,1283,1358,5,82,0,0,1284,1285,5,17,0,0,1285,1286,5,81,
        0,0,1286,1287,7,7,0,0,1287,1288,3,304,152,0,1288,1289,5,82,0,0,1289,
        1358,1,0,0,0,1290,1291,5,23,0,0,1291,1292,5,81,0,0,1292,1358,5,82,
        0,0,1293,1294,5,23,0,0,1294,1295,5,81,0,0,1295,1296,5,116,0,0,1296,
        1358,5,82,0,0,1297,1298,5,23,0,0,1298,1299,5,81,0,0,1299,1300,5,
        116,0,0,1300,1301,3,316,158,0,1301,1302,5,82,0,0,1302,1358,1,0,0,
        0,1303,1304,5,23,0,0,1304,1305,5,81,0,0,1305,1306,5,116,0,0,1306,
        1307,3,316,158,0,1307,1308,5,111,0,0,1308,1309,5,82,0,0,1309,1358,
        1,0,0,0,1310,1311,5,23,0,0,1311,1312,5,81,0,0,1312,1313,5,119,0,
        0,1313,1358,5,82,0,0,1314,1315,5,23,0,0,1315,1316,5,81,0,0,1316,
        1317,5,119,0,0,1317,1318,3,316,158,0,1318,1319,5,82,0,0,1319,1358,
        1,0,0,0,1320,1321,5,23,0,0,1321,1322,5,81,0,0,1322,1323,5,119,0,
        0,1323,1324,3,316,158,0,1324,1325,5,111,0,0,1325,1326,5,82,0,0,1326,
        1358,1,0,0,0,1327,1328,5,23,0,0,1328,1329,5,81,0,0,1329,1330,5,120,
        0,0,1330,1358,5,82,0,0,1331,1332,5,23,0,0,1332,1333,5,81,0,0,1333,
        1334,5,120,0,0,1334,1335,3,316,158,0,1335,1336,5,82,0,0,1336,1358,
        1,0,0,0,1337,1338,5,23,0,0,1338,1339,5,81,0,0,1339,1340,5,120,0,
        0,1340,1341,3,316,158,0,1341,1342,5,111,0,0,1342,1343,5,82,0,0,1343,
        1358,1,0,0,0,1344,1345,5,26,0,0,1345,1346,5,81,0,0,1346,1358,5,82,
        0,0,1347,1348,5,26,0,0,1348,1349,5,81,0,0,1349,1350,3,278,139,0,
        1350,1351,5,82,0,0,1351,1358,1,0,0,0,1352,1353,5,26,0,0,1353,1354,
        5,81,0,0,1354,1355,3,300,150,0,1355,1356,5,82,0,0,1356,1358,1,0,
        0,0,1357,1246,1,0,0,0,1357,1249,1,0,0,0,1357,1253,1,0,0,0,1357,1258,
        1,0,0,0,1357,1263,1,0,0,0,1357,1267,1,0,0,0,1357,1272,1,0,0,0,1357,
        1277,1,0,0,0,1357,1280,1,0,0,0,1357,1284,1,0,0,0,1357,1290,1,0,0,
        0,1357,1293,1,0,0,0,1357,1297,1,0,0,0,1357,1303,1,0,0,0,1357,1310,
        1,0,0,0,1357,1314,1,0,0,0,1357,1320,1,0,0,0,1357,1327,1,0,0,0,1357,
        1331,1,0,0,0,1357,1337,1,0,0,0,1357,1344,1,0,0,0,1357,1347,1,0,0,
        0,1357,1352,1,0,0,0,1358,221,1,0,0,0,1359,1364,3,224,112,0,1360,
        1361,5,84,0,0,1361,1363,3,224,112,0,1362,1360,1,0,0,0,1363,1366,
        1,0,0,0,1364,1362,1,0,0,0,1364,1365,1,0,0,0,1365,223,1,0,0,0,1366,
        1364,1,0,0,0,1367,1373,3,226,113,0,1368,1373,3,232,116,0,1369,1373,
        3,236,118,0,1370,1373,3,240,120,0,1371,1373,3,244,122,0,1372,1367,
        1,0,0,0,1372,1368,1,0,0,0,1372,1369,1,0,0,0,1372,1370,1,0,0,0,1372,
        1371,1,0,0,0,1373,225,1,0,0,0,1374,1375,5,14,0,0,1375,1378,5,81,
        0,0,1376,1379,3,228,114,0,1377,1379,3,230,115,0,1378,1376,1,0,0,
        0,1378,1377,1,0,0,0,1379,1380,1,0,0,0,1380,1381,5,82,0,0,1381,227,
        1,0,0,0,1382,1383,7,8,0,0,1383,1384,5,102,0,0,1384,1385,3,318,159,
        0,1385,229,1,0,0,0,1386,1387,7,8,0,0,1387,1388,7,0,0,0,1388,1389,
        5,64,0,0,1389,231,1,0,0,0,1390,1391,5,17,0,0,1391,1392,5,81,0,0,
        1392,1393,3,234,117,0,1393,1394,5,82,0,0,1394,233,1,0,0,0,1395,1396,
        5,160,0,0,1396,1397,3,304,152,0,1397,1398,3,314,157,0,1398,235,1,
        0,0,0,1399,1400,5,23,0,0,1400,1401,5,81,0,0,1401,1402,3,238,119,
        0,1402,1403,5,82,0,0,1403,237,1,0,0,0,1404,1407,3,306,153,0,1405,
        1407,3,308,154,0,1406,1404,1,0,0,0,1406,1405,1,0,0,0,1407,1408,1,
        0,0,0,1408,1409,5,153,0,0,1409,239,1,0,0,0,1410,1411,5,26,0,0,1411,
        1412,5,81,0,0,1412,1413,3,242,121,0,1413,1414,5,82,0,0,1414,241,
        1,0,0,0,1415,1418,3,276,138,0,1416,1418,3,298,149,0,1417,1415,1,
        0,0,0,1417,1416,1,0,0,0,1418,243,1,0,0,0,1419,1420,5,14,0,0,1420,
        1421,5,81,0,0,1421,1531,5,82,0,0,1422,1423,5,14,0,0,1423,1424,5,
        81,0,0,1424,1425,5,165,0,0,1425,1531,5,82,0,0,1426,1427,5,14,0,0,
        1427,1428,5,81,0,0,1428,1429,5,165,0,0,1429,1430,5,102,0,0,1430,
        1531,5,82,0,0,1431,1432,5,14,0,0,1432,1433,5,81,0,0,1433,1434,5,
        165,0,0,1434,1435,7,0,0,0,1435,1531,5,82,0,0,1436,1437,5,14,0,0,
        1437,1438,5,81,0,0,1438,1439,5,170,0,0,1439,1531,5,82,0,0,1440,1441,
        5,14,0,0,1441,1442,5,81,0,0,1442,1443,5,170,0,0,1443,1444,5,102,
        0,0,1444,1531,5,82,0,0,1445,1446,5,14,0,0,1446,1447,5,81,0,0,1447,
        1448,5,170,0,0,1448,1449,7,0,0,0,1449,1531,5,82,0,0,1450,1451,5,
        17,0,0,1451,1452,5,81,0,0,1452,1531,5,82,0,0,1453,1454,5,17,0,0,
        1454,1455,5,81,0,0,1455,1456,5,160,0,0,1456,1531,5,82,0,0,1457,1458,
        5,17,0,0,1458,1459,5,81,0,0,1459,1460,5,160,0,0,1460,1461,3,304,
        152,0,1461,1462,5,82,0,0,1462,1531,1,0,0,0,1463,1464,5,23,0,0,1464,
        1465,5,81,0,0,1465,1531,5,82,0,0,1466,1467,5,23,0,0,1467,1468,5,
        81,0,0,1468,1469,5,116,0,0,1469,1531,5,82,0,0,1470,1471,5,23,0,0,
        1471,1472,5,81,0,0,1472,1473,5,116,0,0,1473,1474,3,316,158,0,1474,
        1475,5,82,0,0,1475,1531,1,0,0,0,1476,1477,5,23,0,0,1477,1478,5,81,
        0,0,1478,1479,5,116,0,0,1479,1480,3,316,158,0,1480,1481,5,111,0,
        0,1481,1482,5,82,0,0,1482,1531,1,0,0,0,1483,1484,5,23,0,0,1484,1485,
        5,81,0,0,1485,1486,5,119,0,0,1486,1531,5,82,0,0,1487,1488,5,23,0,
        0,1488,1489,5,81,0,0,1489,1490,5,119,0,0,1490,1491,3,316,158,0,1491,
        1492,5,82,0,0,1492,1531,1,0,0,0,1493,1494,5,23,0,0,1494,1495,5,81,
        0,0,1495,1496,5,119,0,0,1496,1497,3,316,158,0,1497,1498,5,111,0,
        0,1498,1499,5,82,0,0,1499,1531,1,0,0,0,1500,1501,5,23,0,0,1501,1502,
        5,81,0,0,1502,1503,5,120,0,0,1503,1531,5,82,0,0,1504,1505,5,23,0,
        0,1505,1506,5,81,0,0,1506,1507,5,120,0,0,1507,1508,3,316,158,0,1508,
        1509,5,82,0,0,1509,1531,1,0,0,0,1510,1511,5,23,0,0,1511,1512,5,81,
        0,0,1512,1513,5,120,0,0,1513,1514,3,316,158,0,1514,1515,5,111,0,
        0,1515,1516,5,82,0,0,1516,1531,1,0,0,0,1517,1518,5,26,0,0,1518,1519,
        5,81,0,0,1519,1531,5,82,0,0,1520,1521,5,26,0,0,1521,1522,5,81,0,
        0,1522,1523,3,278,139,0,1523,1524,5,82,0,0,1524,1531,1,0,0,0,1525,
        1526,5,26,0,0,1526,1527,5,81,0,0,1527,1528,3,300,150,0,1528,1529,
        5,82,0,0,1529,1531,1,0,0,0,1530,1419,1,0,0,0,1530,1422,1,0,0,0,1530,
        1426,1,0,0,0,1530,1431,1,0,0,0,1530,1436,1,0,0,0,1530,1440,1,0,0,
        0,1530,1445,1,0,0,0,1530,1450,1,0,0,0,1530,1453,1,0,0,0,1530,1457,
        1,0,0,0,1530,1463,1,0,0,0,1530,1466,1,0,0,0,1530,1470,1,0,0,0,1530,
        1476,1,0,0,0,1530,1483,1,0,0,0,1530,1487,1,0,0,0,1530,1493,1,0,0,
        0,1530,1500,1,0,0,0,1530,1504,1,0,0,0,1530,1510,1,0,0,0,1530,1517,
        1,0,0,0,1530,1520,1,0,0,0,1530,1525,1,0,0,0,1531,245,1,0,0,0,1532,
        1537,3,248,124,0,1533,1534,5,84,0,0,1534,1536,3,248,124,0,1535,1533,
        1,0,0,0,1536,1539,1,0,0,0,1537,1535,1,0,0,0,1537,1538,1,0,0,0,1538,
        247,1,0,0,0,1539,1537,1,0,0,0,1540,1546,3,250,125,0,1541,1546,3,
        256,128,0,1542,1546,3,260,130,0,1543,1546,3,264,132,0,1544,1546,
        3,268,134,0,1545,1540,1,0,0,0,1545,1541,1,0,0,0,1545,1542,1,0,0,
        0,1545,1543,1,0,0,0,1545,1544,1,0,0,0,1546,249,1,0,0,0,1547,1548,
        5,14,0,0,1548,1551,5,81,0,0,1549,1552,3,252,126,0,1550,1552,3,254,
        127,0,1551,1549,1,0,0,0,1551,1550,1,0,0,0,1552,1553,1,0,0,0,1553,
        1554,5,82,0,0,1554,251,1,0,0,0,1555,1556,5,167,0,0,1556,1557,5,102,
        0,0,1557,1558,3,318,159,0,1558,253,1,0,0,0,1559,1560,5,167,0,0,1560,
        1561,7,0,0,0,1561,1562,5,64,0,0,1562,255,1,0,0,0,1563,1564,5,17,
        0,0,1564,1565,5,81,0,0,1565,1566,3,258,129,0,1566,1567,5,82,0,0,
        1567,257,1,0,0,0,1568,1569,5,161,0,0,1569,1570,3,304,152,0,1570,
        1571,3,316,158,0,1571,259,1,0,0,0,1572,1573,5,23,0,0,1573,1574,5,
        81,0,0,1574,1575,3,262,131,0,1575,1576,5,82,0,0,1576,261,1,0,0,0,
        1577,1580,3,306,153,0,1578,1580,3,308,154,0,1579,1577,1,0,0,0,1579,
        1578,1,0,0,0,1580,1581,1,0,0,0,1581,1582,5,154,0,0,1582,263,1,0,
        0,0,1583,1584,5,26,0,0,1584,1585,5,81,0,0,1585,1586,3,266,133,0,
        1586,1587,5,82,0,0,1587,265,1,0,0,0,1588,1591,3,276,138,0,1589,1591,
        3,298,149,0,1590,1588,1,0,0,0,1590,1589,1,0,0,0,1591,267,1,0,0,0,
        1592,1593,5,14,0,0,1593,1594,5,81,0,0,1594,1690,5,82,0,0,1595,1596,
        5,14,0,0,1596,1597,5,81,0,0,1597,1598,5,167,0,0,1598,1690,5,82,0,
        0,1599,1600,5,14,0,0,1600,1601,5,81,0,0,1601,1602,5,167,0,0,1602,
        1603,5,102,0,0,1603,1690,5,82,0,0,1604,1605,5,14,0,0,1605,1606,5,
        81,0,0,1606,1607,5,167,0,0,1607,1608,7,0,0,0,1608,1690,5,82,0,0,
        1609,1610,5,17,0,0,1610,1611,5,81,0,0,1611,1690,5,82,0,0,1612,1613,
        5,17,0,0,1613,1614,5,81,0,0,1614,1615,5,161,0,0,1615,1690,5,82,0,
        0,1616,1617,5,17,0,0,1617,1618,5,81,0,0,1618,1619,5,161,0,0,1619,
        1620,3,304,152,0,1620,1621,5,82,0,0,1621,1690,1,0,0,0,1622,1623,
        5,23,0,0,1623,1624,5,81,0,0,1624,1690,5,82,0,0,1625,1626,5,23,0,
        0,1626,1627,5,81,0,0,1627,1628,5,116,0,0,1628,1690,5,82,0,0,1629,
        1630,5,23,0,0,1630,1631,5,81,0,0,1631,1632,5,116,0,0,1632,1633,3,
        316,158,0,1633,1634,5,82,0,0,1634,1690,1,0,0,0,1635,1636,5,23,0,
        0,1636,1637,5,81,0,0,1637,1638,5,116,0,0,1638,1639,3,316,158,0,1639,
        1640,5,111,0,0,1640,1641,5,82,0,0,1641,1690,1,0,0,0,1642,1643,5,
        23,0,0,1643,1644,5,81,0,0,1644,1645,5,119,0,0,1645,1690,5,82,0,0,
        1646,1647,5,23,0,0,1647,1648,5,81,0,0,1648,1649,5,119,0,0,1649,1650,
        3,316,158,0,1650,1651,5,82,0,0,1651,1690,1,0,0,0,1652,1653,5,23,
        0,0,1653,1654,5,81,0,0,1654,1655,5,119,0,0,1655,1656,3,316,158,0,
        1656,1657,5,111,0,0,1657,1658,5,82,0,0,1658,1690,1,0,0,0,1659,1660,
        5,23,0,0,1660,1661,5,81,0,0,1661,1662,5,120,0,0,1662,1690,5,82,0,
        0,1663,1664,5,23,0,0,1664,1665,5,81,0,0,1665,1666,5,120,0,0,1666,
        1667,3,316,158,0,1667,1668,5,82,0,0,1668,1690,1,0,0,0,1669,1670,
        5,23,0,0,1670,1671,5,81,0,0,1671,1672,5,120,0,0,1672,1673,3,316,
        158,0,1673,1674,5,111,0,0,1674,1675,5,82,0,0,1675,1690,1,0,0,0,1676,
        1677,5,26,0,0,1677,1678,5,81,0,0,1678,1690,5,82,0,0,1679,1680,5,
        26,0,0,1680,1681,5,81,0,0,1681,1682,3,278,139,0,1682,1683,5,82,0,
        0,1683,1690,1,0,0,0,1684,1685,5,26,0,0,1685,1686,5,81,0,0,1686,1687,
        3,300,150,0,1687,1688,5,82,0,0,1688,1690,1,0,0,0,1689,1592,1,0,0,
        0,1689,1595,1,0,0,0,1689,1599,1,0,0,0,1689,1604,1,0,0,0,1689,1609,
        1,0,0,0,1689,1612,1,0,0,0,1689,1616,1,0,0,0,1689,1622,1,0,0,0,1689,
        1625,1,0,0,0,1689,1629,1,0,0,0,1689,1635,1,0,0,0,1689,1642,1,0,0,
        0,1689,1646,1,0,0,0,1689,1652,1,0,0,0,1689,1659,1,0,0,0,1689,1663,
        1,0,0,0,1689,1669,1,0,0,0,1689,1676,1,0,0,0,1689,1679,1,0,0,0,1689,
        1684,1,0,0,0,1690,269,1,0,0,0,1691,1692,5,14,0,0,1692,1695,5,81,
        0,0,1693,1696,3,272,136,0,1694,1696,3,274,137,0,1695,1693,1,0,0,
        0,1695,1694,1,0,0,0,1696,1697,1,0,0,0,1697,1698,5,82,0,0,1698,271,
        1,0,0,0,1699,1700,5,168,0,0,1700,1701,5,102,0,0,1701,1702,3,318,
        159,0,1702,273,1,0,0,0,1703,1704,5,168,0,0,1704,1705,7,0,0,0,1705,
        1706,5,64,0,0,1706,275,1,0,0,0,1707,1710,5,130,0,0,1708,1711,3,272,
        136,0,1709,1711,3,274,137,0,1710,1708,1,0,0,0,1710,1709,1,0,0,0,
        1711,277,1,0,0,0,1712,1723,1,0,0,0,1713,1723,5,130,0,0,1714,1715,
        5,130,0,0,1715,1723,5,168,0,0,1716,1717,5,130,0,0,1717,1718,5,168,
        0,0,1718,1723,5,102,0,0,1719,1720,5,130,0,0,1720,1721,5,168,0,0,
        1721,1723,7,0,0,0,1722,1712,1,0,0,0,1722,1713,1,0,0,0,1722,1714,
        1,0,0,0,1722,1716,1,0,0,0,1722,1719,1,0,0,0,1723,279,1,0,0,0,1724,
        1729,3,282,141,0,1725,1726,5,84,0,0,1726,1728,3,282,141,0,1727,1725,
        1,0,0,0,1728,1731,1,0,0,0,1729,1727,1,0,0,0,1729,1730,1,0,0,0,1730,
        281,1,0,0,0,1731,1729,1,0,0,0,1732,1737,3,284,142,0,1733,1737,3,
        290,145,0,1734,1737,3,294,147,0,1735,1737,3,302,151,0,1736,1732,
        1,0,0,0,1736,1733,1,0,0,0,1736,1734,1,0,0,0,1736,1735,1,0,0,0,1737,
        283,1,0,0,0,1738,1739,5,14,0,0,1739,1742,5,81,0,0,1740,1743,3,286,
        143,0,1741,1743,3,288,144,0,1742,1740,1,0,0,0,1742,1741,1,0,0,0,
        1743,1744,1,0,0,0,1744,1745,5,82,0,0,1745,285,1,0,0,0,1746,1747,
        5,169,0,0,1747,1748,5,102,0,0,1748,1749,3,318,159,0,1749,287,1,0,
        0,0,1750,1751,5,169,0,0,1751,1752,7,0,0,0,1752,1753,5,64,0,0,1753,
        289,1,0,0,0,1754,1755,5,23,0,0,1755,1756,5,81,0,0,1756,1757,3,292,
        146,0,1757,1758,5,82,0,0,1758,291,1,0,0,0,1759,1762,3,306,153,0,
        1760,1762,3,308,154,0,1761,1759,1,0,0,0,1761,1760,1,0,0,0,1762,1763,
        1,0,0,0,1763,1764,5,155,0,0,1764,293,1,0,0,0,1765,1766,5,26,0,0,
        1766,1767,5,81,0,0,1767,1768,3,296,148,0,1768,1769,5,82,0,0,1769,
        295,1,0,0,0,1770,1773,3,276,138,0,1771,1773,3,166,83,0,1772,1770,
        1,0,0,0,1772,1771,1,0,0,0,1773,297,1,0,0,0,1774,1777,5,131,0,0,1775,
        1778,3,286,143,0,1776,1778,3,288,144,0,1777,1775,1,0,0,0,1777,1776,
        1,0,0,0,1778,299,1,0,0,0,1779,1790,1,0,0,0,1780,1790,5,131,0,0,1781,
        1782,5,131,0,0,1782,1790,5,169,0,0,1783,1784,5,131,0,0,1784,1785,
        5,169,0,0,1785,1790,5,102,0,0,1786,1787,5,131,0,0,1787,1788,5,169,
        0,0,1788,1790,7,0,0,0,1789,1779,1,0,0,0,1789,1780,1,0,0,0,1789,1781,
        1,0,0,0,1789,1783,1,0,0,0,1789,1786,1,0,0,0,1790,301,1,0,0,0,1791,
        1792,5,14,0,0,1792,1793,5,81,0,0,1793,1876,5,82,0,0,1794,1795,5,
        14,0,0,1795,1796,5,81,0,0,1796,1797,5,169,0,0,1797,1876,5,82,0,0,
        1798,1799,5,14,0,0,1799,1800,5,81,0,0,1800,1801,5,169,0,0,1801,1802,
        5,102,0,0,1802,1876,5,82,0,0,1803,1804,5,14,0,0,1804,1805,5,81,0,
        0,1805,1806,5,169,0,0,1806,1807,7,0,0,0,1807,1876,5,82,0,0,1808,
        1809,5,23,0,0,1809,1810,5,81,0,0,1810,1876,5,82,0,0,1811,1812,5,
        23,0,0,1812,1813,5,81,0,0,1813,1814,5,116,0,0,1814,1876,5,82,0,0,
        1815,1816,5,23,0,0,1816,1817,5,81,0,0,1817,1818,5,116,0,0,1818,1819,
        3,316,158,0,1819,1820,5,82,0,0,1820,1876,1,0,0,0,1821,1822,5,23,
        0,0,1822,1823,5,81,0,0,1823,1824,5,116,0,0,1824,1825,3,316,158,0,
        1825,1826,5,111,0,0,1826,1827,5,82,0,0,1827,1876,1,0,0,0,1828,1829,
        5,23,0,0,1829,1830,5,81,0,0,1830,1831,5,119,0,0,1831,1876,5,82,0,
        0,1832,1833,5,23,0,0,1833,1834,5,81,0,0,1834,1835,5,119,0,0,1835,
        1836,3,316,158,0,1836,1837,5,82,0,0,1837,1876,1,0,0,0,1838,1839,
        5,23,0,0,1839,1840,5,81,0,0,1840,1841,5,119,0,0,1841,1842,3,316,
        158,0,1842,1843,5,111,0,0,1843,1844,5,82,0,0,1844,1876,1,0,0,0,1845,
        1846,5,23,0,0,1846,1847,5,81,0,0,1847,1848,5,120,0,0,1848,1876,5,
        82,0,0,1849,1850,5,23,0,0,1850,1851,5,81,0,0,1851,1852,5,120,0,0,
        1852,1853,3,316,158,0,1853,1854,5,82,0,0,1854,1876,1,0,0,0,1855,
        1856,5,23,0,0,1856,1857,5,81,0,0,1857,1858,5,120,0,0,1858,1859,3,
        316,158,0,1859,1860,5,111,0,0,1860,1861,5,82,0,0,1861,1876,1,0,0,
        0,1862,1863,5,26,0,0,1863,1864,5,81,0,0,1864,1876,5,82,0,0,1865,
        1866,5,26,0,0,1866,1867,5,81,0,0,1867,1868,3,278,139,0,1868,1869,
        5,82,0,0,1869,1876,1,0,0,0,1870,1871,5,26,0,0,1871,1872,5,81,0,0,
        1872,1873,3,168,84,0,1873,1874,5,82,0,0,1874,1876,1,0,0,0,1875,1791,
        1,0,0,0,1875,1794,1,0,0,0,1875,1798,1,0,0,0,1875,1803,1,0,0,0,1875,
        1808,1,0,0,0,1875,1811,1,0,0,0,1875,1815,1,0,0,0,1875,1821,1,0,0,
        0,1875,1828,1,0,0,0,1875,1832,1,0,0,0,1875,1838,1,0,0,0,1875,1845,
        1,0,0,0,1875,1849,1,0,0,0,1875,1855,1,0,0,0,1875,1862,1,0,0,0,1875,
        1865,1,0,0,0,1875,1870,1,0,0,0,1876,303,1,0,0,0,1877,1878,7,9,0,
        0,1878,305,1,0,0,0,1879,1880,5,116,0,0,1880,1881,3,316,158,0,1881,
        1882,5,111,0,0,1882,307,1,0,0,0,1883,1886,3,310,155,0,1884,1886,
        3,312,156,0,1885,1883,1,0,0,0,1885,1884,1,0,0,0,1886,309,1,0,0,0,
        1887,1888,5,119,0,0,1888,1889,3,316,158,0,1889,1890,5,111,0,0,1890,
        311,1,0,0,0,1891,1892,5,120,0,0,1892,1893,3,316,158,0,1893,1894,
        5,111,0,0,1894,313,1,0,0,0,1895,1904,3,316,158,0,1896,1898,5,76,
        0,0,1897,1896,1,0,0,0,1897,1898,1,0,0,0,1898,1899,1,0,0,0,1899,1901,
        5,121,0,0,1900,1902,5,76,0,0,1901,1900,1,0,0,0,1901,1902,1,0,0,0,
        1902,1904,1,0,0,0,1903,1895,1,0,0,0,1903,1897,1,0,0,0,1904,315,1,
        0,0,0,1905,1906,5,76,0,0,1906,317,1,0,0,0,1907,1912,5,48,0,0,1908,
        1909,5,84,0,0,1909,1911,5,48,0,0,1910,1908,1,0,0,0,1911,1914,1,0,
        0,0,1912,1910,1,0,0,0,1912,1913,1,0,0,0,1913,319,1,0,0,0,1914,1912,
        1,0,0,0,90,325,352,357,366,372,378,424,437,449,455,460,491,500,510,
        514,518,524,537,595,610,617,621,636,642,649,664,671,677,685,705,
        725,743,757,765,783,818,825,832,839,846,853,862,869,875,894,905,
        910,922,1008,1015,1023,1029,1045,1064,1075,1184,1191,1199,1205,1233,
        1244,1357,1364,1372,1378,1406,1417,1530,1537,1545,1551,1579,1590,
        1689,1695,1710,1722,1729,1736,1742,1761,1772,1777,1789,1875,1885,
        1897,1901,1903,1912
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!SubjectsVariables.__ATN) {
            SubjectsVariables.__ATN = new antlr.ATNDeserializer().deserialize(SubjectsVariables._serializedATN);
        }

        return SubjectsVariables.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(SubjectsVariables.literalNames, SubjectsVariables.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return SubjectsVariables.vocabulary;
    }

    private static readonly decisionsToDFA = SubjectsVariables._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}

export class Subjects_variableContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public SUBJECTS_VARIABLE_NAME(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.SUBJECTS_VARIABLE_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.SEMICOLON, 0)!;
    }
    public demographic_event_criteria(): Demographic_event_criteriaContext | null {
        return this.getRuleContext(0, Demographic_event_criteriaContext);
    }
    public event_count_criteria(): Event_count_criteriaContext | null {
        return this.getRuleContext(0, Event_count_criteriaContext);
    }
    public event_count_criteria_error(): Event_count_criteria_errorContext | null {
        return this.getRuleContext(0, Event_count_criteria_errorContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_subjects_variable;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterSubjects_variable) {
             listener.enterSubjects_variable(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitSubjects_variable) {
             listener.exitSubjects_variable(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitSubjects_variable) {
            return visitor.visitSubjects_variable(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Event_count_criteriaContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Count_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public COUNT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.COUNT, 0)!;
    }
    public count_criteria(): Count_criteriaContext {
        return this.getRuleContext(0, Count_criteriaContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_event_count_criteria;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterEvent_count_criteria) {
             listener.enterEvent_count_criteria(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitEvent_count_criteria) {
             listener.exitEvent_count_criteria(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitEvent_count_criteria) {
            return visitor.visitEvent_count_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Count_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public subject_variable_event_name(): Subject_variable_event_nameContext {
        return this.getRuleContext(0, Subject_variable_event_nameContext)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_count_criteria;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCount_criteria) {
             listener.enterCount_criteria(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCount_criteria) {
             listener.exitCount_criteria(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCount_criteria) {
            return visitor.visitCount_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Event_count_criteria_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COUNT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.COUNT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public subject_variable_event_name(): Subject_variable_event_nameContext | null {
        return this.getRuleContext(0, Subject_variable_event_nameContext);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_event_count_criteria_error;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterEvent_count_criteria_error) {
             listener.enterEvent_count_criteria_error(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitEvent_count_criteria_error) {
             listener.exitEvent_count_criteria_error(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitEvent_count_criteria_error) {
            return visitor.visitEvent_count_criteria_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_event_criteriaContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public PERSON(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.PERSON, 0)!;
    }
    public demographic_event_filters(): Demographic_event_filtersContext | null {
        return this.getRuleContext(0, Demographic_event_filtersContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_demographic_event_criteria;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDemographic_event_criteria) {
             listener.enterDemographic_event_criteria(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDemographic_event_criteria) {
             listener.exitDemographic_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDemographic_event_criteria) {
            return visitor.visitDemographic_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_event_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public demographic_event_filter(): Demographic_event_filterContext[];
    public demographic_event_filter(i: number): Demographic_event_filterContext | null;
    public demographic_event_filter(i?: number): Demographic_event_filterContext[] | Demographic_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Demographic_event_filterContext);
        }

        return this.getRuleContext(i, Demographic_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SubjectsVariables.COMMA);
    	} else {
    		return this.getToken(SubjectsVariables.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_demographic_event_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDemographic_event_filters) {
             listener.enterDemographic_event_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDemographic_event_filters) {
             listener.exitDemographic_event_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDemographic_event_filters) {
            return visitor.visitDemographic_event_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public demographic_concept_filter(): Demographic_concept_filterContext | null {
        return this.getRuleContext(0, Demographic_concept_filterContext);
    }
    public demographic_numeric_filter(): Demographic_numeric_filterContext | null {
        return this.getRuleContext(0, Demographic_numeric_filterContext);
    }
    public demographic_error_filter(): Demographic_error_filterContext | null {
        return this.getRuleContext(0, Demographic_error_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_demographic_event_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDemographic_event_filter) {
             listener.enterDemographic_event_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDemographic_event_filter) {
             listener.exitDemographic_event_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDemographic_event_filter) {
            return visitor.visitDemographic_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_concept_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public demographic_concept_group_filter(): Demographic_concept_group_filterContext | null {
        return this.getRuleContext(0, Demographic_concept_group_filterContext);
    }
    public demographic_concept_id_filter(): Demographic_concept_id_filterContext | null {
        return this.getRuleContext(0, Demographic_concept_id_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_demographic_concept_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDemographic_concept_filter) {
             listener.enterDemographic_concept_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDemographic_concept_filter) {
             listener.exitDemographic_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDemographic_concept_filter) {
            return visitor.visitDemographic_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PERSON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.PERSON_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_demographic_concept_group_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDemographic_concept_group_filter) {
             listener.enterDemographic_concept_group_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDemographic_concept_group_filter) {
             listener.exitDemographic_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDemographic_concept_group_filter) {
            return visitor.visitDemographic_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_concept_id_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PERSON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.PERSON_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_demographic_concept_id_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDemographic_concept_id_filter) {
             listener.enterDemographic_concept_id_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDemographic_concept_id_filter) {
             listener.exitDemographic_concept_id_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDemographic_concept_id_filter) {
            return visitor.visitDemographic_concept_id_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_numeric_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public demographic_int_filter(): Demographic_int_filterContext | null {
        return this.getRuleContext(0, Demographic_int_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_demographic_numeric_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDemographic_numeric_filter) {
             listener.enterDemographic_numeric_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDemographic_numeric_filter) {
             listener.exitDemographic_numeric_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDemographic_numeric_filter) {
            return visitor.visitDemographic_numeric_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_int_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PERSON_INT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.PERSON_INT_ATTRIBUTE, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_demographic_int_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDemographic_int_filter) {
             listener.enterDemographic_int_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDemographic_int_filter) {
             listener.exitDemographic_int_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDemographic_int_filter) {
            return visitor.visitDemographic_int_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_error_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public PERSON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.PERSON_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.IN, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NF, 0);
    }
    public PERSON_INT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.PERSON_INT_ATTRIBUTE, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_demographic_error_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDemographic_error_filter) {
             listener.enterDemographic_error_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDemographic_error_filter) {
             listener.exitDemographic_error_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDemographic_error_filter) {
            return visitor.visitDemographic_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Subject_variable_event_nameContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public SUBJECT_VARIABLE_CARE_SITE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.SUBJECT_VARIABLE_CARE_SITE_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_MEASUREMENT_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.SUBJECT_VARIABLE_MEASUREMENT_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_OBSERVATION_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.SUBJECT_VARIABLE_OBSERVATION_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_PROVIDER_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.SUBJECT_VARIABLE_PROVIDER_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_DERIVED_EVENT_NAME(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.SUBJECT_VARIABLE_DERIVED_EVENT_NAME, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_subject_variable_event_name;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterSubject_variable_event_name) {
             listener.enterSubject_variable_event_name(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitSubject_variable_event_name) {
             listener.exitSubject_variable_event_name(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitSubject_variable_event_name) {
            return visitor.visitSubject_variable_event_name(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_dateContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INDEX_DATE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.INDEX_DATE, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.EQ, 0)!;
    }
    public index_date_definition(): Index_date_definitionContext {
        return this.getRuleContext(0, Index_date_definitionContext)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_index_date;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterIndex_date) {
             listener.enterIndex_date(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitIndex_date) {
             listener.exitIndex_date(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitIndex_date) {
            return visitor.visitIndex_date(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_date_definitionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public calendar_date(): Calendar_dateContext | null {
        return this.getRuleContext(0, Calendar_dateContext);
    }
    public calendarError(): CalendarErrorContext | null {
        return this.getRuleContext(0, CalendarErrorContext);
    }
    public index_event_date(): Index_event_dateContext | null {
        return this.getRuleContext(0, Index_event_dateContext);
    }
    public index_event_date_error(): Index_event_date_errorContext | null {
        return this.getRuleContext(0, Index_event_date_errorContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_index_date_definition;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterIndex_date_definition) {
             listener.enterIndex_date_definition(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitIndex_date_definition) {
             listener.exitIndex_date_definition(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitIndex_date_definition) {
            return visitor.visitIndex_date_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Calendar_dateContext extends antlr.ParserRuleContext {
    public _index_date_type?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.DATE, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public CALENDAR_DATE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CALENDAR_DATE, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_calendar_date;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCalendar_date) {
             listener.enterCalendar_date(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCalendar_date) {
             listener.exitCalendar_date(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCalendar_date) {
            return visitor.visitCalendar_date(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_event_dateContext extends antlr.ParserRuleContext {
    public _index_date_type?: Token | null;
    public _date?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public EVENT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.EVENT, 0)!;
    }
    public INSTANCE_EVENT_NAME(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.INSTANCE_EVENT_NAME, 0);
    }
    public PERSON_DATE_TIME_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.PERSON_DATE_TIME_ATTRIBUTE, 0);
    }
    public COMMA(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.COMMA, 0);
    }
    public index_date_bounds(): Index_date_boundsContext | null {
        return this.getRuleContext(0, Index_date_boundsContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_index_event_date;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterIndex_event_date) {
             listener.enterIndex_event_date(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitIndex_event_date) {
             listener.exitIndex_event_date(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitIndex_event_date) {
            return visitor.visitIndex_event_date(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_date_boundsContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COMMA(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.COMMA, 0)!;
    }
    public lower_date_bounds(): Lower_date_boundsContext | null {
        return this.getRuleContext(0, Lower_date_boundsContext);
    }
    public lower_date_bounds_error(): Lower_date_bounds_errorContext | null {
        return this.getRuleContext(0, Lower_date_bounds_errorContext);
    }
    public upper_date_bounds(): Upper_date_boundsContext | null {
        return this.getRuleContext(0, Upper_date_boundsContext);
    }
    public upper_date_bounds_error(): Upper_date_bounds_errorContext | null {
        return this.getRuleContext(0, Upper_date_bounds_errorContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_index_date_bounds;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterIndex_date_bounds) {
             listener.enterIndex_date_bounds(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitIndex_date_bounds) {
             listener.exitIndex_date_bounds(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitIndex_date_bounds) {
            return visitor.visitIndex_date_bounds(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Upper_date_boundsContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UPPER_DATE_BOUND(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.UPPER_DATE_BOUND, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.DATE, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_upper_date_bounds;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterUpper_date_bounds) {
             listener.enterUpper_date_bounds(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitUpper_date_bounds) {
             listener.exitUpper_date_bounds(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitUpper_date_bounds) {
            return visitor.visitUpper_date_bounds(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Lower_date_boundsContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public LOWER_DATE_BOUND(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.LOWER_DATE_BOUND, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.DATE, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_lower_date_bounds;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterLower_date_bounds) {
             listener.enterLower_date_bounds(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitLower_date_bounds) {
             listener.exitLower_date_bounds(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitLower_date_bounds) {
            return visitor.visitLower_date_bounds(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class CalendarErrorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CALENDAR_DATE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CALENDAR_DATE, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_calendarError;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCalendarError) {
             listener.enterCalendarError(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCalendarError) {
             listener.exitCalendarError(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCalendarError) {
            return visitor.visitCalendarError(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_event_date_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EVENT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_index_event_date_error;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterIndex_event_date_error) {
             listener.enterIndex_event_date_error(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitIndex_event_date_error) {
             listener.exitIndex_event_date_error(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitIndex_event_date_error) {
            return visitor.visitIndex_event_date_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Lower_date_bounds_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public LOWER_DATE_BOUND(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.LOWER_DATE_BOUND, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_lower_date_bounds_error;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterLower_date_bounds_error) {
             listener.enterLower_date_bounds_error(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitLower_date_bounds_error) {
             listener.exitLower_date_bounds_error(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitLower_date_bounds_error) {
            return visitor.visitLower_date_bounds_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Upper_date_bounds_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UPPER_DATE_BOUND(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.UPPER_DATE_BOUND, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_upper_date_bounds_error;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterUpper_date_bounds_error) {
             listener.enterUpper_date_bounds_error(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitUpper_date_bounds_error) {
             listener.exitUpper_date_bounds_error(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitUpper_date_bounds_error) {
            return visitor.visitUpper_date_bounds_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event(): Merged_eventContext | null {
        return this.getRuleContext(0, Merged_eventContext);
    }
    public sequence_event(): Sequence_eventContext | null {
        return this.getRuleContext(0, Sequence_eventContext);
    }
    public instance_event(): Instance_eventContext | null {
        return this.getRuleContext(0, Instance_eventContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_derived_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDerived_event) {
             listener.enterDerived_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDerived_event) {
             listener.exitDerived_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDerived_event) {
            return visitor.visitDerived_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MERGED_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.MERGED_EVENT_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.EQ, 0)!;
    }
    public MERGED_EVENT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.MERGED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public merged_event_criteria(): Merged_event_criteriaContext {
        return this.getRuleContext(0, Merged_event_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.SEMICOLON, 0)!;
    }
    public COMMA(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.COMMA, 0);
    }
    public merged_event_filter_criterion(): Merged_event_filter_criterionContext | null {
        return this.getRuleContext(0, Merged_event_filter_criterionContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_merged_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMerged_event) {
             listener.enterMerged_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMerged_event) {
             listener.exitMerged_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMerged_event) {
            return visitor.visitMerged_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_criterion(): Merged_event_criterionContext[];
    public merged_event_criterion(i: number): Merged_event_criterionContext | null;
    public merged_event_criterion(i?: number): Merged_event_criterionContext[] | Merged_event_criterionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Merged_event_criterionContext);
        }

        return this.getRuleContext(i, Merged_event_criterionContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SubjectsVariables.COMMA);
    	} else {
    		return this.getToken(SubjectsVariables.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_merged_event_criteria;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMerged_event_criteria) {
             listener.enterMerged_event_criteria(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMerged_event_criteria) {
             listener.exitMerged_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_criteria) {
            return visitor.visitMerged_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_event(): Merged_event_eventContext | null {
        return this.getRuleContext(0, Merged_event_eventContext);
    }
    public derived_event_error(): Derived_event_errorContext | null {
        return this.getRuleContext(0, Derived_event_errorContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_merged_event_criterion;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMerged_event_criterion) {
             listener.enterMerged_event_criterion(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMerged_event_criterion) {
             listener.exitMerged_event_criterion(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_criterion) {
            return visitor.visitMerged_event_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_filter_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_filter(): Merged_event_filterContext | null {
        return this.getRuleContext(0, Merged_event_filterContext);
    }
    public merged_event_filter_error(): Merged_event_filter_errorContext | null {
        return this.getRuleContext(0, Merged_event_filter_errorContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_merged_event_filter_criterion;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMerged_event_filter_criterion) {
             listener.enterMerged_event_filter_criterion(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMerged_event_filter_criterion) {
             listener.exitMerged_event_filter_criterion(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_filter_criterion) {
            return visitor.visitMerged_event_filter_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_merged_event_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMerged_event_event) {
             listener.enterMerged_event_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMerged_event_event) {
             listener.exitMerged_event_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_event) {
            return visitor.visitMerged_event_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_uniqueness_filter(): Merged_event_uniqueness_filterContext {
        return this.getRuleContext(0, Merged_event_uniqueness_filterContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_merged_event_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMerged_event_filter) {
             listener.enterMerged_event_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMerged_event_filter) {
             listener.exitMerged_event_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_filter) {
            return visitor.visitMerged_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public merged_event_uniqueness_filter_criteria(): Merged_event_uniqueness_filter_criteriaContext {
        return this.getRuleContext(0, Merged_event_uniqueness_filter_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_merged_event_uniqueness_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMerged_event_uniqueness_filter) {
             listener.enterMerged_event_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMerged_event_uniqueness_filter) {
             listener.exitMerged_event_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_uniqueness_filter) {
            return visitor.visitMerged_event_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_uniqueness_filter_criteriaContext extends antlr.ParserRuleContext {
    public _date_attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT_DATE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.DERIVED_EVENT_DATE, 0)!;
    }
    public derived_uniqueness_filter(): Derived_uniqueness_filterContext | null {
        return this.getRuleContext(0, Derived_uniqueness_filterContext);
    }
    public derived_uniqueness_filter_window(): Derived_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Derived_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_merged_event_uniqueness_filter_criteria;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMerged_event_uniqueness_filter_criteria) {
             listener.enterMerged_event_uniqueness_filter_criteria(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMerged_event_uniqueness_filter_criteria) {
             listener.exitMerged_event_uniqueness_filter_criteria(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_uniqueness_filter_criteria) {
            return visitor.visitMerged_event_uniqueness_filter_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_filter_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MINIMUM_BETWEEN, 0);
    }
    public derived_event_int(): Derived_event_intContext | null {
        return this.getRuleContext(0, Derived_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.ROLLING_WINDOW, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_merged_event_filter_error;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMerged_event_filter_error) {
             listener.enterMerged_event_filter_error(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMerged_event_filter_error) {
             listener.exitMerged_event_filter_error(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_filter_error) {
            return visitor.visitMerged_event_filter_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public SEQUENCE_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.SEQUENCE_EVENT_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.EQ, 0)!;
    }
    public SEQUENCE_EVENT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.SEQUENCE_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public sequence_event_criteria(): Sequence_event_criteriaContext {
        return this.getRuleContext(0, Sequence_event_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_sequence_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterSequence_event) {
             listener.enterSequence_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitSequence_event) {
             listener.exitSequence_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitSequence_event) {
            return visitor.visitSequence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public sequence_event_criterion(): Sequence_event_criterionContext[];
    public sequence_event_criterion(i: number): Sequence_event_criterionContext | null;
    public sequence_event_criterion(i?: number): Sequence_event_criterionContext[] | Sequence_event_criterionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Sequence_event_criterionContext);
        }

        return this.getRuleContext(i, Sequence_event_criterionContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SubjectsVariables.COMMA);
    	} else {
    		return this.getToken(SubjectsVariables.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_sequence_event_criteria;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterSequence_event_criteria) {
             listener.enterSequence_event_criteria(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitSequence_event_criteria) {
             listener.exitSequence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_criteria) {
            return visitor.visitSequence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public sequence_event_constraint(): Sequence_event_constraintContext | null {
        return this.getRuleContext(0, Sequence_event_constraintContext);
    }
    public sequence_event_event(): Sequence_event_eventContext | null {
        return this.getRuleContext(0, Sequence_event_eventContext);
    }
    public sequence_event_constraint_error(): Sequence_event_constraint_errorContext | null {
        return this.getRuleContext(0, Sequence_event_constraint_errorContext);
    }
    public derived_event_error(): Derived_event_errorContext | null {
        return this.getRuleContext(0, Derived_event_errorContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_sequence_event_criterion;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterSequence_event_criterion) {
             listener.enterSequence_event_criterion(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitSequence_event_criterion) {
             listener.exitSequence_event_criterion(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_criterion) {
            return visitor.visitSequence_event_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_constraintContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ANY_ORDER(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.ANY_ORDER, 0);
    }
    public temporal_constraint(): Temporal_constraintContext | null {
        return this.getRuleContext(0, Temporal_constraintContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_sequence_event_constraint;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterSequence_event_constraint) {
             listener.enterSequence_event_constraint(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitSequence_event_constraint) {
             listener.exitSequence_event_constraint(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_constraint) {
            return visitor.visitSequence_event_constraint(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Temporal_constraintContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public TC(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.TC, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public sequence_temporal_filter(): Sequence_temporal_filterContext {
        return this.getRuleContext(0, Sequence_temporal_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_temporal_constraint;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterTemporal_constraint) {
             listener.enterTemporal_constraint(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitTemporal_constraint) {
             listener.exitTemporal_constraint(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitTemporal_constraint) {
            return visitor.visitTemporal_constraint(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_temporal_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.INT, 0)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.TIME_UNIT, 0)!;
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MINIMUM_BETWEEN, 0);
    }
    public MAXIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MAXIMUM_BETWEEN, 0);
    }
    public TOTAL_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.TOTAL_BETWEEN, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_sequence_temporal_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterSequence_temporal_filter) {
             listener.enterSequence_temporal_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitSequence_temporal_filter) {
             listener.exitSequence_temporal_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitSequence_temporal_filter) {
            return visitor.visitSequence_temporal_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public selected_sequence_event(): Selected_sequence_eventContext | null {
        return this.getRuleContext(0, Selected_sequence_eventContext);
    }
    public unselected_sequence_event(): Unselected_sequence_eventContext | null {
        return this.getRuleContext(0, Unselected_sequence_eventContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_sequence_event_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterSequence_event_event) {
             listener.enterSequence_event_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitSequence_event_event) {
             listener.exitSequence_event_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_event) {
            return visitor.visitSequence_event_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Selected_sequence_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COMMA(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.COMMA, 0)!;
    }
    public IS_EVENT_DATE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.IS_EVENT_DATE, 0)!;
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_selected_sequence_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterSelected_sequence_event) {
             listener.enterSelected_sequence_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitSelected_sequence_event) {
             listener.exitSelected_sequence_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitSelected_sequence_event) {
            return visitor.visitSelected_sequence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Unselected_sequence_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_unselected_sequence_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterUnselected_sequence_event) {
             listener.enterUnselected_sequence_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitUnselected_sequence_event) {
             listener.exitUnselected_sequence_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitUnselected_sequence_event) {
            return visitor.visitUnselected_sequence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INSTANCE_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.INSTANCE_EVENT_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.EQ, 0)!;
    }
    public INSTANCE_EVENT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.INSTANCE_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public instance_event_criteria(): Instance_event_criteriaContext {
        return this.getRuleContext(0, Instance_event_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_instance_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterInstance_event) {
             listener.enterInstance_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitInstance_event) {
             listener.exitInstance_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitInstance_event) {
            return visitor.visitInstance_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public instance_event_criterion(): Instance_event_criterionContext[];
    public instance_event_criterion(i: number): Instance_event_criterionContext | null;
    public instance_event_criterion(i?: number): Instance_event_criterionContext[] | Instance_event_criterionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Instance_event_criterionContext);
        }

        return this.getRuleContext(i, Instance_event_criterionContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SubjectsVariables.COMMA);
    	} else {
    		return this.getToken(SubjectsVariables.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_instance_event_criteria;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterInstance_event_criteria) {
             listener.enterInstance_event_criteria(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitInstance_event_criteria) {
             listener.exitInstance_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_criteria) {
            return visitor.visitInstance_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public instance_event_event(): Instance_event_eventContext | null {
        return this.getRuleContext(0, Instance_event_eventContext);
    }
    public derived_event_error(): Derived_event_errorContext | null {
        return this.getRuleContext(0, Derived_event_errorContext);
    }
    public instance_event_position(): Instance_event_positionContext | null {
        return this.getRuleContext(0, Instance_event_positionContext);
    }
    public instance_event_position_error(): Instance_event_position_errorContext | null {
        return this.getRuleContext(0, Instance_event_position_errorContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_instance_event_criterion;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterInstance_event_criterion) {
             listener.enterInstance_event_criterion(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitInstance_event_criterion) {
             listener.exitInstance_event_criterion(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_criterion) {
            return visitor.visitInstance_event_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_instance_event_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterInstance_event_event) {
             listener.enterInstance_event_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitInstance_event_event) {
             listener.exitInstance_event_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_event) {
            return visitor.visitInstance_event_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_positionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public POSITION(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.POSITION, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public aggregation_qualified(): Aggregation_qualifiedContext | null {
        return this.getRuleContext(0, Aggregation_qualifiedContext);
    }
    public specific_instance(): Specific_instanceContext | null {
        return this.getRuleContext(0, Specific_instanceContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_instance_event_position;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterInstance_event_position) {
             listener.enterInstance_event_position(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitInstance_event_position) {
             listener.exitInstance_event_position(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_position) {
            return visitor.visitInstance_event_position(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Aggregation_qualifiedContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MAX(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MAX, 0);
    }
    public MIN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MIN, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_aggregation_qualified;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterAggregation_qualified) {
             listener.enterAggregation_qualified(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitAggregation_qualified) {
             listener.exitAggregation_qualified(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitAggregation_qualified) {
            return visitor.visitAggregation_qualified(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Specific_instanceContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INDEX(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.INDEX, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.INT, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_specific_instance;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterSpecific_instance) {
             listener.enterSpecific_instance(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitSpecific_instance) {
             listener.exitSpecific_instance(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitSpecific_instance) {
            return visitor.visitSpecific_instance(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_position_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public POSITION(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.POSITION, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode[];
    public OPEN_PAREN(i: number): antlr.TerminalNode | null;
    public OPEN_PAREN(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SubjectsVariables.OPEN_PAREN);
    	} else {
    		return this.getToken(SubjectsVariables.OPEN_PAREN, i);
    	}
    }
    public CLOSE_PAREN(): antlr.TerminalNode[];
    public CLOSE_PAREN(i: number): antlr.TerminalNode | null;
    public CLOSE_PAREN(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SubjectsVariables.CLOSE_PAREN);
    	} else {
    		return this.getToken(SubjectsVariables.CLOSE_PAREN, i);
    	}
    }
    public INDEX(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.INDEX, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_instance_event_position_error;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterInstance_event_position_error) {
             listener.enterInstance_event_position_error(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitInstance_event_position_error) {
             listener.exitInstance_event_position_error(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_position_error) {
            return visitor.visitInstance_event_position_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Qualified_simple_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUALIFIED_CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.QUALIFIED_CONDITION_OCCURRENCE_ALIAS, 0);
    }
    public PERIOD(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.PERIOD, 0)!;
    }
    public CONDITION_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.CONDITION_OCCURRENCE_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.QUALIFIED_DRUG_EXPOSURE_ALIAS, 0);
    }
    public DRUG_EXPOSURE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.DRUG_EXPOSURE_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_MEASUREMENT_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.QUALIFIED_MEASUREMENT_ALIAS, 0);
    }
    public MEASUREMENT_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MEASUREMENT_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_OBSERVATION_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.QUALIFIED_OBSERVATION_ALIAS, 0);
    }
    public OBSERVATION_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.OBSERVATION_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS, 0);
    }
    public PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.QUALIFIED_VISIT_OCCURRENCE_ALIAS, 0);
    }
    public VISIT_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.VISIT_OCCURRENCE_DATE_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_qualified_simple_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterQualified_simple_event) {
             listener.enterQualified_simple_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitQualified_simple_event) {
             listener.exitQualified_simple_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitQualified_simple_event) {
            return visitor.visitQualified_simple_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Qualified_derived_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUALIFIED_DERIVED_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.QUALIFIED_DERIVED_EVENT_NAME, 0)!;
    }
    public PERIOD(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.PERIOD, 0)!;
    }
    public DERIVED_EVENT_DATE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.DERIVED_EVENT_DATE, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_qualified_derived_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterQualified_derived_event) {
             listener.enterQualified_derived_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitQualified_derived_event) {
             listener.exitQualified_derived_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitQualified_derived_event) {
            return visitor.visitQualified_derived_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_constraint_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public TC(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.TC, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MINIMUM_BETWEEN, 0);
    }
    public MAXIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MAXIMUM_BETWEEN, 0);
    }
    public TOTAL_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.TOTAL_BETWEEN, 0);
    }
    public INT(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.INT, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_sequence_event_constraint_error;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterSequence_event_constraint_error) {
             listener.enterSequence_event_constraint_error(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitSequence_event_constraint_error) {
             listener.exitSequence_event_constraint_error(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_constraint_error) {
            return visitor.visitSequence_event_constraint_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_event_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public QUALIFIED_CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.QUALIFIED_CONDITION_OCCURRENCE_ALIAS, 0);
    }
    public QUALIFIED_DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.QUALIFIED_DRUG_EXPOSURE_ALIAS, 0);
    }
    public QUALIFIED_MEASUREMENT_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.QUALIFIED_MEASUREMENT_ALIAS, 0);
    }
    public QUALIFIED_OBSERVATION_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.QUALIFIED_OBSERVATION_ALIAS, 0);
    }
    public QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS, 0);
    }
    public QUALIFIED_VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.QUALIFIED_VISIT_OCCURRENCE_ALIAS, 0);
    }
    public QUALIFIED_DERIVED_EVENT_NAME(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.QUALIFIED_DERIVED_EVENT_NAME, 0);
    }
    public PERIOD(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.PERIOD, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_derived_event_error;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDerived_event_error) {
             listener.enterDerived_event_error(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDerived_event_error) {
             listener.exitDerived_event_error(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDerived_event_error) {
            return visitor.visitDerived_event_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.MINIMUM_BETWEEN, 0)!;
    }
    public derived_event_int(): Derived_event_intContext {
        return this.getRuleContext(0, Derived_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_derived_uniqueness_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDerived_uniqueness_filter) {
             listener.enterDerived_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDerived_uniqueness_filter) {
             listener.exitDerived_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDerived_uniqueness_filter) {
            return visitor.visitDerived_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_uniqueness_filter_windowContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public derived_fixed_window_uniqueness_filter(): Derived_fixed_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Derived_fixed_window_uniqueness_filterContext);
    }
    public derived_rolling_window_uniqueness_filter(): Derived_rolling_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Derived_rolling_window_uniqueness_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_derived_uniqueness_filter_window;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDerived_uniqueness_filter_window) {
             listener.enterDerived_uniqueness_filter_window(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDerived_uniqueness_filter_window) {
             listener.exitDerived_uniqueness_filter_window(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDerived_uniqueness_filter_window) {
            return visitor.visitDerived_uniqueness_filter_window(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_fixed_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public FIXED_WINDOW(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.FIXED_WINDOW, 0)!;
    }
    public derived_event_int(): Derived_event_intContext {
        return this.getRuleContext(0, Derived_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_derived_fixed_window_uniqueness_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDerived_fixed_window_uniqueness_filter) {
             listener.enterDerived_fixed_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDerived_fixed_window_uniqueness_filter) {
             listener.exitDerived_fixed_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDerived_fixed_window_uniqueness_filter) {
            return visitor.visitDerived_fixed_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_rolling_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.ROLLING_WINDOW, 0)!;
    }
    public derived_event_int(): Derived_event_intContext {
        return this.getRuleContext(0, Derived_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_derived_rolling_window_uniqueness_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDerived_rolling_window_uniqueness_filter) {
             listener.enterDerived_rolling_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDerived_rolling_window_uniqueness_filter) {
             listener.exitDerived_rolling_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDerived_rolling_window_uniqueness_filter) {
            return visitor.visitDerived_rolling_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_event_intContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_derived_event_int;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDerived_event_int) {
             listener.enterDerived_event_int(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDerived_event_int) {
             listener.exitDerived_event_int(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDerived_event_int) {
            return visitor.visitDerived_event_int(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_event(): Condition_occurrence_eventContext | null {
        return this.getRuleContext(0, Condition_occurrence_eventContext);
    }
    public drug_exposure_event(): Drug_exposure_eventContext | null {
        return this.getRuleContext(0, Drug_exposure_eventContext);
    }
    public measurement_event(): Measurement_eventContext | null {
        return this.getRuleContext(0, Measurement_eventContext);
    }
    public observation_event(): Observation_eventContext | null {
        return this.getRuleContext(0, Observation_eventContext);
    }
    public procedure_occurrence_event(): Procedure_occurrence_eventContext | null {
        return this.getRuleContext(0, Procedure_occurrence_eventContext);
    }
    public visit_occurrence_event(): Visit_occurrence_eventContext | null {
        return this.getRuleContext(0, Visit_occurrence_eventContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_simple_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterSimple_event) {
             listener.enterSimple_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitSimple_event) {
             listener.exitSimple_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitSimple_event) {
            return visitor.visitSimple_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Condition_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.SEMICOLON, 0)!;
    }
    public CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CONDITION_OCCURRENCE_ALIAS, 0)!;
    }
    public condition_occurrence_event_definition(): Condition_occurrence_event_definitionContext {
        return this.getRuleContext(0, Condition_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_condition_occurrence_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCondition_occurrence_event) {
             listener.enterCondition_occurrence_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCondition_occurrence_event) {
             listener.exitCondition_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event) {
            return visitor.visitCondition_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Drug_exposure_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.SEMICOLON, 0)!;
    }
    public DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.DRUG_EXPOSURE_ALIAS, 0)!;
    }
    public drug_exposure_event_definition(): Drug_exposure_event_definitionContext {
        return this.getRuleContext(0, Drug_exposure_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_drug_exposure_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDrug_exposure_event) {
             listener.enterDrug_exposure_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDrug_exposure_event) {
             listener.exitDrug_exposure_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event) {
            return visitor.visitDrug_exposure_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Measurement_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.SEMICOLON, 0)!;
    }
    public MEASUREMENT_ALIAS(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.MEASUREMENT_ALIAS, 0)!;
    }
    public measurement_event_definition(): Measurement_event_definitionContext {
        return this.getRuleContext(0, Measurement_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_measurement_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMeasurement_event) {
             listener.enterMeasurement_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMeasurement_event) {
             listener.exitMeasurement_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event) {
            return visitor.visitMeasurement_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Observation_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.SEMICOLON, 0)!;
    }
    public OBSERVATION_ALIAS(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OBSERVATION_ALIAS, 0)!;
    }
    public observation_event_definition(): Observation_event_definitionContext {
        return this.getRuleContext(0, Observation_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_observation_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterObservation_event) {
             listener.enterObservation_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitObservation_event) {
             listener.exitObservation_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitObservation_event) {
            return visitor.visitObservation_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Procedure_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.SEMICOLON, 0)!;
    }
    public PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.PROCEDURE_OCCURRENCE_ALIAS, 0)!;
    }
    public procedure_occurrence_event_definition(): Procedure_occurrence_event_definitionContext {
        return this.getRuleContext(0, Procedure_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_procedure_occurrence_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProcedure_occurrence_event) {
             listener.enterProcedure_occurrence_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProcedure_occurrence_event) {
             listener.exitProcedure_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event) {
            return visitor.visitProcedure_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Visit_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.SEMICOLON, 0)!;
    }
    public VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.VISIT_OCCURRENCE_ALIAS, 0)!;
    }
    public visit_occurrence_event_definition(): Visit_occurrence_event_definitionContext {
        return this.getRuleContext(0, Visit_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_visit_occurrence_event;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterVisit_occurrence_event) {
             listener.enterVisit_occurrence_event(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitVisit_occurrence_event) {
             listener.exitVisit_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event) {
            return visitor.visitVisit_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Condition_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CONDITION_OCCURRENCE, 0)!;
    }
    public condition_occurrence_event_criteria(): Condition_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Condition_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_condition_occurrence_event_definition;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCondition_occurrence_event_definition) {
             listener.enterCondition_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCondition_occurrence_event_definition) {
             listener.exitCondition_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_definition) {
            return visitor.visitCondition_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Drug_exposure_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public DRUG_EXPOSURE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.DRUG_EXPOSURE, 0)!;
    }
    public drug_exposure_event_criteria(): Drug_exposure_event_criteriaContext | null {
        return this.getRuleContext(0, Drug_exposure_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_drug_exposure_event_definition;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDrug_exposure_event_definition) {
             listener.enterDrug_exposure_event_definition(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDrug_exposure_event_definition) {
             listener.exitDrug_exposure_event_definition(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_definition) {
            return visitor.visitDrug_exposure_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Measurement_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public MEASUREMENT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.MEASUREMENT, 0)!;
    }
    public measurement_event_criteria(): Measurement_event_criteriaContext | null {
        return this.getRuleContext(0, Measurement_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_measurement_event_definition;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMeasurement_event_definition) {
             listener.enterMeasurement_event_definition(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMeasurement_event_definition) {
             listener.exitMeasurement_event_definition(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_definition) {
            return visitor.visitMeasurement_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Observation_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public OBSERVATION(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OBSERVATION, 0)!;
    }
    public observation_event_criteria(): Observation_event_criteriaContext | null {
        return this.getRuleContext(0, Observation_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_observation_event_definition;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterObservation_event_definition) {
             listener.enterObservation_event_definition(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitObservation_event_definition) {
             listener.exitObservation_event_definition(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_definition) {
            return visitor.visitObservation_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Procedure_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public PROCEDURE_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.PROCEDURE_OCCURRENCE, 0)!;
    }
    public procedure_occurrence_event_criteria(): Procedure_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Procedure_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_procedure_occurrence_event_definition;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProcedure_occurrence_event_definition) {
             listener.enterProcedure_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProcedure_occurrence_event_definition) {
             listener.exitProcedure_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_definition) {
            return visitor.visitProcedure_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Visit_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.VISIT_OCCURRENCE, 0)!;
    }
    public visit_occurrence_event_criteria(): Visit_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Visit_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_visit_occurrence_event_definition;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterVisit_occurrence_event_definition) {
             listener.enterVisit_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitVisit_occurrence_event_definition) {
             listener.exitVisit_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_definition) {
            return visitor.visitVisit_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_event_filter(): Condition_occurrence_event_filterContext[];
    public condition_occurrence_event_filter(i: number): Condition_occurrence_event_filterContext | null;
    public condition_occurrence_event_filter(i?: number): Condition_occurrence_event_filterContext[] | Condition_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Condition_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Condition_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SubjectsVariables.COMMA);
    	} else {
    		return this.getToken(SubjectsVariables.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_condition_occurrence_event_criteria;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCondition_occurrence_event_criteria) {
             listener.enterCondition_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCondition_occurrence_event_criteria) {
             listener.exitCondition_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_criteria) {
            return visitor.visitCondition_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_concept_filters(): Condition_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filtersContext);
    }
    public condition_occurrence_uniqueness_filters(): Condition_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_uniqueness_filtersContext);
    }
    public condition_occurrence_related_entity_filters(): Condition_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_related_entity_filtersContext);
    }
    public condition_occurrence_error_filter(): Condition_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_condition_occurrence_event_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCondition_occurrence_event_filter) {
             listener.enterCondition_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCondition_occurrence_event_filter) {
             listener.exitCondition_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_filter) {
            return visitor.visitCondition_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_group_filterContext);
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_condition_occurrence_concept_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCondition_occurrence_concept_filters) {
             listener.enterCondition_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCondition_occurrence_concept_filters) {
             listener.exitCondition_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_filters) {
            return visitor.visitCondition_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_condition_occurrence_concept_group_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCondition_occurrence_concept_group_filter) {
             listener.enterCondition_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCondition_occurrence_concept_group_filter) {
             listener.exitCondition_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_group_filter) {
            return visitor.visitCondition_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_condition_occurrence_concept_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCondition_occurrence_concept_filter) {
             listener.enterCondition_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCondition_occurrence_concept_filter) {
             listener.exitCondition_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_filter) {
            return visitor.visitCondition_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public condition_occurrence_uniqueness_filter(): Condition_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Condition_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_condition_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCondition_occurrence_uniqueness_filters) {
             listener.enterCondition_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCondition_occurrence_uniqueness_filters) {
             listener.exitCondition_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_uniqueness_filters) {
            return visitor.visitCondition_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public _date_attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CONDITION_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_condition_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCondition_occurrence_uniqueness_filter) {
             listener.enterCondition_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCondition_occurrence_uniqueness_filter) {
             listener.exitCondition_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_uniqueness_filter) {
            return visitor.visitCondition_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public condition_occurrence_related_entity_filter(): Condition_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Condition_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_condition_occurrence_related_entity_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCondition_occurrence_related_entity_filters) {
             listener.enterCondition_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCondition_occurrence_related_entity_filters) {
             listener.exitCondition_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_related_entity_filters) {
            return visitor.visitCondition_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_condition_occurrence_related_entity_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCondition_occurrence_related_entity_filter) {
             listener.enterCondition_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCondition_occurrence_related_entity_filter) {
             listener.exitCondition_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_related_entity_filter) {
            return visitor.visitCondition_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CONDITION_OCCURRENCE, 0)!;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_group_filterContext);
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_condition_occurrence_sub_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCondition_occurrence_sub_filter) {
             listener.enterCondition_occurrence_sub_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCondition_occurrence_sub_filter) {
             listener.exitCondition_occurrence_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_sub_filter) {
            return visitor.visitCondition_occurrence_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.CONDITION_OCCURRENCE, 0);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_condition_occurrence_error_sub_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCondition_occurrence_error_sub_filter) {
             listener.enterCondition_occurrence_error_sub_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCondition_occurrence_error_sub_filter) {
             listener.exitCondition_occurrence_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_error_sub_filter) {
            return visitor.visitCondition_occurrence_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_condition_occurrence_error_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterCondition_occurrence_error_filter) {
             listener.enterCondition_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitCondition_occurrence_error_filter) {
             listener.exitCondition_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_error_filter) {
            return visitor.visitCondition_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public drug_exposure_event_filter(): Drug_exposure_event_filterContext[];
    public drug_exposure_event_filter(i: number): Drug_exposure_event_filterContext | null;
    public drug_exposure_event_filter(i?: number): Drug_exposure_event_filterContext[] | Drug_exposure_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Drug_exposure_event_filterContext);
        }

        return this.getRuleContext(i, Drug_exposure_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SubjectsVariables.COMMA);
    	} else {
    		return this.getToken(SubjectsVariables.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_drug_exposure_event_criteria;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDrug_exposure_event_criteria) {
             listener.enterDrug_exposure_event_criteria(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDrug_exposure_event_criteria) {
             listener.exitDrug_exposure_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_criteria) {
            return visitor.visitDrug_exposure_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public drug_exposure_concept_filters(): Drug_exposure_concept_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_filtersContext);
    }
    public drug_exposure_numeric_filters(): Drug_exposure_numeric_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_numeric_filtersContext);
    }
    public drug_exposure_uniqueness_filters(): Drug_exposure_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_uniqueness_filtersContext);
    }
    public drug_exposure_related_entity_filters(): Drug_exposure_related_entity_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_related_entity_filtersContext);
    }
    public drug_exposure_error_filter(): Drug_exposure_error_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_error_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_drug_exposure_event_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDrug_exposure_event_filter) {
             listener.enterDrug_exposure_event_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDrug_exposure_event_filter) {
             listener.exitDrug_exposure_event_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_filter) {
            return visitor.visitDrug_exposure_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public drug_exposure_concept_group_filter(): Drug_exposure_concept_group_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_group_filterContext);
    }
    public drug_exposure_concept_filter(): Drug_exposure_concept_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_drug_exposure_concept_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDrug_exposure_concept_filters) {
             listener.enterDrug_exposure_concept_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDrug_exposure_concept_filters) {
             listener.exitDrug_exposure_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_filters) {
            return visitor.visitDrug_exposure_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_drug_exposure_concept_group_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDrug_exposure_concept_group_filter) {
             listener.enterDrug_exposure_concept_group_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDrug_exposure_concept_group_filter) {
             listener.exitDrug_exposure_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_group_filter) {
            return visitor.visitDrug_exposure_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_drug_exposure_concept_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDrug_exposure_concept_filter) {
             listener.enterDrug_exposure_concept_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDrug_exposure_concept_filter) {
             listener.exitDrug_exposure_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_filter) {
            return visitor.visitDrug_exposure_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public drug_exposure_float_filter(): Drug_exposure_float_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_float_filterContext);
    }
    public drug_exposure_int_filter(): Drug_exposure_int_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_int_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_drug_exposure_numeric_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDrug_exposure_numeric_filters) {
             listener.enterDrug_exposure_numeric_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDrug_exposure_numeric_filters) {
             listener.exitDrug_exposure_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_numeric_filters) {
            return visitor.visitDrug_exposure_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUANTITY(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.QUANTITY, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_drug_exposure_float_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDrug_exposure_float_filter) {
             listener.enterDrug_exposure_float_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDrug_exposure_float_filter) {
             listener.exitDrug_exposure_float_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_float_filter) {
            return visitor.visitDrug_exposure_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_int_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_INT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.DRUG_EXPOSURE_INT_ATTRIBUTE, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_drug_exposure_int_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDrug_exposure_int_filter) {
             listener.enterDrug_exposure_int_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDrug_exposure_int_filter) {
             listener.exitDrug_exposure_int_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_int_filter) {
            return visitor.visitDrug_exposure_int_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public drug_exposure_uniqueness_filter(): Drug_exposure_uniqueness_filterContext {
        return this.getRuleContext(0, Drug_exposure_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_drug_exposure_uniqueness_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDrug_exposure_uniqueness_filters) {
             listener.enterDrug_exposure_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDrug_exposure_uniqueness_filters) {
             listener.exitDrug_exposure_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_uniqueness_filters) {
            return visitor.visitDrug_exposure_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.DRUG_EXPOSURE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_drug_exposure_uniqueness_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDrug_exposure_uniqueness_filter) {
             listener.enterDrug_exposure_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDrug_exposure_uniqueness_filter) {
             listener.exitDrug_exposure_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_uniqueness_filter) {
            return visitor.visitDrug_exposure_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public drug_exposure_related_entity_filter(): Drug_exposure_related_entity_filterContext {
        return this.getRuleContext(0, Drug_exposure_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_drug_exposure_related_entity_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDrug_exposure_related_entity_filters) {
             listener.enterDrug_exposure_related_entity_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDrug_exposure_related_entity_filters) {
             listener.exitDrug_exposure_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_related_entity_filters) {
            return visitor.visitDrug_exposure_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_drug_exposure_related_entity_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDrug_exposure_related_entity_filter) {
             listener.enterDrug_exposure_related_entity_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDrug_exposure_related_entity_filter) {
             listener.exitDrug_exposure_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_related_entity_filter) {
            return visitor.visitDrug_exposure_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NF, 0);
    }
    public QUANTITY(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.QUANTITY, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public DRUG_EXPOSURE_INT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.DRUG_EXPOSURE_INT_ATTRIBUTE, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_drug_exposure_error_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterDrug_exposure_error_filter) {
             listener.enterDrug_exposure_error_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitDrug_exposure_error_filter) {
             listener.exitDrug_exposure_error_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_error_filter) {
            return visitor.visitDrug_exposure_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public measurement_event_filter(): Measurement_event_filterContext[];
    public measurement_event_filter(i: number): Measurement_event_filterContext | null;
    public measurement_event_filter(i?: number): Measurement_event_filterContext[] | Measurement_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Measurement_event_filterContext);
        }

        return this.getRuleContext(i, Measurement_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SubjectsVariables.COMMA);
    	} else {
    		return this.getToken(SubjectsVariables.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_measurement_event_criteria;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMeasurement_event_criteria) {
             listener.enterMeasurement_event_criteria(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMeasurement_event_criteria) {
             listener.exitMeasurement_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_criteria) {
            return visitor.visitMeasurement_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public measurement_concept_filters(): Measurement_concept_filtersContext | null {
        return this.getRuleContext(0, Measurement_concept_filtersContext);
    }
    public measurement_numeric_filters(): Measurement_numeric_filtersContext | null {
        return this.getRuleContext(0, Measurement_numeric_filtersContext);
    }
    public measurement_uniqueness_filters(): Measurement_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Measurement_uniqueness_filtersContext);
    }
    public measurement_related_entity_filters(): Measurement_related_entity_filtersContext | null {
        return this.getRuleContext(0, Measurement_related_entity_filtersContext);
    }
    public measurement_error_filter(): Measurement_error_filterContext | null {
        return this.getRuleContext(0, Measurement_error_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_measurement_event_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMeasurement_event_filter) {
             listener.enterMeasurement_event_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMeasurement_event_filter) {
             listener.exitMeasurement_event_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_filter) {
            return visitor.visitMeasurement_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public measurement_concept_group_filter(): Measurement_concept_group_filterContext | null {
        return this.getRuleContext(0, Measurement_concept_group_filterContext);
    }
    public measurement_concept_filter(): Measurement_concept_filterContext | null {
        return this.getRuleContext(0, Measurement_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_measurement_concept_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMeasurement_concept_filters) {
             listener.enterMeasurement_concept_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMeasurement_concept_filters) {
             listener.exitMeasurement_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_filters) {
            return visitor.visitMeasurement_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_group_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_measurement_concept_group_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMeasurement_concept_group_filter) {
             listener.enterMeasurement_concept_group_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMeasurement_concept_group_filter) {
             listener.exitMeasurement_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_group_filter) {
            return visitor.visitMeasurement_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CONCEPT, 0)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_measurement_concept_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMeasurement_concept_filter) {
             listener.enterMeasurement_concept_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMeasurement_concept_filter) {
             listener.exitMeasurement_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_filter) {
            return visitor.visitMeasurement_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public measurement_float_filter(): Measurement_float_filterContext {
        return this.getRuleContext(0, Measurement_float_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_measurement_numeric_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMeasurement_numeric_filters) {
             listener.enterMeasurement_numeric_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMeasurement_numeric_filters) {
             listener.exitMeasurement_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_numeric_filters) {
            return visitor.visitMeasurement_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public MEASUREMENT_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MEASUREMENT_FLOAT_ATTRIBUTE, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_measurement_float_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMeasurement_float_filter) {
             listener.enterMeasurement_float_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMeasurement_float_filter) {
             listener.exitMeasurement_float_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_float_filter) {
            return visitor.visitMeasurement_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public measurement_uniqueness_filter(): Measurement_uniqueness_filterContext {
        return this.getRuleContext(0, Measurement_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_measurement_uniqueness_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMeasurement_uniqueness_filters) {
             listener.enterMeasurement_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMeasurement_uniqueness_filters) {
             listener.exitMeasurement_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_uniqueness_filters) {
            return visitor.visitMeasurement_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MEASUREMENT_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.MEASUREMENT_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_measurement_uniqueness_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMeasurement_uniqueness_filter) {
             listener.enterMeasurement_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMeasurement_uniqueness_filter) {
             listener.exitMeasurement_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_uniqueness_filter) {
            return visitor.visitMeasurement_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public measurement_related_entity_filter(): Measurement_related_entity_filterContext {
        return this.getRuleContext(0, Measurement_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_measurement_related_entity_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMeasurement_related_entity_filters) {
             listener.enterMeasurement_related_entity_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMeasurement_related_entity_filters) {
             listener.exitMeasurement_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_related_entity_filters) {
            return visitor.visitMeasurement_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_measurement_related_entity_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMeasurement_related_entity_filter) {
             listener.enterMeasurement_related_entity_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMeasurement_related_entity_filter) {
             listener.exitMeasurement_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_related_entity_filter) {
            return visitor.visitMeasurement_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NF, 0);
    }
    public MEASUREMENT_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MEASUREMENT_FLOAT_ATTRIBUTE, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_measurement_error_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterMeasurement_error_filter) {
             listener.enterMeasurement_error_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitMeasurement_error_filter) {
             listener.exitMeasurement_error_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_error_filter) {
            return visitor.visitMeasurement_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public observation_event_filter(): Observation_event_filterContext[];
    public observation_event_filter(i: number): Observation_event_filterContext | null;
    public observation_event_filter(i?: number): Observation_event_filterContext[] | Observation_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Observation_event_filterContext);
        }

        return this.getRuleContext(i, Observation_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SubjectsVariables.COMMA);
    	} else {
    		return this.getToken(SubjectsVariables.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_observation_event_criteria;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterObservation_event_criteria) {
             listener.enterObservation_event_criteria(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitObservation_event_criteria) {
             listener.exitObservation_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_criteria) {
            return visitor.visitObservation_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public observation_concept_filters(): Observation_concept_filtersContext | null {
        return this.getRuleContext(0, Observation_concept_filtersContext);
    }
    public observation_numeric_filters(): Observation_numeric_filtersContext | null {
        return this.getRuleContext(0, Observation_numeric_filtersContext);
    }
    public observation_uniqueness_filters(): Observation_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Observation_uniqueness_filtersContext);
    }
    public observation_related_entity_filters(): Observation_related_entity_filtersContext | null {
        return this.getRuleContext(0, Observation_related_entity_filtersContext);
    }
    public observation_error_filter(): Observation_error_filterContext | null {
        return this.getRuleContext(0, Observation_error_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_observation_event_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterObservation_event_filter) {
             listener.enterObservation_event_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitObservation_event_filter) {
             listener.exitObservation_event_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_filter) {
            return visitor.visitObservation_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public observation_concept_group_filter(): Observation_concept_group_filterContext | null {
        return this.getRuleContext(0, Observation_concept_group_filterContext);
    }
    public observation_concept_filter(): Observation_concept_filterContext | null {
        return this.getRuleContext(0, Observation_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_observation_concept_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterObservation_concept_filters) {
             listener.enterObservation_concept_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitObservation_concept_filters) {
             listener.exitObservation_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_filters) {
            return visitor.visitObservation_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_group_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_observation_concept_group_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterObservation_concept_group_filter) {
             listener.enterObservation_concept_group_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitObservation_concept_group_filter) {
             listener.exitObservation_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_group_filter) {
            return visitor.visitObservation_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CONCEPT, 0)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_observation_concept_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterObservation_concept_filter) {
             listener.enterObservation_concept_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitObservation_concept_filter) {
             listener.exitObservation_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_filter) {
            return visitor.visitObservation_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public observation_float_filter(): Observation_float_filterContext | null {
        return this.getRuleContext(0, Observation_float_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_observation_numeric_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterObservation_numeric_filters) {
             listener.enterObservation_numeric_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitObservation_numeric_filters) {
             listener.exitObservation_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitObservation_numeric_filters) {
            return visitor.visitObservation_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_observation_float_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterObservation_float_filter) {
             listener.enterObservation_float_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitObservation_float_filter) {
             listener.exitObservation_float_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitObservation_float_filter) {
            return visitor.visitObservation_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public observation_uniqueness_filter(): Observation_uniqueness_filterContext {
        return this.getRuleContext(0, Observation_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_observation_uniqueness_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterObservation_uniqueness_filters) {
             listener.enterObservation_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitObservation_uniqueness_filters) {
             listener.exitObservation_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitObservation_uniqueness_filters) {
            return visitor.visitObservation_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OBSERVATION_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OBSERVATION_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_observation_uniqueness_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterObservation_uniqueness_filter) {
             listener.enterObservation_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitObservation_uniqueness_filter) {
             listener.exitObservation_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitObservation_uniqueness_filter) {
            return visitor.visitObservation_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public observation_related_entity_filter(): Observation_related_entity_filterContext {
        return this.getRuleContext(0, Observation_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_observation_related_entity_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterObservation_related_entity_filters) {
             listener.enterObservation_related_entity_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitObservation_related_entity_filters) {
             listener.exitObservation_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitObservation_related_entity_filters) {
            return visitor.visitObservation_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_observation_related_entity_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterObservation_related_entity_filter) {
             listener.enterObservation_related_entity_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitObservation_related_entity_filter) {
             listener.exitObservation_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitObservation_related_entity_filter) {
            return visitor.visitObservation_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NF, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_observation_error_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterObservation_error_filter) {
             listener.enterObservation_error_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitObservation_error_filter) {
             listener.exitObservation_error_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitObservation_error_filter) {
            return visitor.visitObservation_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public procedure_occurrence_event_filter(): Procedure_occurrence_event_filterContext[];
    public procedure_occurrence_event_filter(i: number): Procedure_occurrence_event_filterContext | null;
    public procedure_occurrence_event_filter(i?: number): Procedure_occurrence_event_filterContext[] | Procedure_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Procedure_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Procedure_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SubjectsVariables.COMMA);
    	} else {
    		return this.getToken(SubjectsVariables.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_procedure_occurrence_event_criteria;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProcedure_occurrence_event_criteria) {
             listener.enterProcedure_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProcedure_occurrence_event_criteria) {
             listener.exitProcedure_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_criteria) {
            return visitor.visitProcedure_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public procedure_occurrence_concept_filters(): Procedure_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_filtersContext);
    }
    public procedure_occurrence_numeric_filters(): Procedure_occurrence_numeric_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_numeric_filtersContext);
    }
    public procedure_occurrence_uniqueness_filters(): Procedure_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_uniqueness_filtersContext);
    }
    public procedure_occurrence_related_entity_filters(): Procedure_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_related_entity_filtersContext);
    }
    public procedure_occurrence_error_filter(): Procedure_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_procedure_occurrence_event_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProcedure_occurrence_event_filter) {
             listener.enterProcedure_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProcedure_occurrence_event_filter) {
             listener.exitProcedure_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_filter) {
            return visitor.visitProcedure_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public procedure_occurrence_concept_group_filter(): Procedure_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_group_filterContext);
    }
    public procedure_occurrence_concept_filter(): Procedure_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_procedure_occurrence_concept_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProcedure_occurrence_concept_filters) {
             listener.enterProcedure_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProcedure_occurrence_concept_filters) {
             listener.exitProcedure_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_filters) {
            return visitor.visitProcedure_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_procedure_occurrence_concept_group_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProcedure_occurrence_concept_group_filter) {
             listener.enterProcedure_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProcedure_occurrence_concept_group_filter) {
             listener.exitProcedure_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_group_filter) {
            return visitor.visitProcedure_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_procedure_occurrence_concept_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProcedure_occurrence_concept_filter) {
             listener.enterProcedure_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProcedure_occurrence_concept_filter) {
             listener.exitProcedure_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_filter) {
            return visitor.visitProcedure_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_int_filter(): Procedure_occurrence_int_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_int_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_procedure_occurrence_numeric_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProcedure_occurrence_numeric_filters) {
             listener.enterProcedure_occurrence_numeric_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProcedure_occurrence_numeric_filters) {
             listener.exitProcedure_occurrence_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_numeric_filters) {
            return visitor.visitProcedure_occurrence_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_int_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUANTITY(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.QUANTITY, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_procedure_occurrence_int_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProcedure_occurrence_int_filter) {
             listener.enterProcedure_occurrence_int_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProcedure_occurrence_int_filter) {
             listener.exitProcedure_occurrence_int_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_int_filter) {
            return visitor.visitProcedure_occurrence_int_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_uniqueness_filter(): Procedure_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_procedure_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProcedure_occurrence_uniqueness_filters) {
             listener.enterProcedure_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProcedure_occurrence_uniqueness_filters) {
             listener.exitProcedure_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_uniqueness_filters) {
            return visitor.visitProcedure_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_procedure_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProcedure_occurrence_uniqueness_filter) {
             listener.enterProcedure_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProcedure_occurrence_uniqueness_filter) {
             listener.exitProcedure_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_uniqueness_filter) {
            return visitor.visitProcedure_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_related_entity_filter(): Procedure_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_procedure_occurrence_related_entity_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProcedure_occurrence_related_entity_filters) {
             listener.enterProcedure_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProcedure_occurrence_related_entity_filters) {
             listener.exitProcedure_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_related_entity_filters) {
            return visitor.visitProcedure_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_procedure_occurrence_related_entity_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProcedure_occurrence_related_entity_filter) {
             listener.enterProcedure_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProcedure_occurrence_related_entity_filter) {
             listener.exitProcedure_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_related_entity_filter) {
            return visitor.visitProcedure_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NF, 0);
    }
    public QUANTITY(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.QUANTITY, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_procedure_occurrence_error_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProcedure_occurrence_error_filter) {
             listener.enterProcedure_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProcedure_occurrence_error_filter) {
             listener.exitProcedure_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_error_filter) {
            return visitor.visitProcedure_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext | null {
        return this.getRuleContext(0, Provider_concept_group_filterContext);
    }
    public provider_concept_filter(): Provider_concept_filterContext | null {
        return this.getRuleContext(0, Provider_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_provider_concept_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProvider_concept_filters) {
             listener.enterProvider_concept_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProvider_concept_filters) {
             listener.exitProvider_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_filters) {
            return visitor.visitProvider_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.PROVIDER_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_provider_concept_group_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProvider_concept_group_filter) {
             listener.enterProvider_concept_group_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProvider_concept_group_filter) {
             listener.exitProvider_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_group_filter) {
            return visitor.visitProvider_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.PROVIDER_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_provider_concept_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProvider_concept_filter) {
             listener.enterProvider_concept_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProvider_concept_filter) {
             listener.exitProvider_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_filter) {
            return visitor.visitProvider_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.PROVIDER, 0)!;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext | null {
        return this.getRuleContext(0, Provider_concept_group_filterContext);
    }
    public provider_concept_filter(): Provider_concept_filterContext | null {
        return this.getRuleContext(0, Provider_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_provider_sub_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProvider_sub_filter) {
             listener.enterProvider_sub_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProvider_sub_filter) {
             listener.exitProvider_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProvider_sub_filter) {
            return visitor.visitProvider_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.PROVIDER, 0);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.PROVIDER_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_provider_error_sub_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterProvider_error_sub_filter) {
             listener.enterProvider_error_sub_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitProvider_error_sub_filter) {
             listener.exitProvider_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitProvider_error_sub_filter) {
            return visitor.visitProvider_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public visit_occurrence_event_filter(): Visit_occurrence_event_filterContext[];
    public visit_occurrence_event_filter(i: number): Visit_occurrence_event_filterContext | null;
    public visit_occurrence_event_filter(i?: number): Visit_occurrence_event_filterContext[] | Visit_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Visit_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Visit_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SubjectsVariables.COMMA);
    	} else {
    		return this.getToken(SubjectsVariables.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_visit_occurrence_event_criteria;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterVisit_occurrence_event_criteria) {
             listener.enterVisit_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitVisit_occurrence_event_criteria) {
             listener.exitVisit_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_criteria) {
            return visitor.visitVisit_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public visit_occurrence_concept_filters(): Visit_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filtersContext);
    }
    public visit_occurrence_uniqueness_filters(): Visit_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_uniqueness_filtersContext);
    }
    public visit_occurrence_related_entity_filters(): Visit_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_related_entity_filtersContext);
    }
    public visit_occurrence_error_filter(): Visit_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_visit_occurrence_event_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterVisit_occurrence_event_filter) {
             listener.enterVisit_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitVisit_occurrence_event_filter) {
             listener.exitVisit_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_filter) {
            return visitor.visitVisit_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_group_filterContext);
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_visit_occurrence_concept_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterVisit_occurrence_concept_filters) {
             listener.enterVisit_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitVisit_occurrence_concept_filters) {
             listener.exitVisit_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_filters) {
            return visitor.visitVisit_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_visit_occurrence_concept_group_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterVisit_occurrence_concept_group_filter) {
             listener.enterVisit_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitVisit_occurrence_concept_group_filter) {
             listener.exitVisit_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_group_filter) {
            return visitor.visitVisit_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_visit_occurrence_concept_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterVisit_occurrence_concept_filter) {
             listener.enterVisit_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitVisit_occurrence_concept_filter) {
             listener.exitVisit_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_filter) {
            return visitor.visitVisit_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public visit_occurrence_uniqueness_filter(): Visit_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Visit_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_visit_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterVisit_occurrence_uniqueness_filters) {
             listener.enterVisit_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitVisit_occurrence_uniqueness_filters) {
             listener.exitVisit_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_uniqueness_filters) {
            return visitor.visitVisit_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.VISIT_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_visit_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterVisit_occurrence_uniqueness_filter) {
             listener.enterVisit_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitVisit_occurrence_uniqueness_filter) {
             listener.exitVisit_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_uniqueness_filter) {
            return visitor.visitVisit_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public visit_occurrence_related_entity_filter(): Visit_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Visit_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_visit_occurrence_related_entity_filters;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterVisit_occurrence_related_entity_filters) {
             listener.enterVisit_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitVisit_occurrence_related_entity_filters) {
             listener.exitVisit_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_related_entity_filters) {
            return visitor.visitVisit_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public condition_occurrence_sub_filter(): Condition_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_visit_occurrence_related_entity_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterVisit_occurrence_related_entity_filter) {
             listener.enterVisit_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitVisit_occurrence_related_entity_filter) {
             listener.exitVisit_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_related_entity_filter) {
            return visitor.visitVisit_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.VISIT_OCCURRENCE, 0)!;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_group_filterContext);
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_visit_occurrence_sub_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterVisit_occurrence_sub_filter) {
             listener.enterVisit_occurrence_sub_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitVisit_occurrence_sub_filter) {
             listener.exitVisit_occurrence_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_sub_filter) {
            return visitor.visitVisit_occurrence_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.VISIT_OCCURRENCE, 0);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_visit_occurrence_error_sub_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterVisit_occurrence_error_sub_filter) {
             listener.enterVisit_occurrence_error_sub_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitVisit_occurrence_error_sub_filter) {
             listener.exitVisit_occurrence_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_error_sub_filter) {
            return visitor.visitVisit_occurrence_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.CLOSE_PAREN, 0)!;
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public condition_occurrence_error_sub_filter(): Condition_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_visit_occurrence_error_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterVisit_occurrence_error_filter) {
             listener.enterVisit_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitVisit_occurrence_error_filter) {
             listener.exitVisit_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_error_filter) {
            return visitor.visitVisit_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Comparison_opContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.EQ, 0);
    }
    public LT(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.LT, 0);
    }
    public GT(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.GT, 0);
    }
    public LTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.LTE, 0);
    }
    public GTE(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.GTE, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_comparison_op;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterComparison_op) {
             listener.enterComparison_op(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitComparison_op) {
             listener.exitComparison_op(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitComparison_op) {
            return visitor.visitComparison_op(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.MINIMUM_BETWEEN, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_simple_uniqueness_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterSimple_uniqueness_filter) {
             listener.enterSimple_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitSimple_uniqueness_filter) {
             listener.exitSimple_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitSimple_uniqueness_filter) {
            return visitor.visitSimple_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_uniqueness_filter_windowContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public fixed_window_uniqueness_filter(): Fixed_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Fixed_window_uniqueness_filterContext);
    }
    public rolling_window_uniqueness_filter(): Rolling_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Rolling_window_uniqueness_filterContext);
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_simple_uniqueness_filter_window;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterSimple_uniqueness_filter_window) {
             listener.enterSimple_uniqueness_filter_window(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitSimple_uniqueness_filter_window) {
             listener.exitSimple_uniqueness_filter_window(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitSimple_uniqueness_filter_window) {
            return visitor.visitSimple_uniqueness_filter_window(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Fixed_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public FIXED_WINDOW(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.FIXED_WINDOW, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_fixed_window_uniqueness_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterFixed_window_uniqueness_filter) {
             listener.enterFixed_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitFixed_window_uniqueness_filter) {
             listener.exitFixed_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitFixed_window_uniqueness_filter) {
            return visitor.visitFixed_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Rolling_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.ROLLING_WINDOW, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_rolling_window_uniqueness_filter;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterRolling_window_uniqueness_filter) {
             listener.enterRolling_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitRolling_window_uniqueness_filter) {
             listener.exitRolling_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitRolling_window_uniqueness_filter) {
            return visitor.visitRolling_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_event_floatContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public PERIOD(): antlr.TerminalNode | null {
        return this.getToken(SubjectsVariables.PERIOD, 0);
    }
    public INT(): antlr.TerminalNode[];
    public INT(i: number): antlr.TerminalNode | null;
    public INT(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SubjectsVariables.INT);
    	} else {
    		return this.getToken(SubjectsVariables.INT, i);
    	}
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_simple_event_float;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterSimple_event_float) {
             listener.enterSimple_event_float(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitSimple_event_float) {
             listener.exitSimple_event_float(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitSimple_event_float) {
            return visitor.visitSimple_event_float(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_event_intContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(SubjectsVariables.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_simple_event_int;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterSimple_event_int) {
             listener.enterSimple_event_int(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitSimple_event_int) {
             listener.exitSimple_event_int(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitSimple_event_int) {
            return visitor.visitSimple_event_int(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Concept_group_selectionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT_GROUP(): antlr.TerminalNode[];
    public CONCEPT_GROUP(i: number): antlr.TerminalNode | null;
    public CONCEPT_GROUP(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SubjectsVariables.CONCEPT_GROUP);
    	} else {
    		return this.getToken(SubjectsVariables.CONCEPT_GROUP, i);
    	}
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(SubjectsVariables.COMMA);
    	} else {
    		return this.getToken(SubjectsVariables.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return SubjectsVariables.RULE_concept_group_selection;
    }
    public override enterRule(listener: SubjectsVariablesListener): void {
        if(listener.enterConcept_group_selection) {
             listener.enterConcept_group_selection(this);
        }
    }
    public override exitRule(listener: SubjectsVariablesListener): void {
        if(listener.exitConcept_group_selection) {
             listener.exitConcept_group_selection(this);
        }
    }
    public override accept<Result>(visitor: SubjectsVariablesVisitor<Result>): Result | null {
        if (visitor.visitConcept_group_selection) {
            return visitor.visitConcept_group_selection(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
